<template>
    <div class="four">
        <Loading :value="loading"></Loading>

        <!-- RACOURCIS -->
        <v-card>
            <v-card-title>
                <v-breadcrumbs icons divider="chevron_right">
                    <v-breadcrumbs-item icons router :to='item.path' v-for="item in racourcis" :key="item.text" :disabled="item.disabled">
                        {{ item.text }}
                    </v-breadcrumbs-item>
                </v-breadcrumbs>
            </v-card-title>
        </v-card>
        <br>
        <!-- DASHBOARB FACTURE -->
        <v-container fluid grid-list-md >
            <boardFacture   :show="showFactureStat"   ></boardFacture>
        </v-container>


        <!-- MODAL AJOUT DE COMMANDE -->
        <v-dialog v-model="dialogComm"  scrollable persistent fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">

                    <v-toolbar-title>
                        <span v-if="dialogEdit != true ">Ajouter une nouvelle commande</span>
                        <span v-if="dialogEdit== true && assignTotier == false" >Modification de la commande {{commCourant.ref}} {{commCourant.libelle}} </span>
                        <span v-if="assignTotier" >Assignation de la commande {{commCourant.ref}} {{commCourant.libelle}} à un autre fournisseur </span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialogComm = false">
                        <v-icon>close</v-icon>
                    </v-btn>

                </v-toolbar>

                <v-card-text>
                    <p align="center">
                        <v-chip text-color="white" label color="primary" style="width:100%">
                            DETAILS ASSOCIE A LA COMMANDE <v-icon right>shopping_cart</v-icon>
                        </v-chip>
                    </p>


                    <v-form v-model="formComm" ref="formComm" lazy-validation id="formComm">
                        <v-container fluid grid-list-md>
                            <v-layout row>

                                <v-flex md4 v-if="assignTotier">
                                    <div class="block">
                                        <span class="demonstration">Fournisseur *</span>
                                        <el-select
                                            v-model="selectFourn"
                                            filterable
                                            placeholder="Fournisseur"
                                            style="width:100%"
                                            >
                                            <el-option
                                                v-for="item in listFour"
                                                :key="item.id"
                                                :label="item.libelle"
                                                :value="item.id"
                                            ></el-option>
                                            </el-select>                                       
                                    </div>
                                </v-flex>

                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Intitulé de la commande *</span>
                                        <el-input name="libelle" placeholder="Intitulé de la commande" v-model="libelle" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Date de livraison *</span>
                                        <el-date-picker v-model="dateLivr" name="dateLivr" id="dateLivr" value-format="dd-MM-yyyy" type="date" placeholder="Date de livraison" style="width: 100%"></el-date-picker>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Associer des utilisateurs </span>
                                        <el-select v-model="selectUsers"  filterable multiple placeholder="Associer des utilisateurs" style="width:100%">
                                            <el-option v-for="item in users" :key="item.id" :label="item.nom" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout row>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Type de commande *</span>
                                        <el-select v-model="selectTypeCom" placeholder="Type de commande" style="width:100%">
                                            <el-option v-for="item in typeComm" :key="item.value" :label="item.text" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>

                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Avance démarrage(%)</span>
                                        <el-input-number :max="100" v-model="avance" :min="0" size="small"  style="width:100%" controls-position="right" />
                                    </div>
                                </v-flex>

                                <!-- <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Modalité de paiement</span>
                                        <el-select clearable v-model="modePaie" placeholder="paiement" style="width:100%">
                                            <el-option v-for="item in modalitePaie" :key="item.value" :label="item.text" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex> -->
                                  <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Conditions de paiement</span>
                                        <el-select clearable v-model="modePaie" placeholder="paiement" style="width:100%">
                                            <el-option v-for="item in modalitePaie" :key="item.value" :label="item.text" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <p align="center">
                                <v-chip v-if="selectTypeCom == 1" text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    COMMANDE CONCERNANT UN CHANTIER <v-icon right>last_page</v-icon>
                                </v-chip>
                            </p>

                            <!-- PROJET -->
                            <v-layout v-if="selectTypeCom == 1" row>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Projet concerné *</span>
                                        <el-select filterable v-on:change="loadChantier()" v-model="projetS" placeholder="Type de Projet" style="width:100%" :disabled= dialogEdit>
                                            <el-option v-for="item in listProjet" :key="item.id" :label="item.libelle" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Chantier concerné *</span>
                                        <el-select filterable v-on:change="loadTravaux()" v-model="chantierS" placeholder="Chantier concerné" style="width:100%" :disabled= dialogEdit>
                                            <el-option v-for="item in listChantier" :key="item.id" :label="item.libelle" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Travaux *</span>
                                        <el-select filterable v-model="travauxS" placeholder="Travaux" style="width:100%" :disabled= dialogEdit>
                                            <el-option v-for="item in listTravaux" :key="item.id" :label="item.libelle" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <p align="center">
                                <v-chip v-if="selectTypeCom == 2" text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    COMMANDE CONCERNANT UNE DEMANDE DE MAINTENANCE <v-icon right>last_page</v-icon>
                                </v-chip>
                            </p>

                            <!-- MAINTENANCE -->
                            <v-layout v-if="selectTypeCom == 2" row>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Demande de maintenance concerné *</span>
                                        <el-select v-model="selectDemande" placeholder="Demande de maintenance concerné" style="width:100%">
                                            <el-option v-for="item in listDemande" :key="item.id" :label="item.libelle" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <p align="center">
                                <v-chip text-color="white" label color="primary" style="width:100%">
                                    AJOUTER LES LIGNES DE VOTRE COMMANDE <v-icon right>shopping_cart</v-icon>
                                </v-chip>
                            </p>

                             <v-layout >
                                <v-flex md3>
                                    <span class="demonstration">Type ressource *</span>
                                    <el-select name="typeProduit" id="typeProduit" filterable v-model="prodSelct" v-on:change="loadTypeProduit(prodSelct)" placeholder="Type ressource" style="width:100%">
                                        <el-option v-for="item in listTypeRessource" :key="item.id" :label="item.libelle" :value="item.libelle">
                                        </el-option>
                                    </el-select>
                                </v-flex>
                            </v-layout>

                            <v-layout row v-for="(optionComd, index) in optionCommande" :key="optionComd.key">
                                <v-flex md3>
                                    <div class="block">
                                        <span class="demonstration">Ressource *</span>
                                        <el-select filterable @change="totauxCommande(index)" v-model="optionComd.produit" :prop="'optionCommande.'+ index+'.produit'" placeholder="Produit" style="width:100%">
                                            <el-option v-for="item in listProd" :key="item.id" :label="item.value" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Prix unitaire *</span>
                                        <el-input type="number"  @change="totauxCommande(index)"  :min="5" value="prix" :prop="'optionCommande.' + index+ '.prix'" placeholder="Prix unitaire" v-model="optionComd.prix" style="width:100%"></el-input>
                                    </div>
                                </v-flex>                                
                                <v-flex md1>
                                    <div class="block">
                                        <span class="demonstration">Unité</span>
                                        <el-input class="inline-input" v-model="optionComd.unite" :prop="'optionCommande.' + index+ '.unite'" required  placeholder="Unité" :trigger-on-focus="true" style="width: 100%" ></el-input>
                                    </div>
                                </v-flex>

                                <v-flex md1>
                                    <div class="block">
                                        <span class="demonstration">Quantité *</span>
                                        <el-input type="number" @change="totauxCommande(index)" :min="1" value="qte" :prop="'optionCommande.' + index+ '.qte'" placeholder="Quantité" v-model="optionComd.qte" style="width:100%"></el-input>
                                    </div>
                                </v-flex>

                                <v-flex md1>
                                    <div class="block">
                                        <span class="demonstration">Remise %</span>
                                        <el-input type="number" @change="totauxCommande(index)" :min="1" value="remise" :prop="'optionCommande.' + index+ '.remise'" placeholder="Remise" v-model="optionComd.remise" style="width:100%"></el-input>
                                    </div>
                                </v-flex>

                                <v-flex md1>
                                    <div class="block">
                                        <span class="demonstration">Tva %</span>
                                        <el-input type="number" @change="totauxCommande(index)" :min="0" value="qte" :prop="'optionCommande.' + index+ '.tva'" placeholder="Tva" v-model="optionComd.tva" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">TOTAL HT </span>
                                        <el-input type="number"  :min="0" value="total" :prop="'optionCommande.' + index+ '.total'" placeholder="TOTAL" v-model="optionComd.total" style="width:100%" :readonly="true"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md1>
                                    <v-tooltip top>
                                        <v-btn slot="activator" @click.prevent="removeOptionComm(optionComd)" fab dark small color="red">
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                        Supprimer
                                    </v-tooltip>
                                </v-flex>
                            </v-layout>
                            <br>

                            <v-layout row>
                                <!-- <v-flex md10>
                                    <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                        TOTAL HT : {{totalComHT}} FCFA
                                    </v-chip>
                                </v-flex> -->
                                <v-flex md2 >
                                    <v-btn icons color="primary" @click="addOptionComm()" fab small dark> <v-icon>add</v-icon></v-btn>
                                </v-flex>
                            </v-layout>
                            <!--v-layout row>
                                <v-flex md10>
                                    <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                        TOTAL TVA : {{totalComTVA}} FCFA
                                    </v-chip>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex md10>
                                    <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                        TOTAL TTC : {{totComLigneTTCFormat}} FCFA
                                    </v-chip>
                                </v-flex>
                            </v-layout> -->
                        </v-container>

                        <v-btn @click="dialogComm = false" color="orange" dark>Annuler <v-icon right>close</v-icon></v-btn>
                        <!-- <v-btn v-if="dialogEdit != true" icons color="blue" @click="submitComm()" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn> -->
                        <v-btn v-if="dialogEdit != true"  icons color="blue" @click="displayMontant()" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                        <v-btn v-if="dialogEdit == true"  color="blue" dark @click="displayMontant()" >Enregistrer <v-icon right>save</v-icon></v-btn>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL AJOUT DE FACTURE -->
        <v-dialog v-model="dialogFacture" max-width="80%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span v-if="dialogEdit != true ">Créer la facture d'une commande</span>
                        <span v-if="dialogEdit" >Modification de la facture {{factureCourant.ref}} {{factureCourant.libelle}} </span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogFacture = false; dialogShowFacture = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text>
                    <p align="center">
                        <v-chip text-color="white" label color="primary" style="width:100%">
                            DETAILS ASSOCIE A LA NOUVELLE FACTURE  <v-icon right>note_add</v-icon>
                        </v-chip>
                    </p>

                    <v-form v-model="valid" ref="form" lazy-validation id="formFacture">
                        <v-container fluid grid-list-md>
                            <v-layout row>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Référence commande</span>
                                        <el-input v-if="dialogEdit" placeholder="Référence commande" v-model="factureCourant.refCom" style="width:100%" :disabled="true"></el-input>
                                        <el-input v-if="dialogEdit != true" placeholder="Référence commande" v-model="commCourant.ref" style="width:100%" :disabled="true"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Libellé de commande</span>
                                        <el-input placeholder="Libellé de commande" v-model="libelle" style="width:100%" :disabled="true"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Date de la commande</span>
                                        <el-input v-if="dialogEdit" placeholder="Date de la commande" v-model="factureCourant.dateC" style="width:100%" :disabled="true"></el-input>
                                        <el-input v-if="dialogEdit != true" placeholder="Date de la commande" v-model="commCourant.dateC" style="width:100%" :disabled="true"></el-input>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout row>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Conditions de paiement *</span>
                                        <el-select filterable v-model="selectModalite" placeholder="Conditions de paiement" style="width:100%">
                                            <el-option v-for="item in modalitePaie" :key="item.value" :label="item.text" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Avance démarrage(%)</span>
                                        <el-input-number :max="100" v-model="avance" :min="0" size="small"  style="width:100%" controls-position="right" />
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Date de paiement *</span>
                                        <el-date-picker v-model="datePaie" name="datePaie" id="datePaie" value-format="dd-MM-yyyy" type="date" placeholder="Date de paiement" style="width: 100%"></el-date-picker>
                                    </div>
                                </v-flex>
                            </v-layout>

                             <v-layout row>
                                <!-- <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Caisse </span>
                                        <el-select :disabled="disableCaisse == true || dialogEdit == true  " filterable v-model="selectCaisse" placeholder="Caisse" style="width:100%">
                                            <el-option v-for="item in loadCaisseCommd" :key="item.id" :label="item.libelle" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex> -->
                                  <v-flex md12>
                                    <div class="block">
                                       <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="image1" alt="avatar"></v-avatar>
                                      <!-- <v-layout row> -->
                                      <input name="image1" type="file" style="display:none" ref="file1" accept="image/*|pdf" @change="onFileImage1Picked"/>
                                      <span class="font-weight-thin" >Joindre le devis validé au format (JPEG,PNG,PDF) avec une taille de 10 Mo maximalenn</span>
                                      <div class="font-weight-thin red--text" >{{nameFile}}</div>
                                    </div>
                                      <v-flex xs2>
                                        <v-btn color="primary" class="white--text" required @click.native="$refs.file1.click()">Docs <v-icon right dark>cloud_upload</v-icon></v-btn>
                                    </v-flex>
                                </v-flex>
                            </v-layout>

                            <!-- <p align="center">
                                <v-chip outline text-color="primary" label color="primary" style="width:100%">
                                    AJOUTER LES LIGNES A VOTRE FACTURE <v-icon right>note_add</v-icon>
                                </v-chip>
                            </p> -->

                            <v-layout row>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Ajouter une TVA global?</span>
                                        <el-select clearable @change="calculTotalComm()" v-model="tvaGlobal" placeholder="tva global" style="width:100%">
                                            <el-option v-for="item in reponses" :key="item.value" :label="item.text" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                                <v-flex md2 v-if="tvaGlobal == 'OUI'">
                                    <div class="block">
                                        <span class="demonstration">Tva %</span>
                                        <el-input type="number" @change="calculTotalComm()" :min="0" value="tva" placeholder="TVA" v-model="tvaSelect" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md3>
                                    <div class="block">
                                        <span class="demonstration">Ajouter une REMISE global?</span>
                                        <el-select clearable @change="calculTotalComm()" v-model="remiseGlobal" placeholder="remise global" style="width:100%">
                                            <el-option v-for="item in reponses" :key="item.value" :label="item.text" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                                <v-flex md2 v-if="remiseGlobal == 'OUI'">
                                    <div class="block">
                                        <span class="demonstration">Rémise %</span>
                                        <el-input type="number" @change="calculTotalComm()" :min="0" value="tva" placeholder="REMISE" v-model="remiseSelect" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md2 v-if="rabaisGlobal != 'NON'">
                                    <div class="block">
                                        <span class="demonstration">Rabais en {{rabaisGlobal}}</span>
                                        <el-input type="number" @change="calculTotalComm()" :min="0" value="rabais" placeholder="rabais" v-model="rabaisSelect" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Appliquer une RETENUE?</span>
                                        <el-select clearable @change="calculTotalComm()" v-model="retenuGlobal" placeholder="tva global" style="width:100%">
                                            <el-option v-for="item in reponses" :key="item.value" :label="item.text" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                                <v-flex md2 v-if="retenuGlobal == 'OUI'">
                                    <div class="block">
                                        <span class="demonstration">en %</span>
                                        <el-input type="number" @change="calculTotalComm()" :min="0" value="retenu" placeholder="retenu" v-model="retenuSelect" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout row v-for="(optionCom, index) in optionCommande" :key="optionCom.key">
                                <v-flex md3>
                                    <div class="block" >
                                        <span class="demonstration">Ressource *</span>
                                        <el-select filterable  diseable @change="calculTotalComm(index)" v-model="optionCom.produit" :prop="'optionCommande.'+ index+'.produit'" placeholder="Produit" style="width:100%">
                                            <el-option v-for="item in listProd" :readonly="true" :key="item.id" :label="item.value" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Prix unitaire *</span>
                                        <el-input type="number"  :readonly="true" @blur="calculTotalComm(index)" :min="5" value="prix" :prop="'optionCommande.' + index+ '.prix'" placeholder="Prix unitaire" v-model="optionCom.prix" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                               
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Unité</span>
                                        <el-input class="inline-input" v-model="optionCom.unite" :prop="'optionCommande.' + index+ '.unite'" required  placeholder="Unité" :trigger-on-focus="true" style="width: 100%" ></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Quantité *</span>
                                        <el-input type="number" :readonly="true"  @change="calculTotalComm(index)" :min="1" value="qte" :prop="'optionCommande.' + index+ '.qte'" placeholder="Quantité" v-model="optionCom.qte" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md1>
                                    <div class="block">
                                        <span class="demonstration">Remise %</span>
                                        <el-input v-if="remiseGlobal != 'OUI'"  type="number" @change="calculTotalComm(index)" :min="0" value="remise" :prop="'optionCommande.' + index+ '.remise'" placeholder="REMISE" v-model="optionCom.remise" style="width:100%"></el-input>                                
                                        <el-input v-if="remiseGlobal == 'OUI'" :disabled="true" type="number" :min="0" :value="remiseSelect" :placeholder="remiseSelect" v-model="remiseSelect" style="width:100%"></el-input>
                                    
                                    </div>
                                </v-flex>
                                <v-flex md1>
                                    <div class="block">
                                        <span class="demonstration">TVA %</span>
                                        <el-input v-if="tvaGlobal != 'OUI'" type="number" @change="calculTotalComm(index)" :min="0" value="tva" :prop="'optionCommande.' + index+ '.tva'" placeholder="TVA" v-model="optionCom.tva" style="width:100%"></el-input>
                                        <el-input v-if="tvaGlobal == 'OUI'" :disabled="true" type="number" :min="0" :prop="tvaSelect" :value="tvaSelect" placeholder="TVA" v-model="tvaSelect" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">TOTAL</span>
                                        <el-input type="number" @change="calculTotalComm(index)" :min="0" value="total" :prop="'optionCommande.' + index+ '.total'" placeholder="TOTAL" v-model="optionCom.total" style="width:100%" :readonly="true"></el-input>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout wrap>
                                <v-flex md10>
                                    <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                        TOTAL HT : {{totalComHT}} FCFA
                                    </v-chip>
                                </v-flex>
                                <v-flex md10 v-if="rabaisGlobal != 'NON'">
                                    <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                        TOTAL RABAIS: {{totalRabais}} FCFA
                                    </v-chip>
                                </v-flex>                                
                                <v-flex md10>
                                    <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                        TOTAL REMISE : {{totalComRemise}} FCFA
                                    </v-chip>
                                </v-flex>
                                <v-flex md10 v-if="retenuGlobal != 'NON'">
                                    <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                        TOTAL RETENU: {{totalComRetenu}} FCFA
                                    </v-chip>
                                </v-flex>             
                            </v-layout>
                            <v-layout row>
                                <v-flex md10>
                                    <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                        TOTAL TVA : {{totalComTVA}} FCFA
                                    </v-chip>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex md10>
                                    <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                        TOTAL TTC : {{totComLigneTTCFormat}} FCFA
                                    </v-chip>
                                </v-flex>
                            </v-layout>
                            <br>
                        </v-container>

                        <v-btn @click="dialogFacture = false" color="orange" dark>Annuler <v-icon right>close</v-icon></v-btn>
                        <v-btn v-if="dialogEdit != true" icons color="blue" @click="submitFacture()" :disabled="loading" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                        <v-btn v-if="dialogEdit" icons color="blue" @click="submitEditFacture()" :disabled="loading"  dark>Modifier <v-icon right>edit</v-icon></v-btn>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL AJOUT DE FACTURE FACT -->
        <v-dialog v-model="dialogFactureFact" max-width="95%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span v-if="dialogEdit != true ">Ajouter dévis / facture</span>
                        <span v-if="dialogEdit">Modification dévis / facture</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogFactureFact = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text>
                    <p align="center">
                        <v-chip text-color="white" label color="primary" style="width: 100%">
                            DETAILS ASSOCIE AU DEVIS / FACTURE <v-icon right>note_add</v-icon>
                        </v-chip>
                    </p>

                    <v-layout row v-if="selectContrat != null">
                        <v-flex xs2 >
                            <v-card-text class="text-xs-center">
                                <v-chip
                                        label
                                        outline
                                        color="primary darken-1"
                                        class="elevation-4"
                                        style="width:100%"
                                >
                                    <span class="subheading">Mnt Contrat : </span>
                                    <span class="title">&nbsp;  {{ new Intl.NumberFormat().format(mntEstimeContrat)}} </span>
                                </v-chip>
                            </v-card-text>

                        </v-flex>

                        <v-flex xs3>
                            <v-card-text class="text-xs-center">
                                <v-chip
                                        label
                                        outline
                                        color="blue-grey darken-1"
                                        class="elevation-4"
                                        style="width:100%"
                                >
                                    <span class="subheading">facture(s) déjà generée(s) : </span>
                                    <span class="title">&nbsp;  {{ new Intl.NumberFormat().format(mntFactureGenere)}} </span>
                                </v-chip>
                            </v-card-text>

                        </v-flex>

                        <v-flex xs4>
                            <v-card-text class="text-xs-center">
                                <v-chip
                                        label
                                        outline
                                        color="orange darken-1"
                                        class="elevation-4"
                                        style="width:100%"
                                >
                                    <span class="subheading">Mnt à verser / évolution: </span>
                                    <span class="title">&nbsp;  {{ new Intl.NumberFormat().format(mntAVerserContrat) }} / {{evolutionContrat}}% </span>
                                </v-chip>
                            </v-card-text>
                        </v-flex>

                        <v-flex xs3>
                            <v-card-text class="text-xs-center">
                                <v-chip
                                        label
                                        outline
                                        color="red darken-1"
                                        class="elevation-4"
                                        style="width:100%"
                                >
                                    <span class="subheading">Mnt restant: </span>
                                    <span class="title">&nbsp;  {{ new Intl.NumberFormat().format(mntRestantContrat) }} </span>
                                </v-chip>
                            </v-card-text>

                        </v-flex>
                    </v-layout>



                    <v-form v-model="valid" ref="formFactureFact" lazy-validation id="formFactureFact">
                        <v-container fluid grid-list-md>
                            <v-layout row>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Libellé de la facture</span>
                                        <el-input placeholder="Libellé de la facture" name="libelle" v-model="libelle" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Conditions de paiement *</span>
                                        <el-select filterable v-model="selectModalite" placeholder="Conditions de paiement" style="width:100%">
                                            <el-option v-for="item in modalitePaie" :key="item.value" :label="item.text" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                                <v-flex md2 v-show="(selectContrat != null)  && (avanceContSelect  == false)">
                                    <div class="block">
                                        <span class="demonstration">Avance démarrage(%)</span>
                                        <el-input-number :max="100" v-model="avance" :min="0" size="small"  style="width:100%" controls-position="right" />
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Date de paiement *</span>
                                        <el-date-picker v-model="datePaie" name="datePaie" id="datePaie" value-format="dd-MM-yyyy" type="date" placeholder="Date de paiement" style="width: 100%"></el-date-picker>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout row>
                                <v-flex md10>

                                    <div class="block">
                                        <span class="demonstration">Contrat prestataire(Projet/Chantier/travaux/tache) </span>
                                        <el-select clearable @clear="loadCaisse();libTachePrest = null;clearAll()"  @change="changeContrat(selectContrat)" filterable v-model="selectContrat" placeholder="Contrat prestataire" style="width:100%">
                                            <el-option v-for="item in listContrat" :key="item.idContrat" :label="item.projet" :value="item.idContrat" :value-key="item.idContrat">
                                                <span style="float: left">CONTRAT-{{ item.idContrat }}</span>
                                                <span style="float: right; color: #8492a6; font-size: 13px">Projet: {{ item.projet }}</span>
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>

                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Compte *</span>
                                        <el-select  :disabled= disabledSelectCaisse  filterable v-model="selectCaisse" placeholder="Caisse" style="width:100%">
                                            <el-option v-for="item in listCaisse" :key="item.id" :label="item.libelle" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <!-- PROJET -->
                                <v-layout >
                                    <v-flex md4>
                                        <div class="block">
                                            <span class="demonstration">Projet concerné *</span>
                                            <el-select clearable :disabled="selectContrat != null"    filterable v-on:change="loadChantier()" v-model="projetS" placeholder="Type de Projet" style="width:100%">
                                                <el-option v-for="item in listProjet" :key="item.id" :label="item.libelle" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </v-flex>
                                    <v-flex md3>
                                        <div class="block">
                                            <span class="demonstration">Chantier concerné *</span>
                                            <el-select clearable :disabled="selectContrat != null"   filterable v-on:change="loadTravaux()" v-model="chantierS" placeholder="Chantier concerné" style="width:100%">
                                                <el-option v-for="item in listChantier" :key="item.id" :label="item.libelle" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </v-flex>
                                    <v-flex md3>
                                        <div class="block">
                                            <span class="demonstration">Travaux </span>
                                            <el-select clearable :disabled="selectContrat != null"   filterable v-model="travauxS" placeholder="Selectionner travaux" style="width:100%">
                                                <el-option v-for="item in listTravaux" :key="item.id" :label="item.libelle" :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </v-flex>

                                    <v-flex md3 v-show="selectContrat != null &&  libTachePrest != null">
                                        <div class="block">
                                            <span class="demonstration">Tache </span>
                                            <el-input clearable :disabled="true" placeholder="Libellé de la tache" name="tache" v-model="libTachePrest" style="width:100%"></el-input>
                                        </div>
                                    </v-flex>

                                    <v-flex md2>
                                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="logoFacture" alt="avatar"></v-avatar><br/>
                                    <input name="photo" type="file" style="display:none" ref="logoFacture" accept="image/*" @change="onFileImageFacturePicked"/>
                                    <v-btn color="primary" class="white--text" required @click.native="$refs.logoFacture.click()">Photo  <v-icon right dark>cloud_upload</v-icon></v-btn><br/>
                                </v-flex>
                                </v-layout>
                            </v-layout>
                            <p align="center">
                                <v-chip outline text-color="primary" label color="primary" style="width: 100%">
                                    AJOUTER LES LIGNES DE VOTRE FACTURE <v-icon right>note_add</v-icon>
                                </v-chip>
                            </p>
                            <v-layout>
                            <v-flex md3 v-show="selectContrat == null">
                                <span class="demonstration">Type ressource *</span>
                                <el-select name="typeProduit" id="typeProduit" filterable  v-model="prodSelct" v-on:change="loadTypeProduit(prodSelct)" placeholder="Type ressource" style="width:100%">
                                    <el-option v-for="item in listTypeRessource" :key="item.id" :label="item.libelle" :value="item.libelle">
                                  </el-option>
                                </el-select>
                            </v-flex>
                            </v-layout>

                            <v-layout row v-for="(optionCom, index) in optionCommande" :key="optionCom.key">
                                <v-flex v-bind:class="{'md3': selectContrat == null,  'md7': selectContrat !=null}">
                                    <div class="block" v-if="selectContrat == null" >
                                        <span class="demonstration">Ressource *</span>
                                        <el-select filterable @change="calculTotalComm(index)" v-model="optionCom.produit" :prop="'optionCommande.'+ index+'.produit'" placeholder="Ressource" style="width:100%">
                                            <el-option v-for="item in listProd" :key="item.id" :label="item.value" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>

                                    <div class="block" v-if="selectContrat != null" >
                                        <span class="demonstration">Travaux </span>
                                        <el-input  :prop="'optionCommande.'+ index+'.produit'" placeholder="Service" style="width:100%" v-model="optionCom.produit"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span v-if="selectContrat == null" class="demonstration">Prix unitaire *</span>
                                        <span v-else class="demonstration">Montant *</span>
                                        <el-input :disabled="selectContrat != null && avance != 0" type="number" @blur="calculTotalComm(index)" value="prix" :prop="'optionCommande.' + index+ '.prix'" placeholder="Prix unitaire" v-model="optionCom.prix" style="width:100%" ></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md2 v-show="selectContrat == null">
                                    <div class="block">
                                        <span class="demonstration">Quantité *</span>
                                        <el-input  type="number" @change="calculTotalComm(index)" :min="1" value="qte" :prop="'optionCommande.' + index+ '.qte'" placeholder="Quantité" v-model="optionCom.qte" style="width:100%" :readonly="false"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md1 v-show="selectContrat == null">
                                    <div class="block">
                                        <span class="demonstration">Unité</span>
                                        <el-input  class="inline-input" v-model="optionCom.unite" :prop="'optionCommande.' + index+ '.unite'" required  placeholder="Unité" :trigger-on-focus="true" style="width: 100%" ></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md1 v-show="selectContrat == null">
                                    <div class="block">
                                        <span class="demonstration">Remise</span>
                                        <el-input    type="number" @change="calculTotalComm(index)" :min="0" value="remise" :prop="'optionCommande.' + index+ '.remise'" placeholder="REMISE" v-model="optionCom.remise" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md1 v-show="selectContrat == null">
                                    <div class="block">
                                        <span class="demonstration">TVA </span>
                                        <el-input   type="number" @change="calculTotalComm(index)" :min="0" value="tva" :prop="'optionCommande.' + index+ '.tva'" placeholder="TVA" v-model="optionCom.tva" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex v-bind:class="{'md1': selectContrat == null,  'md3': selectContrat !=null}">
                                    <div class="block">
                                        <span class="demonstration">TOTAL </span>
                                        <el-input type="number" @change="calculTotalComm(index)" :min="0" value="total" :prop="'optionCommande.' + index+ '.total'" placeholder="TOTAL" v-model="optionCom.total" style="width:100%" :readonly="true"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md1 v-show="selectContrat == null">
                                    <v-tooltip top>
                                        <v-btn slot="activator" @click.prevent="removeOptionComm(optionCom)" fab dark small color="red">
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                        Supprimer
                                    </v-tooltip>
                                </v-flex>
                            </v-layout>

                            <v-container v-show="selectContrat == null">

                                <v-layout wrap>
                                    <v-flex md10>
                                        <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                            TOTAL HT : {{totalComHT}} FCFA
                                        </v-chip>
                                    </v-flex>
                                    <v-flex md10>
                                        <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                            TOTAL REMISE : {{totalComRemise}} FCFA
                                        </v-chip>
                                    </v-flex>
                                    <v-flex md2>
                                        <v-btn icons color="primary" @click="addOptionComm" fab small dark> <v-icon>add</v-icon></v-btn>
                                    </v-flex>
                                </v-layout>

                                <v-layout row>
                                    <v-flex md10>
                                        <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                            TOTAL TVA : {{totalComTVA}} FCFA
                                        </v-chip>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex md10>
                                        <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                            TOTAL TTC : {{totComLigneTTCFormat}} FCFA
                                        </v-chip>
                                    </v-flex>
                                </v-layout>



                            </v-container>



                            <br>
                        </v-container>

                        <v-btn @click="dialogFactureFact = false" color="orange" dark>Annuler <v-icon right>close</v-icon></v-btn>
                        <v-btn v-if="dialogEdit != true" icons color="blue" @click="submitFactureFact()"  dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                        <v-btn v-if="dialogEdit" icons color="blue" @click="submitFactureFact()" :disabled="!valid" dark>Modifier <v-icon right>edit</v-icon></v-btn>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL VALIDER FACTURE -->
        <v-dialog v-model="dialogValiFacture" max-width="50%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="green">
                    <v-toolbar-title>
                        <span>Validation de la facture {{factureCourant.ref}} {{factureCourant.libelle}}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogValiFacture = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text v-loading="loading" element-loading-text="En cours d'enregistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <p align="center">
                        <v-chip text-color="white" label color="green">
                            VALIDATION DE LA FACTURE {{factureCourant.ref}} {{factureCourant.libelle}} <v-icon right>done_all</v-icon>
                        </v-chip>
                    </p>

                    <v-form v-model="valid" ref="form" lazy-validation id="formValidFacture">
                        <v-container fluid grid-list-md>
                            <v-layout row justify>
                                <v-flex md6>
                                    <v-select label="Décision concernant la facture" name="decisionFact" v-bind:items="decisionFact" v-model="selectDecisionFact" item-value="value" required></v-select>
                                </v-flex>
                                <v-flex md6>
                                    <v-textarea name="remarque" label="Remarque" multi-line></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>

                        <v-btn @click="dialogValiFacture = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                        <v-btn icons color="blue" @click="submitValidFacture" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL NEW LIVRAISON -->
        <v-dialog v-model="dialogLivraison" max-width="90%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span>Nouvelle livraison devis / facture {{factureCourant.ref}} {{factureCourant.libelle}}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogLivraison = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text >
                    <p align="center">
                        <v-chip text-color="white" label color="primary" style="width:100%">
                            NOUVELLE LIVRAISON DEVIS / FACTURE {{factureCourant.ref}} {{factureCourant.libelle}} <v-icon right>done_all</v-icon>
                        </v-chip>
                    </p>

                    <v-form v-model="valid" ref="form" lazy-validation id="formLivraison">
                        <v-container fluid grid-list-md>
                            <v-layout row>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Date de la livraison </span>
                                        <el-input :value="factureCourant.dateLivr" placeholder="Date de la livraison" v-model="factureCourant.dateLivr" style="width:100%" :disabled="true"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Type de livraison *</span>
                                        <el-select v-model="selectTypeLivraison" placeholder="Type de livraison" style="width:100%">
                                            <el-option v-for="item in typeLivraison" :key="item.value" :label="item.text" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>

                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Etat de la livraison *</span>
                                        <el-select filterable @change="handleTypeLivr" v-model="selectLivraison" placeholder="Etat de la livraison" style="width:100%">
                                            <el-option v-for="item in etatLivraison" :key="item.value" :label="item.text" :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                                <!-- <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Nom et prénoms du livreur (Standard/Bâteau)*</span>
                                        <el-input name="livreur" placeholder="Nom et prénoms du livreur" v-model="livreur" style="width:100%"></el-input>
                                    </div>
                                </v-flex> -->
                            </v-layout>

                            <v-layout>
                              <!-- <v-layout>
                                  <v-flex md4>
                                      <span class="demonstration">Type ressource *</span>
                                      <el-select name="typeProduit"  id="typeProduit" v-model="prodSelct" v-on:change="loadTypeProduit(prodSelct)" placeholder="Type ressource" style="width:100%">
                                          <el-option v-for="item in typeProd" :key="item.value" :label="item.text" :value="item.id">
                                          </el-option>
                                      </el-select>
                                  </v-flex>
                              </v-layout> -->
                                <v-layout  row wrap >
                                    <v-flex md12  v-for="(optionLivr, index) in optionLivraison" :key="index">
                                        <v-layout row wrap>
                                            <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Ressource</span>
                                                    <el-select v-model="optionLivr.produit" placeholder="Ressource" style="width:100%" :disabled="true">
                                                        <el-option v-for="item in listProd" :key="item.id" :label="item.produit" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                            </v-flex>
                                            <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Quantité commandée / à livrer</span>
                                                    <el-input type="number" value="qte" :prop="'optionLivraison.' + index+ '.qte'" placeholder="Quantité commandée" v-model="optionLivr.qte" style="width:100%" :readonly="true"></el-input>
                                                </div>
                                            </v-flex>
                                            <v-flex md4>
                                                <div class="block">
                                                    <span class="demonstration">Quantité livrée</span>
                                                    <el-input-number :disabled="selectLivraison == 1" :min="0"  :max="optionLivr.qte"  value="qteL" :prop="'optionLivraison.' + index+ '.qteL'" placeholder="Quantité livrée" v-model="optionLivr.qteL" style="width:100%"></el-input-number>
                                                </div>
                                            </v-flex>
                                        </v-layout>

                                    </v-flex>

                                </v-layout>
                            </v-layout>

                          <v-layout row>
                                <!-- <v-flex md6>
                                    <div class="block">
                                        <span class="demonstration">Commentaire</span>
                                        <el-input type="textarea" name="commentaire" placeholder="Commentaire" v-model="commentaire" style="width:100%"></el-input>
                                    </div>
                                </v-flex> -->
                                <v-flex md6>
                                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="image2" alt="avatar"></v-avatar>
                                    <input name="image2" type="file" style="display:none" ref="file2" accept="image/*" @change="onFileImage2Picked"/>
                                    <v-btn color="primary" class="white--text" required @click.native="$refs.file2.click()">Docs <v-icon right dark>cloud_upload</v-icon></v-btn>
                                    <div class="font-weight-thin" >Joindre une image au format (JPEG,PNG,PDF) avec une taille de 10 Mo maximale</div>
                                </v-flex>
                            </v-layout>
                            <br>
                            <br>
                            <p align="center">
                                <v-chip text-color="white"  v-if="selectTypeLivraison == 2" label color="primary" style="width:100%">
                                    INFORMATIONS GENERALES SUR LE BATEAU <v-icon right>done_all</v-icon>
                                </v-chip>
                            </p>

                            <v-layout v-if="selectTypeLivraison == 2" row>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Reference export</span>
                                        <el-input name="export" placeholder="Reference export" v-model="formBateau.export" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Numéro de commande</span>
                                        <el-input name="numCom" placeholder="Numéro de commande" v-model="formBateau.numCom" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Numéro BL</span>
                                        <el-input name="bon" placeholder="Numéro BL" v-model="formBateau.bl" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Lieu de réception</span>
                                        <el-input name="reception" placeholder="Lieu de réception" v-model="formBateau.reception" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                            </v-layout>

                            <v-layout v-if="selectTypeLivraison == 2" row>

                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Numéro de chargement </span>
                                        <el-input name="numCharge" placeholder="numéro de compte livraison" v-model="formBateau.numChargement" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Numéro de voyage </span>
                                        <el-input name="numVoyage" placeholder="Numéro de voyage" v-model="formBateau.numVoyage" style="width:100%"></el-input>
                                    </div>
                                </v-flex>

                                <v-flex md4>
                                    <div class="block">
                                        <span class="demonstration">Lieu de provénance</span>
                                        <el-input name="provenance" placeholder="Lieu de provénance" v-model="formBateau.provenance" style="width:100%"></el-input>
                                    </div>
                                </v-flex>

                            </v-layout>
                            <br>

                            <v-layout v-if="selectTypeLivraison == 2" row>
                                <v-btn  @click.stop="newConteneur('formConteneur')" color="blue" dark>Ajouter un conteneur <v-icon right>add</v-icon></v-btn>
                            </v-layout>

                            <h4 v-if="selectTypeLivraison == 2" mt-2>LISTE DES CONTENEURS</h4>
                            <v-divider v-if="selectTypeLivraison == 2" ></v-divider>
                            <v-layout row v-if="selectTypeLivraison == 2">
                                <el-table :data="tableConteneur" style="width: 100%">
                                    <el-table-column type="expand">
                                        <template slot-scope="props">
                                            <el-row>
                                                <el-col :span="5">
                                                    <div class="grid-content bg-purple">
                                                            <b>Description</b> : <p>{{ props.row.conteneur.description }}</p>
                                                    </div>
                                                </el-col>

                                                <el-col :span="19">
                                                    <div>
                                                        <b>Articles</b> :
                                                    </div>

                                                    <div >

                                                        <el-row :gutter="24">
                                                            <el-col :span="4">
                                                                <div class="grid-content bg-purple">
                                                                    <v-chip style="font-size:16px" label outline color="primary"><b>Tourtes: {{ new Intl.NumberFormat().format(props.row.conteneur.tourtesTotal) }} </b></v-chip>
                                                                </div>
                                                            </el-col>

                                                            <el-col :span="4">
                                                                <div class="grid-content bg-purple">
                                                                    <v-chip style="font-size:16px" label outline color="primary"><b>Metrages: {{ new Intl.NumberFormat().format(props.row.conteneur.metrageTotal) }} </b></v-chip>
                                                                </div>
                                                            </el-col>

                                                            <el-col :span="4">
                                                                <div class="grid-content bg-purple">
                                                                    <v-chip style="font-size:16px" label outline color="primary"><b>Tare (Kg): {{ new Intl.NumberFormat().format(props.row.conteneur.tareTotal) }} </b></v-chip>
                                                                </div>
                                                            </el-col>

                                                            <el-col :span="6">
                                                                <div class="grid-content bg-purple">
                                                                    <v-chip style="font-size:16px" label outline color="primary"><b>Poids brutes (Kg): {{ new Intl.NumberFormat().format(props.row.conteneur.poidsBruteTotal) }} </b></v-chip>
                                                                </div>
                                                            </el-col>

                                                            <el-col :span="6">
                                                                <div class="grid-content bg-purple">
                                                                    <v-chip style="font-size:16px" label outline color="primary"><b>Poids net (Kg): {{ new Intl.NumberFormat().format(props.row.conteneur.poidsNetTotal) }} </b></v-chip>
                                                                </div>
                                                            </el-col>
                                                        </el-row>
                                                    </div>

                                                    <br/>

                                                    <div class="elevation-3">
                                                        <el-table
                                                                :data="props.row.articles"
                                                                style="width: 100%">
                                                            <el-table-column
                                                                    prop="code"
                                                                    label="Code"
                                                            >
                                                            </el-table-column>
                                                            <el-table-column
                                                                    prop="designation"
                                                                    label="Désignation"
                                                            >
                                                            </el-table-column>
                                                            <el-table-column
                                                                    prop="qte"
                                                                    label="Quantité"
                                                            >
                                                            </el-table-column>

                                                            <el-table-column
                                                                    prop="tourtes"
                                                                    label="Tourtes">
                                                            </el-table-column>

                                                            <el-table-column
                                                                    prop="metrage"
                                                                    label="Metrage">
                                                            </el-table-column>

                                                            <el-table-column
                                                                    prop="tourtes"
                                                                    label="Tourtes">
                                                            </el-table-column>

                                                            <el-table-column
                                                                    prop="poidsBrute"
                                                                    label="Poids Brut (kg)">
                                                            </el-table-column>

                                                            <el-table-column
                                                                    prop="poidsNet"
                                                                    label="Poids Net (kg)">
                                                            </el-table-column>

                                                            <el-table-column
                                                                    prop="tare"
                                                                    label="Tare (kg)">
                                                            </el-table-column>

                                                            <el-table-column label="ACTION" align="center" width="100" fixed="right">
                                                                <template slot-scope="scop">
                                                                    <v-btn
                                                                            @click.native="supprimerArticle(scop.$index, props.row.articles)"
                                                                            slot="activator"
                                                                            color="red"
                                                                            fab
                                                                            dark
                                                                            small
                                                                    >
                                                                        <v-icon>delete</v-icon>

                                                                    </v-btn>
                                                                </template>
                                                            </el-table-column>
                                                        </el-table>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                        </template>
                                    </el-table-column>


                                    <el-table-column prop="marque" label="Marque" sortable>
                                        <template slot-scope="item" >
                                            {{item.row.conteneur.marque}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="numConteneur" label="Numéro compte">
                                        <template slot-scope="item" >
                                            {{item.row.conteneur.numConteneur}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="numCle" label="numéro clé">
                                        <template slot-scope="item" >
                                            {{item.row.conteneur.numCle}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="type" label="Type">
                                        <template slot-scope="item" >
                                            {{item.row.conteneur.type}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="poids" label="Poids cargot">
                                        <template slot-scope="item" >
                                            {{item.row.conteneur.poids}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="nbPacket" label="Nombre de packet">
                                        <template slot-scope="item" >
                                            {{item.row.conteneur.nbPacket}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="tare" label="Tare">
                                        <template slot-scope="item" >
                                            {{item.row.conteneur.tare}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="mesure" label="Mesure">
                                        <template slot-scope="item" >
                                            {{item.row.conteneur.mesure}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="Operations">
                                        <template slot-scope="scope">
                                            <v-tooltip top>
                                                <v-btn  slot="activator" @click="editConteneur(scope.row)" fab dark small color="orange">
                                                    <v-icon dark>folder_open</v-icon>
                                                </v-btn>
                                                Détails
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableConteneur)" dark>
                                                    <v-icon center>delete</v-icon>
                                                </v-btn>
                                                Supprimer ce conteneur
                                            </v-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </v-layout>
                            <br>

                            <v-btn @click="dialogLivraison = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                            <!-- <v-btn color="primary" @click.native="e1 = 1">Precedent</v-btn> -->
                            <!-- <v-btn v-if="selectTypeLivraison === 2" color="primary" @click.native="e1 = 2">Suivant</v-btn> -->
                            <v-btn v-if="selectTypeLivraison === 1 || selectTypeLivraison === 2" icons color="green" @click="submitLivraison" :disabled="loading" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                        </v-container >
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL SUPPRESSION CONTENEUR -->
        <v-dialog v-model="deleteConteneur" persistent max-width="50%">
            <v-card>
                <v-card-title class="headline">Supprimer cet enregistrement ?</v-card-title>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 class="mb-2">
                            <el-alert
                                    title="La suppression est définitive"
                                    :closable="false"
                                    show-icon
                                    type="warning"
                            ></el-alert>
                        </v-flex>
                        <!-- <v-flex xs12>
                          <p class="grey--text font-weight-thin body-1">DOCUMENT</p>
                          <p class="black--text .font-weight-regular subheading">NUMERO-12345</p>
                        </v-flex> -->
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" dark @click="dialogSupr = false">
                        Annuler
                        <v-icon right>remove_circle</v-icon>
                    </v-btn>
                    <v-btn
                            color="red darken-1"
                            dark
                            @click="ConteneurDelete()"
                    >
                        Supprimer
                        <v-icon right>delete</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- END MODAL SUPPRESSION CONTENEUR -->

        <!--DIALOG FORMULAIRE CONTENEUR-->
        <v-dialog v-model="dialogConteneur" transition="dialog-bottom-transition" scrollable :loading="loading" max-width="80%" persistent>
            <v-card>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Ajouter un conteneur</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="dialogConteneur = false"> <v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-stepper v-model="d1">
                            <v-stepper-header>
                                <v-stepper-step :complete="d1 > 1" step="1">Informations sur le conteneur</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="d1 > 2" step="2">Articles</v-stepper-step>
                            </v-stepper-header>
                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <v-card>


                                        <el-form label-position="top" :inline="true" :model="formConteneur" ref="formConteneur" class="demo-form-inline">
                                            <v-layout row>
                                                <v-flex md3>
                                                    <el-form-item label="Marque"   required style="width:100%">
                                                        <el-input  v-model="formConteneur.marque"  name="marque" placeholder="Marque" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex xs3 class="mr-1" >
                                                    <el-form-item label="Numéro conteneur">
                                                        <el-input  v-model="formConteneur.numConteneur"  name="numConteneur" placeholder="Numéro conteneur" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex xs3 class="mr-1" >
                                                    <el-form-item   label="Numéro de la clé" >
                                                        <el-input  v-model="formConteneur.numCle" name="numCle" placeholder="Numéro de la clé"  style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md3>
                                                    <el-form-item label="Type de container" style="width:100%">
                                                        <el-select v-model="formConteneur.type"  placeholder="Type de conteneur" style="width:100%">
                                                            <el-option v-for="item in typeConteneur" :key="item.id" :label="item.libelle" :value="item.libelle">
                                                            </el-option>
                                                        </el-select>

                                                    </el-form-item>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row>


                                                <v-flex md3>
                                                    <el-form-item label="Poids cargot"  style="width:100%">
                                                        <el-input-number  name="poids"  v-model="formConteneur.poids" placeholder="Poids cargot" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md3>
                                                    <el-form-item label="Le tare (kg)"  prop="tare"  style="width:100%">
                                                        <el-input-number name="tare" v-model="formConteneur.tare" placeholder="Tare" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md3>
                                                    <el-form-item label="Mesure"    style="width:100%">
                                                        <el-input-number v-model="formConteneur.mesure" placeholder="Mesure" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md3>
                                                    <el-form-item label="Nombre de packet"  style="width:100%">
                                                        <el-input-number v-model="formConteneur.nbPacket" placeholder="Nombre de packet" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>


                                            </v-layout>

                                            <v-layout row>


                                                <v-flex md4>
                                                    <el-form-item label="Description des packets"   style="width:100%">
                                                        <el-input type="textarea" :rows="4" id="description" placeholder="Description des packets" v-model="formConteneur.description" style="width:100%">
                                                        </el-input>
                                                    </el-form-item>
                                                </v-flex>
                                            </v-layout>
                                        </el-form>

                                        <v-layout>
                                            <v-spacer></v-spacer>
                                            <v-btn flat color="error" @click="dialogConteneur = false">Fermer<v-icon right>close</v-icon></v-btn>
                                            <v-btn color="primary" :disabled="!verifFormConteneur()"  @click.native="d1 = 2">Continuer<v-icon right>keyboard_arrow_right</v-icon></v-btn>
                                        </v-layout>
                                    </v-card>
                                </v-stepper-content>
                                <v-stepper-content step="2">
                                    <v-card>
                                        <v-flex xs12 class="mb-2">
                                            <v-alert :value="true" outline color="primary" icon="info">
                                                Ajouter des articles au conteneur
                                            </v-alert>
                                        </v-flex>

                                        <el-form label-position="top" :inline="true" :model="formArticle" class="demo-form-inline">
                                            <v-layout row>
                                                <v-flex md4>
                                                    <el-form-item label="Code" required style="width:100%">
                                                        <el-input v-model="formArticle.code" placeholder="Code" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md4>
                                                    <el-form-item label="Désignation" style="width:100%">
                                                        <el-input v-model="formArticle.designation" placeholder="Désignation" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md4>
                                                    <el-form-item label="Quantité" style="width:100%">
                                                        <el-input-number v-model="formArticle.qte" placeholder="Quantité" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md4>
                                                    <el-form-item label="Tourtes" style="width:100%">
                                                        <el-input v-model="formArticle.tourtes" placeholder="Tourtes" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row>
                                                <v-flex md4>
                                                    <el-form-item label="Métrage" style="width:100%">
                                                        <el-input-number v-model="formArticle.metrage" placeholder="Métrage" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md4>
                                                    <el-form-item label="Poids Brut (kg)" style="width:100%">
                                                        <el-input-number name="poidsBrute" v-model="formArticle.poidsBrute" placeholder="Poids Brut" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md4>
                                                    <el-form-item label="Tare (kg)" style="width:100%">
                                                        <el-input-number name="tare" v-model="formArticle.tare" placeholder="tare" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md4>
                                                    <el-form-item label="Poids net (kg)" style="width:100%">
                                                        <el-input-number name="poidsNet"  v-model="formArticle.poidsNet" placeholder="Poids net" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>
                                            </v-layout>

                                            <el-button  type="primary" @click="addListArticleConteneur(formArticle)">Ajouter</el-button>
                                        </el-form>
                                        <br>

                                        <v-layout row>
                                            <el-table :data="tableArticleConteneur" style="width: 100%">
                                                <el-table-column prop="code" label="Code" sortable> </el-table-column>
                                                <el-table-column prop="designation" label="Désignation"> </el-table-column>
                                                <el-table-column prop="qte" label="Quantité"></el-table-column>

                                                <el-table-column prop="tourtes" label="Tourtes"></el-table-column>
                                                <el-table-column prop="metrage" label="Metrage"></el-table-column>
                                                <el-table-column prop="poidsBrute" label="Poids Brut (kg)"></el-table-column>
                                                <el-table-column prop="tare" label="Tare (kg)"></el-table-column>
                                                <el-table-column prop="poidsNet" label="Poids net (kg)"></el-table-column>
                                                <el-table-column label="Operations">
                                                    <template slot-scope="scope">
                                                        <v-tooltip top>
                                                            <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableArticleConteneur)" dark>
                                                                <v-icon center>delete</v-icon>
                                                            </v-btn>
                                                            Supprimer cet article
                                                        </v-tooltip>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </v-layout>
                                        <br>
                                    </v-card>

                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-btn icons flat color="error"  @click="dialogConteneur = false" >Annuler <v-icon right>close</v-icon></v-btn>
                                        <v-btn color="primary" @click.native="d1 = 1"><v-icon>keyboard_arrow_left</v-icon>Précédent</v-btn>

                                        <!-- <el-button  type="primary" @click="addListConteneur(formConteneur);dialogConteneur = false">Ajouter</el-button> -->
                                        <v-btn color="primary" dark  @click.stop="addListConteneur();dialogConteneur = false">Ajouter<v-icon right>add</v-icon> </v-btn>
                                        <!-- <v-btn color="primary" dark @click="createDemande('formConteneur')">Ajouter<v-icon right>add</v-icon> </v-btn> -->
                                    </v-layout>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--FIN DIALOG FORMULAIRE CONTENEUR-->


        <!-- MODAL NEW APPROVISIONNEMENT -->
        <v-dialog v-model="dialogAppro" max-width="90%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span>Nouvel approvisionnement pour la livraison {{livraisonCourant.ref}}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogAppro = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text v-loading="loading" element-loading-text="En cours d'enregistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <p align="center">
                        <v-chip text-color="white" label color="primary">
                            NOUVEL APPROVISIONNEMENT POUR LA LIVRAISON {{livraisonCourant.ref}}<v-icon right>add_shopping_cart</v-icon>
                        </v-chip>
                    </p>

                    <v-form v-model="valid" ref="formAppro" lazy-validation id="formAppro">
                        <v-container fluid grid-list-md v-for="(optionEntre, index) in optionEntrepot" :key="optionEntre.key">
                            <v-layout row justify>
                                <v-flex md2>
                                    <v-textarea class="subheading black--text" value="ref" :prop="'optionEntrepot.' + index+ '.ref'" label="Référence" v-model="optionEntre.ref" disabled></v-textarea>
                                </v-flex>
                                <v-flex md4>
                                    <v-textarea  class="subheading black--text"   value="libelle" :prop="'optionEntrepot.' + index+ '.libelle'" label="Désignation" v-model="optionEntre.libelle" disabled></v-textarea>
                                </v-flex>
                                <v-flex md5>
                                    <v-textarea  class="subheading black--text" value="lieu" :prop="'optionEntrepot.' + index+ '.lieu'" label="Localisation" v-model="optionEntre.lieu" disabled></v-textarea>
                                </v-flex>
                                <v-flex md1>
                                    <v-checkbox v-model="optionEntre.valide" :prop="'optionEntrepot.' + index+ '.valide'" @change="calculTotalAppro(optionEntre,optionAppro,index)" color="green"></v-checkbox>
                                </v-flex>
                            </v-layout>
                            <v-layout wrap v-if="optionEntre.valide === true" >
                                <v-flex xs10 v-for="(optionItem, index) in optionAppro" :key="optionItem.key">
                                    <v-layout row>
                                        <v-flex md4>
                                            <v-textarea value="produit" :prop="'optionAppro.' + index+ '.produit'" label="Produit" v-model="optionItem.produit" disabled></v-textarea>
                                        </v-flex>
                                        <v-flex md2>
                                            <v-textarea value="qteC" :prop="'optionAppro.' + index+ '.qteC'" label="Quantité commandée" v-model="optionItem.qteC" disabled></v-textarea>
                                        </v-flex>
                                        <v-flex md2>
                                            <v-textarea value="qteL" :prop="'optionAppro.' + index+ '.qteL'" label="Quantité livrée" v-model="optionItem.qteL" disabled></v-textarea>
                                        </v-flex>
                                        <v-flex md2>
                                            <v-textarea value="qteR" :prop="'optionAppro.' + index+ '.qteR'" label="Quantité restante" v-model="optionItem.qteR" disabled></v-textarea>
                                        </v-flex>
                                        <v-flex md2>
                                            <el-input   value="qteRecu" :prop="'optionAppro.' + index+ '.qteRecu'" label="Quantité reçue" type="number" :min="1" :max="optionItem.qteL" v-model="optionQteRecu['p'+optionEntre.id+optionItem.id].qte" @change="calculTotalAppro(optionEntre,optionItem,index)"  required></el-input>
                                        </v-flex>
                                    </v-layout>

                                </v-flex >
                            </v-layout>
                        </v-container>

                        <v-btn @click="dialogAppro = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                        <v-btn icons color="blue" @click="submitAppro()" :disabled="!valid" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL NEW TARIFICATION -->
        <v-dialog v-model="dialogTarif" max-width="70%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span  v-if="dialogEdit == false" >Ajouter nouvelle tarification ressource</span>
                        <span  v-if="dialogEdit == true" >Modifier la tarification</span>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogTarif = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-form v-model="valid" ref="formTarif" lazy-validation id="formTarif">
                        <v-container fluid grid-list-md>
                            <v-layout row>
                               <v-flex md3  v-if="dialogEdit == false">
                                    <span class="demonstration">Type ressource *</span>
                                    <el-select name="typeProduit" id="typeProduit" filterable v-model="prodSelct" v-on:change="loadTypeProduit(prodSelct)" placeholder="Type ressource" style="width:100%">
                                        <el-option v-for="item in listTypeRessource" :key="item.id" :label="item.libelle" :value="item.libelle">
                                        </el-option>
                                    </el-select>
                                </v-flex>
                                <v-flex md3>
                                    <div class="block">
                                        <span class="demonstration">Ressource concerné *</span>
                                        <el-select  v-if="dialogEdit == false"
                                             v-on:change="loadUniteProduit(selectProduit)"
                                         filterable v-model="selectProduit" placeholder="Ressource concerné" style="width:100%">
                                            <el-option v-for="item in listProd" :key="item.id" :label="item.value" :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <el-input v-if="dialogEdit == true" v-model="selectProduit" style="width:100%" :readonly="true"></el-input>
                                    </div>
                                </v-flex>
                                 <v-flex md3>
                                    <div class="block">
                                        <span class="demonstration">Unité *</span>
                                        <el-input type="text" name="valeurSelect" :readonly="true" v-model="valeurUniteMateriel" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md3>
                                    <div class="block">
                                        <span class="demonstration">Prix d'achat *</span>
                                        <el-input type="number" name="prixAchat" :min="0" placeholder="Prix d'achat" v-model="prixAchat" style="width:100%"></el-input>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <br>
                        <v-flex xs12 class="text-xs-right">
                            <v-btn icons color="primary"  v-if="dialogEdit == false" @click="addListTaches(selectProduit,prixAchat)" fab small dark> <v-icon>add</v-icon></v-btn>
                        </v-flex>
                            <br>
                            <v-layout row >

                                <el-table :data="tableTarification"  v-if="dialogEdit == false" style="width: 100%">
                                    <el-table-column  v-for="column in taches"
                                                      :key="column.id"
                                                      :prop="column.prop"
                                                      :label="column.label"
                                                      sortable>
                                    </el-table-column>
                                    <el-table-column label="Operations">
                                        <template slot-scope="scope">
                                            <v-tooltip top>
                                                <v-btn slot="activator" fab small icons color="red"  @click.native.prevent="deleteTache(scope.$index, tableTarification)" dark>
                                                    <v-icon center>delete</v-icon>
                                                </v-btn>
                                                Supprimer ce tarif
                                            </v-tooltip>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </v-layout>
                        </v-container>
                        <v-flex xs12 class="text-xs-right">
                          <v-btn @click="dialogTarif = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                          <v-btn icons color="blue" @click="submitTarif"  v-if="dialogEdit == false" :disabled="loading" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                          <v-btn icons color="blue" @click="dialogConfirm = true" v-if="dialogEdit == true"  :disabled="loading"  dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                        </v-flex>

                    </v-form>

                    <br>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

      <!-- MODAL confirmation -->
        <v-dialog v-model="dialogConfirm" max-width="50%" :overlay="true" scrollable persistent>
          <v-card>
            <v-card-text text-xs-center>
              <h2 align="center">La modification sera prise en compte pour les nouvelles commandes</h2>
              <p align="center">
                <v-btn @click.native="dialogTarif = false;dialogConfirm = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                <v-btn icons color="green" @click.stop="submitTarif" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
              </p>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>

        <!-- MODAL AJOUT DE DEVIS MAINTENANCE -->
        <v-dialog v-model="dialogDevis" max-width="80%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span v-if="dialogEdit != true">Ajouter un nouveau devis</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogDevis = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text v-loading="loading" element-loading-text="En cours d'enregistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <p align="center">
                        <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                            DEVIS DE LA DEMANDE {{maintenanceCourant.ref}} <v-icon right>note_add</v-icon>
                        </v-chip>
                    </p>

                    <v-form v-model="valid" ref="formDevis" lazy-validation id="formDevis">
                        <v-container fluid grid-list-md>

                            <p align="center">
                                <v-chip outline text-color="primary" label color="primary" style="width:100%">
                                    AJOUTER LES LIGNES DE VOTRE FACTURE <v-icon right>note_add</v-icon>
                                </v-chip>
                            </p>
                          <v-layout>
                            <v-flex md3>
                                <span class="demonstration">Type ressource *</span>
                                <el-select name="typeProduit" id="typeProduit" filterable v-model="prodSelct" v-on:change="loadTypeProduit(prodSelct)" placeholder="Type ressource" style="width:100%">
                                    <el-option v-for="item in listTypeRessource" :key="item.id" :label="item.libelle" :value="item.libelle">
                                    </el-option>
                                </el-select>
                            </v-flex>
                        </v-layout>
                            <v-layout row justify v-for="(option, index) in optionDevis" :key="option.key">
                                <v-flex md3>
                                    <div class="block">
                                        <span class="demonstration">Ressource *</span>
                                        <el-select filterable @change="calculTotalDevis()" v-model="option.libelle" placeholder="Ressource" :disabled="maintenanceCourant.etatFact === 1" style="width:100%">
                                            <el-option v-for="item in listProd" :key="item.id" :label="item.value" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Quantité</span>
                                        <el-input :disabled="maintenanceCourant.etatFact === 1" v-model="option.qte" @change="calculTotalDevis" type="number" min="1" placeholder="Quantité" style="width: 100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">Prix unitaire</span>
                                        <el-input :disabled="maintenanceCourant.etatFact === 1" v-model="option.cout" @change="calculTotalDevis" type="number" min="0" placeholder="Prix unitaire" style="width: 100%" :readonly="true"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">TVA</span>
                                        <el-input :disabled="maintenanceCourant.etatFact === 1" v-model="option.tva" @change="calculTotalDevis" type="number" min="0" max="18" placeholder="TVA" style="width: 100%"></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md2>
                                    <div class="block">
                                        <span class="demonstration">TOTAL TTC</span>
                                        <el-input v-model="option.total" type="number" placeholder="TOTAL TTC" style="width: 100%" disabled></el-input>
                                    </div>
                                </v-flex>
                                <v-flex md1>
                                    <v-tooltip top v-if="maintenanceCourant.etatFact !== 1">
                                        <v-btn slot="activator" fab dark small color="red" @click="suppressionDevis(index)">
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                        Supprimer
                                    </v-tooltip>
                                </v-flex>
                            </v-layout>

                            <br>
                            <v-layout row justify>
                                <v-flex md10>
                                    <v-chip outline text-color="primary" label color="primary" style="font-size:29px; width:100%">
                                        MONTANT HT : {{devisHt}} FCFA
                                    </v-chip>
                                </v-flex>

                                <v-flex md2>
                                    <v-tooltip top>
                                        <v-btn v-if="maintenanceCourant.etatFact !== 1" slot="activator" @click="demandeDevisPlus" fab dark small color="blue">
                                            <v-icon icon  dark >add</v-icon>
                                        </v-btn>
                                        Ajouter
                                    </v-tooltip>
                                </v-flex>
                            </v-layout>

                            <v-layout row justify>
                                <v-flex md10>
                                    <v-chip outline text-color="primary" label color="primary" style="font-size:29px; width:100%">
                                        MONTANT TVA : {{devisTva}} FCFA
                                    </v-chip>
                                </v-flex>
                            </v-layout>

                            <v-layout row justify>
                                <v-flex md10>
                                    <v-chip outline text-color="orange" label color="orange" style="font-size:29px; width:100%">
                                        MONTANT TTC : {{devisTotal}} FCFA
                                    </v-chip>
                                </v-flex>
                            </v-layout>

                        </v-container>

                        <v-btn @click="dialogDevis = false" color="orange" dark>Annuler <v-icon right>close</v-icon></v-btn>
                        <v-btn v-if="dialogEdit != true && optionDevis.length !== 0" icons color="blue" @click="submitDevis()" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
                        <v-btn v-if="dialogEdit && optionDevis.length !== 0" icons color="blue" @click="submitDevis()" :disabled="!valid" dark>Modifier <v-icon right>edit</v-icon></v-btn>
                    </v-form>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL SHOW ARTICLE -->
        <v-dialog v-model="dialogShowArticle" max-width="80%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span>Détails de articles du conteneur </span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogShowArticle = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-layout row>
                    <el-table :data="tableEnsemble.infoArticle" style="width: 100%">
                        <el-table-column prop="code" label="Code" sortable> </el-table-column>
                        <el-table-column prop="designation" label="Désignation"> </el-table-column>
                        <el-table-column prop="qte" label="Quantité"></el-table-column>

                        <el-table-column prop="tourtes" label="Tourtes"></el-table-column>
                        <el-table-column prop="metrage" label="Metrage"></el-table-column>
                        <el-table-column prop="poidsBrute" label="Poids Brut (kg)"></el-table-column>
                        <el-table-column prop="tare" label="Tare (kg)"></el-table-column>
                        <el-table-column prop="poidsNet" label="Poids net (kg)"></el-table-column>
                        <el-table-column label="Operations">
                            <template slot-scope="scope">
                                <v-tooltip top>
                                    <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableArticleConteneur)" dark>
                                        <v-icon center>delete</v-icon>
                                    </v-btn>
                                    Supprimer cet article
                                </v-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </v-layout>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>


        <!-- MODAL SHOW COMMANDE -->
        <v-dialog v-model="dialogShowCommande" max-width="80%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span>Détails de la commande {{commCourant.ref}} {{commCourant.libelle}} </span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogShowCommande = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text v-loading="loading" element-loading-text="Veuillez patientez ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <el-row :gutter="20" style="padding:10px;">
                        <el-col :span="12">
                            <el-card class="box-card">
                                <div class="grid-content" style="padding:3px;">
                                    <el-row>
                                        <div class="text item">
                                            <v-layout row justify>
                                                <v-flex md6>
                                                    <p><b>Identifiant : </b> {{detailCommande.ref}} </p>
                                                    <p><b>Libellé : </b> {{detailCommande.libelle}} </p>
                                                    <p><b>Date de la commande : </b> {{detailCommande.dateC}} </p>
                                                    <p><b>Date de la livraison : </b> {{detailCommande.dateLivr}} </p>
                                                    <p><b>Statut : </b>
                                                        <v-chip outline text-color="orange" label color="orange" v-if="detailCommande.factureValide === 0">
                                                            EN ATTENTE DE VALIDATION<v-icon right></v-icon>
                                                        </v-chip>
                                                        <v-chip outline text-color="green" label color="green" v-if="detailCommande.factureValide === 1">
                                                            VALIDE<v-icon right></v-icon>
                                                        </v-chip>
                                                        <v-chip outline text-color="red" label color="red" v-if="detailCommande.factureValide === 2">
                                                            REJETE<v-icon right></v-icon>
                                                        </v-chip>
                                                    </p>
                                                    <p><b>Etat : </b>
                                                        <v-chip outline text-color="red" label color="red" v-if="detailCommande.etat === false">
                                                            NON LIVRE<v-icon right></v-icon>
                                                        </v-chip>
                                                        <v-chip outline text-color="green" label color="green" v-if="detailCommande.etat == true">
                                                            LIVRE EN TOTALITE<v-icon right></v-icon>
                                                        </v-chip>
                                                    </p>
                                                    <p><b>Conditions de paiement : </b> {{detailCommande.modalite}} </p>
                                                </v-flex>
                                                <v-flex md6>
                                                    <p><b>Enregistré par: </b> {{detailCommande.userCreated}} </p>
                                                    <p><b>Date d'enregistrement : </b> {{detailCommande.created}} </p>
                                                    <div v-if="detailCommande.usermodified">
                                                        <p><b>Date de modification : </b> {{detailCommande.modified}} </p>
                                                        <p><b>Modifier par : </b> {{detailCommande.usermodified}} </p>
                                                    </div>
                                                    <p><b>Projet : </b> {{detailCommande.projet}}</p>
                                                    <p><b>Avance démarage(%) : </b> {{detailCommande.avance}} </p>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout v-if="detailCommande.compare == 2" row justify>
                                                <v-flex xs6 class="text-xs-right title">
                                                    <a href="#"  target=_blank>
                                                        <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img src="static/validComparateur.png" ></v-avatar>
                                                    </a>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </el-row>

                                    <el-row >
                                        <el-table stripe :data="detailCommande.user" style="width: 100%">
                                            <el-table-column prop="nom" label="Personnes concernées" width="180"></el-table-column>
                                        </el-table>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-col>

                        <el-col :span="12">
                            <el-card class="box-card">
                                <div class="grid-content" style="padding:3px;">
                                    <el-row>
                                        <div class="text item">
                                            <v-layout wrap justify>
                                                <v-flex md12>
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:29px">
                                                        MONTANT REMISE : {{totalComRemise}} FCFA
                                                    </v-chip>
                                                </v-flex>                                               
                                                <v-flex md12>
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:29px">
                                                        MONTANT HT : {{totalComHT}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                                <!-- <v-flex md12>
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:29px">
                                                        MONTANT RETENU : {{totalComRetenu}} FCFA
                                                    </v-chip>
                                                </v-flex> -->
                                            </v-layout>
                                            <v-layout row justify>
                                                <v-flex md12>
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:29px">
                                                        MONTANT TVA : {{totalComTVA}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify>
                                                <v-flex md12>
                                                    <v-chip outline text-color="orange" label color="orange" style="font-size:29px">
                                                        MONTANT TTC : {{commCourant.total}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-col>

                        <el-card>
                            <v-card>
                                <img height="100px" :src='commCourant.imgCommande' :alt="commCourant.imgCommande"/>
                                <v-card-actions>
                                    <v-btn target="_blank" :href="commCourant.imgCommande" flat color="orange">Voir le document</v-btn>
                                </v-card-actions>
                            </v-card>
                        </el-card>

                    </el-row>

                    <el-row :gutter="7" style="padding:10px;">
                        <el-card class="box-card">
                            <div class="grid-content" style="padding: 3px">
                                <el-row>
                                    <template>
                                        <el-table :data="detailCommande.option" height="250" style="width: 100%">
                                            <el-table-column prop="produit" label="Ressource" width="180"></el-table-column>
                                             <el-table-column prop="prixUOld" label="Ancien Prix unitaire (FCFA)">
                                               <template slot-scope="scope">
                                                <v-chip label text-color="white" color="red">
                                                      {{scope.row.prixUOld}}
                                                  </v-chip>
                                              </template>
                                            </el-table-column>
                                            <el-table-column prop="prix" label="Prix unitaire (FCFA)"></el-table-column>
                                            <el-table-column prop="unite" label="Unité"></el-table-column>
                                            <el-table-column prop="qte" label="Quantité"></el-table-column>
                                            <el-table-column prop="remise" label="Remise(%)"></el-table-column>
                                            <el-table-column prop="tva" label="TVA (18%)"></el-table-column>
                                            <el-table-column prop="total" label="Total TTC (FCFA)"></el-table-column>
                                        </el-table>
                                    </template>
                                </el-row>
                            </div>
                        </el-card>
                    </el-row>
                  
                    <p align="center" v-if="detailCommande.detailsFuison && detailCommande.detailsFuison.length > 0">
                        <v-chip text-color="white" label color="primary" style="width:100%">
                            DETAILS DES DEMANDES FUSIONNÉES
                        </v-chip>
                    </p>

                    <el-row :gutter="7" style="padding:10px;"  v-if="detailCommande.detailsFuison && detailCommande.detailsFuison.length > 0">
                        <el-card class="box-card">
                            <div class="grid-content" style="padding: 3px">
                                <el-row>
                                    <template>
                                        <el-table :data="detailCommande.detailsFuison" height="250" style="width: 100%">
                                            <el-table-column prop="projet" label="Projet" width="180"></el-table-column>
                                            <el-table-column prop="chantier" label="Chantier" width="180"></el-table-column>
                                            <el-table-column prop="travaux" label="Travaux" width="180"></el-table-column>
                                            <el-table-column prop="tache" label="tache" width="180"></el-table-column>                                            
                                            <el-table-column prop="produit" label="Produit"></el-table-column>
                                            <el-table-column prop="unite" label="Unité"></el-table-column>
                                            <el-table-column prop="qte" label="Quantité"></el-table-column>
                                        </el-table>
                                    </template>
                                </el-row>
                            </div>
                        </el-card>
                    </el-row>
                  
                    <v-tooltip top>
                        <v-btn slot="activator" icons color="orange" @click.stop="dialogShowCommande = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
                        Fermer
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn v-if="commCourant.compare != 2 && commCourant.factureValide === 0 && commCourant.factureExiste !== true" slot="activator" icons color="primary" @click.stop="editCommande(commCourant);" dark>Modifier <v-icon right>edit</v-icon></v-btn>
                        Modifier
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn v-if="commCourant.factureExiste !== true" slot="activator" icons color="grey" @click.stop="newFacture(commCourant); " dark> Transformer la commande en facture <v-icon right>note_add</v-icon></v-btn>
                        Transformer en facture
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn slot="activator" icons color="orange" @click.stop="imprimerCommande(commCourant);" dark>Imprimer <v-icon right>print</v-icon></v-btn>
                        Imprimer le bon de commande
                    </v-tooltip>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL SHOW FACTURE -->
        <v-dialog v-model="dialogShowFacture" max-width="95%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span>Détails de la facture {{factureCourant.ref}} {{factureCourant.libelle}} </span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogShowFacture = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text v-loading="loading" element-loading-text="Veuillez patientez ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <el-row :gutter="20" style="padding:10px;">
                        <el-col :span="14">
                            <el-card class="box-card">
                                <div class="grid-content" style="padding:3px;">
                                    <el-row>
                                        <div class="text item">
                                            <el-alert
                                                    title="Vous ne pouvez pas modifier une facture issue d'une commande"
                                                    type="warning"
                                                    :closable="false"
                                                    center
                                                    show-icon>
                                            </el-alert>
                                            <v-layout row justify>
                                                <v-flex md6>
                                                    <p><b>Identifiant : </b> {{detailFacture.ref}} </p>
                                                    <p><b>Libellé : </b> {{detailFacture.libelle}} </p>
                                                    <p><b>Référence commande : </b> {{detailFacture.refCom}} </p>
                                                    <p v-if="detailFacture.typeFact === true"><b>Commande concerné : </b> COM-{{detailFacture.id}} </p>
                                                    <p v-if="detailFacture.typeFact === false"><b>Maintenance concerné : </b> MAIN-{{detailFacture.id}} </p>
                                                    <p v-if="detailFacture.typeFact === true"><b>Date de la commande : </b> {{detailFacture.dateC}} </p>
                                                    <p><b>Total ttc de la facture : </b> {{detailFacture.total}} FCFA</p>

                                                    <p><b>Statut : </b>
                                                        <v-chip outline text-color="orange" label color="orange" v-if="detailFacture.etatFact === 0">
                                                            EN ATTENTE DE VALIDATION<v-icon right></v-icon>
                                                        </v-chip>
                                                        <v-chip outline text-color="green" label color="green" v-if="detailFacture.etatFact === 1">
                                                            VALIDE<v-icon right></v-icon>
                                                        </v-chip>
                                                        <v-chip outline text-color="red" label color="red" v-if="detailFacture.etatFact === 2">
                                                            REJETE<v-icon right></v-icon>
                                                        </v-chip>
                                                    </p>
                                                     <p  v-if="detailFacture.remarqueFact !== null">
                                                       <b>Remarque : </b>
                                                            <el-input v-if="detailFacture.etatFact === 2"
                                                                type="textarea"
                                                                color="red"
                                                                name="description"
                                                                v-model="detailFacture.remarqueFact"
                                                                style="width:100%"
                                                              ></el-input>
                                                    </p>
                                                </v-flex>
                                                <v-flex md6>
                                                    <p><b>Enregistré par : </b> {{detailFacture.userCreated}} </p>
                                                    <p><b>Caisse concerné : </b> {{detailFacture.libelleCaisse}} </p>
                                                    <p v-if="detailFacture.modalite !== null"><b>Conditions de paiement: </b>
                                                        {{detailFacture.modalite}}
                                                    </p>
                                                    <p v-if="detailFacture.avance !== null"><b>Avance demarage : </b>
                                                        {{detailFacture.avance}}
                                                    </p>
                                                    <p v-if="detailFacture.datePaie !== null"><b>Date de paiement : </b> {{detailFacture.datePaie}} </p>
                                                    <p><b>Date d'enregistrement : </b> {{detailFacture.created}} </p>
                                                    <p><b>Date de modification : </b> {{detailFacture.modified}} </p>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="10">
                            <el-card class="box-card">
                                <div class="grid-content" style="padding:3px;">
                                    <el-row>
                                        <div class="text item">
                                            <v-layout wrap justify>                                               
                                                <v-flex md12>
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:23px">
                                                        MONTANT HT : {{totalComHT}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                                <v-flex md12>
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:23px">
                                                        MONTANT REMISE : {{totalComRemise}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                                <v-flex md12 v-if="factureCourant.rabais != 0">
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:23px">
                                                        MONTANT RABAIS : {{totalRabais}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                                <v-flex md12 v-if="factureCourant.retenuPrc != 0">
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:23px">
                                                        MONTANT RETENU {{factureCourant.retenuPrc}} %: {{totalComRetenu}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify>
                                                <v-flex md12>
                                                    <v-chip outline text-color="primary" label color="primary" style="font-size:23px">
                                                        MONTANT TVA : {{totalComTVA}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify>
                                                <v-flex md12>
                                                    <v-chip outline text-color="orange" label color="orange" style="font-size:23px">
                                                        MONTANT TTC : {{detailFacture.total}} FCFA
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </el-row>
                                    <el-row>
                                        <v-layout row  v-if="detailFacture.imagefact !='' ">
                                            <v-flex xs3 class="ml-3  elevation-5 " >
                                                <a :href="detailFacture.imagefact"  target=_blank>
                                                    <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img :src="detailFacture.imagefact" ></v-avatar>
                                                </a>
                                            </v-flex>
                                        </v-layout>
                                    </el-row>
                                </div>
                            </el-card>

                        </el-col>
                    </el-row>

                    <el-row :gutter="7" style="padding:10px;">
                        <el-card class="box-card">
                            <div class="grid-content" style="padding: 3px">
                                <el-row>
                                    <template>
                                        <el-table :data="detailFacture.option" height="250" style="width: 100%">
                                            <el-table-column prop="produit" label="Ressource" width="180"></el-table-column>
                                            <el-table-column prop="unite" label="Unité"></el-table-column>
                                            <el-table-column prop="prix" label="Prix unitaire (FCFA)"></el-table-column>
                                            <el-table-column prop="qte" label="Quantité"></el-table-column>
                                            <el-table-column prop="remise" label="Remise(%)"></el-table-column>
                                            <el-table-column prop="tva" label="TVA(%) " width="180"></el-table-column>
                                            <el-table-column prop="total" label="Total TTC (FCFA)"></el-table-column>
                                        </el-table>
                                    </template>
                                </el-row>
                            </div>
                        </el-card>
                    </el-row>

                    <v-tooltip top>
                        <v-btn slot="activator" icons color="orange" @click.stop="dialogShowFacture = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
                        Fermer
                    </v-tooltip>
                    <v-tooltip top>
                        <!--eviter de modifier la facture si elle est lie a une commande-->
                        <v-btn :disabled="detailFacture.refCom != 'N/A' " v-if="detailFacture.etatFact === 0 && detailFacture.typeFact === true || detailFacture.typeFact === null && detailFacture.etatReglFact === false && detailFacture.etatFact === 0" slot="activator" icons color="primary" @click.stop="editerFacture();">Modifier <v-icon right>edit</v-icon></v-btn>
                        Modifier
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn slot="activator" icons color="orange" @click.stop="imprimerFacture(detailFacture);" dark>Imprimer <v-icon right>print</v-icon></v-btn>
                        Imprimer la facture
                    </v-tooltip>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL SHOW LIVRAISON -->
        <v-dialog v-model="dialogShowLivraison" max-width="70%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span>Détails de la livraison {{livraisonCourant.ref}} {{livraisonCourant.libelle}} </span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogShowLivraison = false, showBoat = false, showConteneurs = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text v-loading="loading" element-loading-text="Veuillez patientez ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <el-row :gutter="20" style="padding:10px;">
                        <el-col>
                            <el-card class="box-card">
                                <div class="grid-content" style="padding:3px;">
                                    <el-row>
                                        <div class="text item">
                                            <v-layout row justify>
                                                <v-flex md6>
                                                    <p><b>Identifiant : </b> {{ livraisonCourant.ref}} </p>
                                                    <p><b>Référence facture : </b> {{livraisonCourant.refact}}</p>
                                                    <p><b>Référence commande : </b> {{livraisonCourant.comRef}} {{livraisonCourant.libelle}}</p>
                                                    <p><b>Date de la livraison : </b> {{livraisonCourant.created}} </p>
                                                </v-flex>
                                                <v-flex md6>
                                                    <p><b>Etat : </b>
                                                        <v-chip text-color="white" label color="red" v-if="livraisonCourant.etat === false">
                                                            PARTIELLEMENT LIVRE<v-icon right></v-icon>
                                                        </v-chip>
                                                        <v-chip text-color="white" label color="green" v-if="livraisonCourant.etat === true">
                                                            TOTALEMENT LIVRE<v-icon right></v-icon>
                                                        </v-chip>
                                                    </p>
                                                    <p><b>Date d'enregistrement : </b> {{livraisonCourant.created}} </p>
                                                    <p><b>Date de modification : </b> {{livraisonCourant.modified}} </p>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>

                    <el-row :gutter="7" style="padding:10px;">
                        <el-card class="box-card">

                            <v-card>
                                <img height="100px" :src='livraisonCourant.imgLivraison' :alt="livraisonCourant.imgLivraison"/>
                                <v-card-actions>
                                    <v-btn target="_blank" :href="livraisonCourant.imgLivraison" flat color="orange">Voir le document</v-btn>
                                </v-card-actions>
                            </v-card>
                        </el-card>
                    </el-row>





                    <el-row :gutter="7" style="padding:10px;">
                        <el-card class="box-card">
                            <div class="grid-content" style="padding: 3px">
                                <el-row>
                                    <template>
                                        <el-table :data="livraisonCourant.livre" height="250" style="width: 100%">
                                            <el-table-column prop="produit" label="Ressource" width="280"></el-table-column>
                                            <el-table-column prop="qteL" label="Quantité livré"></el-table-column>
                                            <el-table-column prop="qteR" label="Quantité restant"></el-table-column>
                                        </el-table>
                                    </template>
                                </el-row>
                            </div>
                        </el-card>
                    </el-row>

                    <el-row :gutter="20" v-if="showBoat" style="padding:10px;">
                        <el-col>
                            <el-card class="box-card">
                                <div class="grid-content" style="padding:3px;">
                                    <el-row>
                                        <div class="text item">
                                            <v-layout row justify>
                                                <v-flex md6>
                                                    <p><b>Reference export : </b> {{detailLivraison[0].export}} </p>
                                                    <p><b>Numéro de commande : </b> {{detailLivraison[0].numComBat}} </p>
                                                    <p><b>Numéro BL : </b> {{detailLivraison[0].numBonLivraison}}  </p>
                                                    <p><b>Lieu de réception : </b> {{detailLivraison[0].recepetionConteneur}} </p>
                                                </v-flex>
                                                <v-flex md6>
                                                    <p><b>Numéro de chargement :  </b>
                                                        {{detailLivraison[0].numCpteLivraison}}
                                                    </p>
                                                    <p><b>Numéro de voyage :  </b>
                                                        {{detailLivraison[0].numVoyage}}
                                                    </p>
                                                    <p><b>Date d'enregistrement : </b> {{detailLivraison[0].created}}  </p>
                                                    <p><b>Date de modification : </b> {{detailLivraison[0].modified}} </p>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" v-if="showConteneurs" style="padding:10px;">
                        <el-table :data="detailLivraison[0].conteneurs" style="width: 100%">
                            <el-table-column type="expand">
                                <template slot-scope="props">
                                    <el-row>
                                        <el-col :span="5">
                                            <div class="grid-content bg-purple">

                                                    <b>Description</b> : <p>{{ props.row.description }}</p>

                                            </div>
                                        </el-col>

                                        <el-col :span="19">
                                            <div>
                                                <b>Articles</b> :
                                            </div>
                                            <div class="elevation-3">
                                                <el-table
                                                        :data="props.row.articles"
                                                        style="width: 100%">
                                                    <el-table-column
                                                            prop="code"
                                                            label="Code"
                                                    >
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="designation"
                                                            label="Désignation"
                                                    >
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="qte"
                                                            label="Quantité"
                                                    >
                                                    </el-table-column>
                                                    <el-table-column
                                                            prop="tourtes"
                                                            label="Tourtes">
                                                    </el-table-column>

                                                    <el-table-column
                                                            prop="metrage"
                                                            label="Metrage">
                                                    </el-table-column>

                                                    <el-table-column
                                                            prop="poidsBrute"
                                                            label="Poids Brut (kg)">
                                                    </el-table-column>

                                                    <el-table-column
                                                            prop="poidsNet"
                                                            label="Poids Net (kg)">
                                                    </el-table-column>

                                                    <el-table-column
                                                            prop="tare"
                                                            label="Tare (kg)">
                                                    </el-table-column>

                                                    <!-- <el-table-column label="ACTION" align="center" width="100" fixed="right">
                                                            <template slot-scope="scop">

                                                            <v-btn
                                                                :disabled="props.row.close"
                                                                @click.native="showDialogVersionEdit(scop.row)"
                                                                slot="activator"
                                                                color="orange"
                                                                fab
                                                                dark
                                                                small
                                                                >
                                                                <v-icon>edit</v-icon>

                                                                </v-btn>

                                                                <v-btn
                                                                @click.native="showDialogVersionDetail(scop.row)"
                                                                slot="activator"
                                                                color="primary"
                                                                fab
                                                                dark
                                                                small
                                                                >
                                                                <v-icon>description</v-icon>

                                                                </v-btn>
                                                            <v-btn
                                                                @click.native="supprimerArticle(scop.$index, props.row.articles)"
                                                                slot="activator"
                                                                color="red"
                                                                fab
                                                                dark
                                                                small
                                                                >
                                                                <v-icon>delete</v-icon>

                                                                </v-btn>
                                                            </template>
                                                        </el-table-column> -->
                                                </el-table>
                                            </div>
                                        </el-col>
                                    </el-row>
                                </template>
                            </el-table-column>


                            <el-table-column prop="marque" label="Marque" sortable>
                                <template slot-scope="item" >
                                    {{item.row.marque}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="numeroConte" label="Numéro Conteneur"> </el-table-column>
                            <el-table-column prop="numCle" label="Numéro clé"></el-table-column>
                            <el-table-column prop="type" label="Type"></el-table-column>
                            <el-table-column prop="poidsCargot" label="Poids cargot"></el-table-column>
                            <el-table-column prop="nbPacket" label="Nombre de packet"></el-table-column>
                            <el-table-column prop="tare" label="Tare"></el-table-column>
                            <el-table-column prop="mesure" label="Mesure"></el-table-column>
                            <!-- <el-table-column label="Operations">
                                <template slot-scope="scope">
                                    <v-tooltip top>
                                        <v-btn  slot="activator" @click="editConteneur(scope.row)" fab dark small color="orange">
                                            <v-icon dark>folder_open</v-icon>
                                        </v-btn>
                                        Détails
                                    </v-tooltip>
                                        <v-tooltip top>
                                        <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableConteneur)" dark>
                                            <v-icon center>delete</v-icon>
                                        </v-btn>
                                        Supprimer ce conteneur
                                    </v-tooltip>
                                </template>
                            </el-table-column> -->
                        </el-table>
                    </el-row>

                    <v-tooltip top>
                        <v-btn slot="activator" icons color="orange" @click.stop="dialogShowLivraison = false, showBoat = false, showConteneurs = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
                        Fermer
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn slot="activator" icons @click.stop="imprimerLivraison(livraisonCourant)" dark color="orange"> Imprimer <v-icon right>print</v-icon>
                        </v-btn>
                        Imprimer la livraison
                    </v-tooltip>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL SHOW MAINTENANCE -->
        <v-dialog v-model="dialogShowMaintenance" max-width="70%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span>Détails de la maintenance {{maintenanceCourant.ref}}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogShowMaintenance = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text v-loading="loading" element-loading-text="Veuillez patientez ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <el-row :gutter="20" style="padding:10px;">
                        <el-col :span="16">
                            <el-card class="box-card">
                                <div class="grid-content" style="padding:3px;">
                                    <el-row>
                                        <div class="text item">
                                            <v-layout row justify>
                                                <v-flex md6>
                                                    <p><b>Demandeur : </b> {{detailMaintenance.nomDemandeur}}</p>
                                                    <p><b>Date de l'intervention : </b> {{detailMaintenance.date}} </p>
                                                    <p><b>Début de l'intervention : </b> {{detailMaintenance.interventionDate}} à {{detailMaintenance.heureDebut}}</p>
                                                    <p><b>Fin de l'intervention : </b> {{detailMaintenance.interventionDateFin}} à {{detailMaintenance.interventionHeureFin}} </p>
                                                    <p><b>Contacts : </b> {{detailMaintenance.tel1}} / {{detailMaintenance.tel2}}</p>
                                                </v-flex>
                                                <v-flex md6>
                                                    <p><b>Statut : </b>
                                                        <v-chip outline text-color="red" label color="red" v-if='detailMaintenance.processus == true'>
                                                            FERMER <v-icon right>clear</v-icon>
                                                        </v-chip>
                                                        <v-chip outline text-color="green" label color="green" v-if='detailMaintenance.processus == false'>
                                                            OUVERT <v-icon right>insert_emoticon</v-icon>
                                                        </v-chip>
                                                    </p>
                                                    <p><b>Etat : </b>
                                                        <v-chip text-color="white" label :color="detailMaintenance.color">
                                                            {{detailMaintenance.etatDmd}}
                                                        </v-chip>
                                                    </p>
                                                    <p><b>Date d'enregistrement : </b> {{detailMaintenance.created}} </p>
                                                    <p><b>Date de modification : </b> {{detailMaintenance.modified}} </p>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card class="box-card">
                                <div class="grid-content" style="padding:3px;">
                                    <el-row>
                                        <div class="text item">
                                            <v-layout row justify v-for="item in detailMaintenance.files">
                                                <v-flex md12>
                                                    <a icons :click="item.url" target="_blank"><v-icon left>photo</v-icon> {{item.name}}</a>
                                                </v-flex>
                                            </v-layout>
                                        </div>
                                    </el-row>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>

                    <el-row :gutter="7" style="padding:10px;" v-if="longDevis !== 0">
                        <el-card class="box-card">
                            <div class="grid-content" style="padding: 3px">
                                <el-row>
                                    <template>
                                        <el-table :data="detailMaintenance.devis" height="250" style="width: 100%">
                                            <el-table-column prop="libelle" label="Désignation" width="280"></el-table-column>
                                            <el-table-column prop="cout" label="Prix unitaire (FCFA)"></el-table-column>
                                            <el-table-column prop="qte" label="Quantité"></el-table-column>
                                            <el-table-column prop="tva" label="TVA (18%)"></el-table-column>
                                        </el-table>
                                    </template>
                                </el-row>
                            </div>
                        </el-card>
                    </el-row>

                    <v-tooltip top>
                        <v-btn slot="activator" icons color="orange" @click.stop="dialogShowMaintenance = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
                        Fermer
                    </v-tooltip>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL SHOW FOURNISSEUR -->
        <v-dialog v-model="dialogShow" fullscreen :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>Détails du fournisseur {{fournCourant.nom}} {{fournCourant.pren}} </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="dialogShow = false; showFactureStatFour = false" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text>
                    <!--&lt;!&ndash; STATS &ndash;&gt;-->
                    <!--<el-row :gutter="20">-->
                    <!--<v-container fluid grid-list-md>-->
                    <!--<v-layout row justify>-->
                    <!--<v-flex md4>-->
                    <!--<div id="chartDepenseFourn" style="width: 450px; height: 300px"></div>-->
                    <!--</v-flex>-->
                    <!--<v-flex md4>-->
                    <!--<div id="chartCommandeFourn" style="width: 450px; height: 300px"></div>-->
                    <!--</v-flex>-->
                    <!--<v-flex md4>-->
                    <!--<div id="chartFactureFourn" style="width: 450px; height: 300px"></div>-->
                    <!--</v-flex>-->
                    <!--</v-layout>-->
                    <!--</v-container>-->
                    <!--</el-row>-->

                    <!--&lt;!&ndash; VIGNET &ndash;&gt;-->
                    <!--<el-row :gutter="20">-->
                    <!--<v-container fluid grid-list-md text-xs-center>-->
                    <!--<v-layout row justify>-->
                    <!--<v-flex md3>-->
                    <!--<v-chip outline text-color="indigo darken-4" label color="indigo darken-4" style="font-size:20px; width:100%">-->
                    <!--Commande : {{nbrComFourn}} <v-icon right>shopping_cart</v-icon>-->
                    <!--</v-chip>-->
                    <!--</v-flex>-->
                    <!--<v-flex md3>-->
                    <!--<v-chip outline text-color="primary" label color="primary" style="font-size:20px; width:100%">-->
                    <!--Facture : {{nbrFactFourn}} <v-icon right>note_add</v-icon>-->
                    <!--</v-chip>-->
                    <!--</v-flex>-->
                    <!--<v-flex md3>-->
                    <!--<v-chip outline text-color="green" label color="green" style="font-size:20px; width:100%">-->
                    <!--Livraison : {{nbrLivrFourn}} <v-icon right>redeem</v-icon>-->
                    <!--</v-chip>-->
                    <!--</v-flex>-->
                    <!--<v-flex md3>-->
                    <!--<v-chip outline text-color="red" label color="red" style="font-size:20px; width:100%">-->
                    <!--Dépenses : {{depenseFourn}} FCFA <v-icon right>monetization_on</v-icon>-->
                    <!--</v-chip>-->
                    <!--</v-flex>-->
                    <!--</v-layout>-->
                    <!--</v-container>-->
                    <!--</el-row>-->

                    <!-- DASHBOARB FACTURE -->
                    <v-container fluid grid-list-md >
                        <boardFactureFournisseur :idFour="fournCourant.id"    :show="showFactureStatFour"   ></boardFactureFournisseur>
                    </v-container>



                    <el-row :gutter="20">
                        <div class="grid-content" style=" padding:3px">
                            <el-row>
                                <el-tabs type="border-card">
                                    <el-tab-pane>
                                        <span slot="label"><v-icon right>ic_person</v-icon> Fiche</span>
                                        <div class="grid-content bg-purple">
                                            <div class="text item">
                                                <v-layout row justify>
                                                    <v-flex md3>
                                                        <p>
                                                            <v-flex text-xs-center layout align-center justify-center>
                                                                <v-avatar size="140px" class="grey lighten-4">
                                                                    <img v-if="detailFour.url" :src="detailFour.url" class="lazy" alt="">
                                                                    <img v-else src="http://archipro-v2.prodestic.net/webservice/web/uploads/avatars/default-avarta.png" class="lazy" alt="">
                                                                </v-avatar>
                                                            </v-flex>
                                                        </p>
                                                        <p><b>Identifiant : </b> {{detailFour.ref}} </p>
                                                        <p><b v-if="detailFour.type == 0">Raison sociale : </b><b v-if="detailFour.type == 1">Nom et prénoms : </b> <span v-if="detailFour.type == 1">{{detailFour.civilite}}</span> {{detailFour.nom}} {{detailFour.pren}} </p>
                                                    </v-flex>
                                                    <v-flex md3>
                                                        <p v-if="detailFour.formJuridique != null"><b>Forme juridique : </b> {{detailFour.formJuridique}} </p>
                                                        <p v-if="detailFour.dateNais != null"><b>Date de naissance : </b> {{detailFour.dateNais}} </p>
                                                        <p><b>Type de fournisseur : </b>
                                                            <v-chip text-color="white" label color="primary" v-if="detailFour.type == 1">
                                                                PARTICULIER<v-icon right>account_circle</v-icon>
                                                            </v-chip>
                                                            <v-chip text-color="white" label color="indigo darken-4" v-if="detailFour.type == 0">
                                                                ENTREPRISE<v-icon right>business</v-icon>
                                                            </v-chip>
                                                        </p>
                                                        <p><b>Rôle du fournisseur : </b>
                                                            <v-chip outline text-color="orange" label color="orange" v-if="detailFour.typeFour == 1">
                                                                FOURNISSEUR<v-icon right></v-icon>
                                                            </v-chip>
                                                            <v-chip outline text-color="indigo" label color="indigo darken-4" v-if="detailFour.typeFour == 2">
                                                                PRESTATAIRE<v-icon right></v-icon>
                                                            </v-chip>
                                                            <v-chip outline text-color="green" label color="green" v-if="detailFour.typeFour == 3">
                                                                FOURNISSEUR ET PRESTATAIRE<v-icon right></v-icon>
                                                            </v-chip>
                                                        </p>
                                                        <p><b>Login de connexion :</b> {{detailFour.email}}</p>
                                                        <p v-if="detailFour.formJuridique != null"><b>Forme juridique : </b> {{detailFour.formJuridique}} </p>
                                                        <p v-if="detailFour.dateNais != null"><b>Date de naissance : </b> {{detailFour.dateNais}} </p>
                                                    </v-flex>
                                                    <v-flex md3>
                                                        <p v-if="detailFour.registreComm != null"><b>Régistre de commerce : </b> {{detailFour.registreComm}} </p>
                                                        <p v-if="detailFour.lieuNais != null"><b>Lieu de naissance : </b> {{detailFour.lieuNais}} </p>
                                                        <p v-if="detailFour.contact != null"><b v-if="detailFour.type == 0">tél bureau : </b><b v-if="detailFour.type == 1">Contact : </b> {{detailFour.contact}} </p>
                                                        <p v-if="detailFour.siege != null"><b>Siège : </b> {{detailFour.siege}} </p>
                                                        <p v-if="detailFour.nationalite != null"><b>Nationalité : </b> {{detailFour.nationalite}} </p>
                                                        <p v-if="detailFour.domicile != null"><b>Domicile : </b> {{detailFour.domicile}} </p>
                                                        <p v-if="detailFour.naturePiece != null"><b>Nature de la pièce : </b> {{detailFour.naturePiece}} </p>
                                                        <p v-if="detailFour.representant != null"><b>Représentant légal : </b> {{detailFour.representant}} </p>
                                                        <p v-if="detailFour.contactGerant != null"><b>Contact : </b> {{detailFour.contactGerant}} </p>
                                                        <p v-if="detailFour.numPiece != null"><b>Numéro de la pièce : </b> {{detailFour.numPiece}} </p>
                                                    </v-flex>
                                                    <v-flex md3>
                                                        <p v-if="detailFour.dateDeliv != null"><b>Date de délivrance : </b> {{detailFour.dateDeliv}} </p>
                                                        <p v-if="detailFour.dateExpi != null"><b>Date d'expiration : </b> {{detailFour.dateExpi}} </p>
                                                        <p><b>Activité : </b> {{detailFour.service}} </p>
                                                        <p><b>Profession : </b> {{detailFour.profession}} </p>
                                                        <p><b>Métier : </b> {{detailFour.metier}} </p>
                                                        <p><b>Date de création : </b> {{detailFour.created}} </p>
                                                        <p><b>Enregistré par: </b> {{detailFour.userCreated}} </p>
                                                        <p><b>Date de modification : </b> {{detailFour.modified}} </p>
                                                    </v-flex>
                                                </v-layout>
                                            </div>
                                        </div>
                                    </el-tab-pane>

                                    <el-tab-pane>
                                        <span slot="label"><v-icon right>shopping_cart</v-icon> Commande</span>
                                        <!-- LISTE DES COMMANDES -->
                                        <div>
                                            <v-card-title>
                                                <v-chip text-color="white" label color="primary">
                                                    LISTE DES 10 DERNIERES COMMANDES AJOUTEES <v-icon right>shopping_cart</v-icon>
                                                </v-chip>
                                                <v-chip outline text-color="primary" label color="primary">
                                                    TOTAL DES COMMANDES : {{totalCommande}} FCFA <v-icon right>monetization_on</v-icon>
                                                </v-chip>
                                                <v-spacer></v-spacer>
                                            </v-card-title>
                                            <v-card-text>
                                                <div class="text-xs-center">
                                                    <v-layout row>                                                      
                                                        <v-flex xs12 class="text-xs-right">
                                                            <v-tooltip top>
                                                                <v-btn
                                                                    v-if="this.nombreSelection.length >=2" @click="imprimerFuCom()"
                                                                    slot="activator"
                                                                    color="orange"
                                                                    dark
                                                                >
                                                                    Imprimer en un
                                                                    <v-icon right>print</v-icon>
                                                                </v-btn> Imprimer en un seul bon de commande
                                                                </v-tooltip>

                                                                <v-tooltip top>
                                                                    <v-btn v-if="this.nombreSelection.length >=1" slot="activator" color="green" @click.stop="generateFile('excel', 'simple')"
                                                                        dark>
                                                                        Exporter en Excel
                                                                        <v-icon right>file_upload</v-icon>
                                                                    </v-btn>Excel
                                                                </v-tooltip>



                                                                <v-tooltip top>
                                                                    <v-btn slot="activator" @click="loadCommande(detailFour)" fab dark small color="primary">
                                                                        <v-icon dark>search</v-icon>
                                                                    </v-btn>
                                                                    Afficher la liste de toutes les commandes
                                                                </v-tooltip>
                                                        </v-flex><br>
                                                    </v-layout>
                                                </div>


                                                <data-tables  highlight-current-rowref="multipleTable" @selection-change="handleSelectionChange"
                                                 :data="listCommande" style="width: 100%">
                                                  <el-table-column
                                                  :selectable="besoinSelect"
                                                    width="55"
                                                    type="selection"
                                                  ></el-table-column>
                                                    <el-table-column prop="ref" label="Référence">
                                                      <template slot-scope="scope">
                                                          <v-chip text-color="white" label color="primary">
                                                            {{ scope.row.ref }}
                                                        </v-chip>
                                                      </template>
                                                    </el-table-column>
                                                    <el-table-column prop="projet" label="Projet / Entrepot">
                                                      <template slot-scope="scope">
                                                          <v-chip text-color="white" label color="orange">
                                                            {{ scope.row.projet ? scope.row.projet : scope.row.libEntrepot}}
                                                        </v-chip>
                                                      </template>
                                                    </el-table-column>
                                                    <el-table-column prop="libelle" label="Description"></el-table-column>
                                                    <el-table-column prop="dateC" label="Date commande">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="primary">
                                                                {{ scope.row.dateC }}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="total" label="Montant">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="orange">
                                                                {{ scope.row.total }} FCFA<v-icon right></v-icon>
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="etat" label="Etat">
                                                        <template slot-scope="scope">
                                                            <!-- <v-chip text-color="white" label color="orange" v-if="scope.row.factureValide === 0">
                                                                EN ATTENTE DE VALIDATION<v-icon right></v-icon>
                                                            </v-chip> -->
                                                            <v-chip text-color="white" label color="green" v-if="scope.row.factureValide === 1">
                                                                FACTURE VALIDE<v-icon right></v-icon>
                                                            </v-chip>
                                                            <v-chip text-color="white" label color="red" v-if="scope.row.factureValide === 2">
                                                                FACTURE REJETE<v-icon right></v-icon>
                                                            </v-chip>
                                                            <v-chip text-color="white" label color="red" v-if="scope.row.etat === false">
                                                                NON LIVRE<v-icon right></v-icon>
                                                            </v-chip>
                                                            <v-chip text-color="white" label color="green" v-if="scope.row.etat == true">
                                                                LIVRE EN TOTALITE<v-icon right></v-icon>
                                                            </v-chip>



                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="compare" label="Comparateur" >
                                                        <template v-if="scope.row.compare == 2" slot-scope="scope">
                                                            <a href="#" >
                                                                <v-avatar  :tile="true" size="50px" height="50px" color="grey lighten-4"> <img src="static/validComparateur.png" ></v-avatar>
                                                            </a>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Action" fixed="right">
                                                        <template slot-scope="scope">
                                                            <div class="text-xs-center">
                                                                <v-tooltip v-if="scope.row.factureValide === 0 && scope.row.compare != 2 && scope.row.factureExiste !== true" >
                                                                    <v-btn slot="activator" @click.stop="editCommande(scope.row,'affecter')" fab dark small color="indigo">
                                                                        <v-icon dark>cached</v-icon>
                                                                    </v-btn>
                                                                    Affecter a un autre fournisseur
                                                                </v-tooltip>
                                                                  <v-tooltip top v-if="scope.row.factureValide === 2">
                                                                    <v-btn  slot="activator" @click.stop="editCommande(scope.row); commReactiv = scope.row.id;" fab dark small color="red">
                                                                        <v-icon dark>cached</v-icon>
                                                                    </v-btn>
                                                                    Reprendre
                                                                </v-tooltip>
                                                                <v-tooltip top>
                                                                    <v-btn  slot="activator" @click.stop="showCommande(scope.row)" fab dark small color="green">
                                                                        <v-icon dark>folder_open</v-icon>
                                                                    </v-btn>
                                                                    Détails
                                                                </v-tooltip>
                                                                <v-tooltip top>
                                                                    <v-btn v-if="scope.row.factureValide === 0 && scope.row.compare != 2 && scope.row.factureExiste !== true" slot="activator" @click.stop="editCommande(scope.row)" fab dark small color="blue">
                                                                        <v-icon dark>edit</v-icon>
                                                                    </v-btn>
                                                                    Modifier
                                                                </v-tooltip>
                                                                <v-tooltip top>
                                                                    <v-btn  v-if="scope.row.compare == 0  &&  scope.row.factureExiste !== true"  slot="activator" @click.stop="disableCaisse  = false;newFacture(scope.row);" fab dark small color="grey">
                                                                    <!-- <v-btn  slot="activator" @click.stop="disableCaisse  = false;newFacture(scope.row);" fab dark small color="grey"> -->
                                                                        <v-icon dark>note_add</v-icon>
                                                                    </v-btn>
                                                                    Faire la facture
                                                                </v-tooltip>
                                                                <v-tooltip top>
                                                                    <v-btn  slot="activator" @click.stop="imprimerCommande(scope.row)" fab dark small color="orange">
                                                                        <v-icon dark>print</v-icon>
                                                                    </v-btn>
                                                                    Imprimer
                                                                </v-tooltip>
                                                                <v-tooltip top>
                                                                    <v-btn v-if="scope.row.etatRefaire == false && scope.row.factureValide != 2 && scope.row.factureExiste == false" slot="activator" @click.stop="dialogSuprComm = true, idComm = scope.row.id, fournCourant" fab dark small color="red">
                                                                        <v-icon dark>delete</v-icon>
                                                                    </v-btn>
                                                                    Supprimer
                                                                </v-tooltip>
                                                                <v-tooltip top>
                                                                  <v-btn v-if="scope.row.compare != 2  && scope.row.etatRefaire == true  && scope.row.factureValide != 1 && scope.row.factureValide != 2 && scope.row.factureExiste !== true" slot="activator" @click="showDialogComparaison(scope.row)" fab dark small color="cyan">
                                                                  <v-icon dark>compare_arrows</v-icon>
                                                                  </v-btn>
                                                                  Effectuer une comparaison
                                                                </v-tooltip>
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                </data-tables>
                                            </v-card-text>
                                        </div>
                                    </el-tab-pane>

                                    <el-tab-pane >
                                        <span slot="label"><v-icon right>note_add</v-icon> Devis / Facture</span>
                                        <!-- LISTE DES FACTURES -->
                                        <div>
                                            <v-card-title>
                                                <v-chip text-color="white" label color="primary">
                                                    LISTE DES 10 DERNIERES FACTURES AJOUTEES <v-icon right>note_add</v-icon>
                                                </v-chip>
                                                <v-chip outline text-color="primary" label color="primary">
                                                    TOTAL DES FACTURES : {{totalFacture}} FCFA <v-icon right>monetization_on</v-icon>
                                                </v-chip>
                                                <v-spacer></v-spacer>
                                            </v-card-title>
                                            <v-card-text>
                                                <div class="text-xs-center">
                                                    <v-layout row>
                                                        <!-- <v-flex v-if="droitAcces.imprime_pdf_histo_fournisseur_liste_four">
                                                            <el-popover ref="popProjet" placement="top" width="180" trigger="hover">
                                                                <p>Veuillez choisir le format d'impression ?</p>
                                                                <div style="text-align: right; margin: 0">
                                                                    <el-button type="success" size="mini" @click="imprimeListeHisFourFacture('PDF')">PDF</el-button>
                                                                    <el-button type="primary" size="mini" @click="imprimeListeHisFourFacture('EXC')">EXCEL</el-button>
                                                                </div>
                                                            </el-popover>
                                                            <div>
                                                                <el-button v-popover:popProjet type="warning" :disabled="disabledBtnF" icon="el-icon-printer" >Rapport
                                                                </el-button>
                                                            </div>
                                                        </v-flex> -->
                                                        <v-flex md4 class="mr-1">
                                                            <div class="text-xs-right">
                                                                <v-tooltip top>
                                                                    <v-btn  slot="activator" @click="loadFacture(detailFour)" fab dark small color=#455a64>
                                                                        <v-icon dark>search</v-icon>
                                                                    </v-btn>
                                                                    Afficher la liste de toutes les factures
                                                                </v-tooltip>
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                </div>

                                                <data-tables :data="listFacture" style="width: 100%">
                                                    <el-table-column prop="ref" label="Référence">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="orange">
                                                                {{ scope.row.ref }}
                                                            </v-chip>
                                                            <v-chip text-color="white" v-if="scope.row.ref2 !=''" label color="primary">
                                                                {{ scope.row.ref2 }}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="libelle" label="Description"></el-table-column>
                                                    <el-table-column prop="total" label="Montant">
                                                        <template slot-scope="scope">
                                                            <v-chip outline text-color="primary" label color="primary">
                                                                {{ scope.row.total }} FCFA<v-icon right></v-icon>
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="etat" label="Etat" width="400">
                                                        <template slot-scope="scope">
                                                            <v-chip outline text-color="orange" label color="orange" v-if="scope.row.etatFact === 0">
                                                                EN ATTENTE DE VALIDATION<v-icon right></v-icon>
                                                            </v-chip>
                                                            <v-chip outline text-color="green" label color="green" v-if="scope.row.etatFact === 1">
                                                                VALIDE<v-icon right></v-icon>
                                                            </v-chip>
                                                            <v-chip outline text-color="red" label color="red" v-if="scope.row.etatFact === 2">
                                                                REJETE<v-icon right></v-icon>
                                                            </v-chip>
                                                            <v-chip v-if="scope.row.etat === 'IMPAYE'" text-color="white" label color="red">
                                                                {{scope.row.etat}}
                                                            </v-chip>
                                                            <v-chip v-if="scope.row.etat === 'PAYE'" text-color="white" label color="green">
                                                                {{scope.row.etat}}
                                                            </v-chip>
                                                            <v-chip v-if="scope.row.etat === 'EN COURS DE PAIEMENT'" text-color="white" label color="orange">
                                                                {{scope.row.etat}}
                                                            </v-chip>
                                                            <v-chip v-if="scope.row.etat === 'EN ATTENTE DE PAIEMENT'" text-color="white" label color="primary">
                                                                {{scope.row.etat}}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Action" fixed="right" width="340">
                                                        <template slot-scope="scope">
                                                            <div class="text-xs-center">
                                                                <v-tooltip top>
                                                                  <v-btn v-if="scope.row.etatFact !== 0 && scope.row.etatFact !== 2 && scope.row.typeFact === true && scope.row.etat === false" slot="activator" @click.stop="dialogSUppFacture = true; idFacture = scope.row.id" fab dark small color="red">
                                                                  <v-icon dark>delete</v-icon>
                                                                  </v-btn>
                                                                  Annuler facture 
                                                                </v-tooltip>

                                                                <v-tooltip top>
                                                                    <v-btn  slot="activator" @click.prevent="showFacture(scope.row)" fab dark small color="green">
                                                                        <v-icon dark>folder_open</v-icon>
                                                                    </v-btn>
                                                                    Détails
                                                                </v-tooltip>
                                                                <!--<v-tooltip top>-->
                                                                <!--<v-btn v-if="scope.row.etatFact === 0 && scope.row.typeFact === true || scope.row.typeFact === null && scope.row.etatReglFact === false && scope.row.etatFact === 0" slot="activator" @click.stop="editFacture(scope.row)" fab dark small color="blue">-->
                                                                <!--<v-icon dark>edit</v-icon>-->
                                                                <!--</v-btn>-->
                                                                <!--Modifier-->
                                                                <!--</v-tooltip>-->
                                                                <!--<v-tooltip top>-->
                                                                <!--<v-btn v-if="droitAcces.valider_facture && scope.row.etatFact === 0 && scope.row.typeFact !== false" slot="activator" @click.stop="validFacture(scope.row)" fab dark small color="green">-->
                                                                <!--<v-icon dark>done_all</v-icon>-->
                                                                <!--</v-btn>-->
                                                                <!--Valider-->
                                                                <!--</v-tooltip>-->

                                                                <!-- <v-tooltip top>
                                                                  <v-btn v-if="scope.row.etatFact !== 0 && scope.row.etatFact !== 2 && scope.row.typeFact === true && scope.row.etat === false" slot="activator" @click.stop="editFacture(scope.row)" fab dark small color="blue">
                                                                  <v-icon dark>edit</v-icon>
                                                                  </v-btn>
                                                                  Modifier 
                                                                </v-tooltip> -->

                                                                <!-- RORO CE QUI ETAIT LA AVANT -->
                                                                 <v-tooltip top>
                                                                    <v-btn v-if="scope.row.etatFact !== 0 && scope.row.etatFact !== 2 && scope.row.typeFact === true && scope.row.etat === false" slot="activator" @click.stop="newLivraison(scope.row)" fab dark small color="primary">
                                                                        <v-icon dark>card_giftcard</v-icon>
                                                                    </v-btn>
                                                                    Livraison
                                                                </v-tooltip>
                                                                <v-tooltip top>
                                                                    <v-btn  slot="activator" @click.stop="imprimerFacture(scope.row)" fab dark small color="orange">
                                                                        <v-icon dark>print</v-icon>
                                                                    </v-btn>
                                                                    Imprimer
                                                                </v-tooltip>
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                </data-tables>
                                            </v-card-text>
                                        </div>
                                    </el-tab-pane>

                                    <el-tab-pane >
                                        <span slot="label"><v-icon right>redeem</v-icon> Livraison</span>
                                        <!-- LISTE DES LIVRAISONS -->
                                        <div>
                                            <v-card-title>
                                                <v-chip text-color="white" label color="primary">
                                                    LISTE DES 10 DERNIERES LIVRAISONS AJOUTEES <v-icon right>redeem</v-icon>
                                                </v-chip>
                                                <v-spacer></v-spacer>
                                            </v-card-title>
                                            <v-card-text>
                                                <div class="text-xs-center">
                                                    <v-layout row>
                                                        <!-- <v-flex >
                                                            <el-popover ref="popProjet" placement="top" width="180" trigger="hover">
                                                                <p>Veuillez choisir le format d'impression ?</p>
                                                                <div style="text-align: right; margin: 0">
                                                                    <el-button type="success" size="mini" @click="imprimeListeHisFourLivraison('PDF')">PDF</el-button>
                                                                    <el-button type="primary" size="mini" @click="imprimeListeHisFourLivraison('EXC')">EXCEL</el-button>
                                                                </div>
                                                            </el-popover>
                                                            <div>
                                                                <el-button v-popover:popProjet type="warning" :disabled="disabledBtnL" icon="el-icon-printer" >Rapport
                                                                </el-button>
                                                            </div>
                                                        </v-flex> -->
                                                        <v-flex md4 class="mr-1">
                                                            <div class="text-xs-right">
                                                                <v-tooltip top>
                                                                    <v-btn  slot="activator" @click="loadLivraison(detailFour)" fab dark small color=#455a64>
                                                                        <v-icon dark>search</v-icon>
                                                                    </v-btn>
                                                                    Afficher la liste de toutes les livraisons
                                                                </v-tooltip>
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                </div>

                                                <data-tables :data="listLivraison" style="width: 100%">
                                                    <el-table-column prop="ref" label="Référence">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="green">
                                                                {{ scope.row.ref }}
                                                            </v-chip>
                                                              <v-chip text-color="white" v-if="scope.row.refact !=''" label color="orange">
                                                                  {{ scope.row.refact }}
                                                              </v-chip>
                                                             <v-chip text-color="white" v-if="scope.row.comRef !=''" label color="primary">
                                                                {{ scope.row.comRef }}
                                                            </v-chip>

                                                        </template>
                                                    </el-table-column>
                                                    <!-- <el-table-column prop="livreur" label="Livreur">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="primary">
                                                                {{ scope.row.livreur }}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column> -->
                                                    <el-table-column prop="date" label="Date livraison">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="orange">
                                                                {{ scope.row.date }}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="etat" label="Etat" width="400">
                                                        <template slot-scope="scope">
                                                            <v-chip outline text-color="primary" label color="primary">
                                                                {{ scope.row.comRef }} {{ scope.row.libelle }} <v-icon right></v-icon>
                                                            </v-chip>
                                                            <v-chip v-if="scope.row.etat === false" outline text-color="orange" label color="orange">
                                                                PARTIELLEMENT LIVRE <v-icon right></v-icon>
                                                            </v-chip>
                                                            <v-chip v-if="scope.row.etat === true" outline text-color="green" label color="green">
                                                                TOTALEMENT LIVRE <v-icon right></v-icon>
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Action" fixed="right" width="340">
                                                        <template slot-scope="scope">
                                                            <div class="text-xs-center">

                                                                <v-tooltip top>
                                                                    <v-btn  slot="activator" @click.stop="showLivraison(scope.row)" fab dark small color="green">
                                                                        <v-icon dark>folder_open</v-icon>
                                                                    </v-btn>
                                                                    Détails
                                                                </v-tooltip>
                                                                <v-tooltip top>
                                                                    <v-btn v-if="scope.row.nbrAppro === 0" slot="activator" @click.stop="newAppro(scope.row)" fab dark small color="primary">
                                                                        <v-icon dark>add_shopping_cart</v-icon>
                                                                    </v-btn>
                                                                    Approvisionner
                                                                </v-tooltip>
                                                                <v-tooltip top>
                                                                    <v-btn  slot="activator" @click.stop="imprimerLivraison(scope.row)" fab dark small color="orange">
                                                                        <v-icon dark>print</v-icon>
                                                                    </v-btn>
                                                                    Imprimer
                                                                </v-tooltip>
                                                            </div>
                                                        </template>
                                                    </el-table-column>
                                                </data-tables>
                                            </v-card-text>
                                        </div>
                                    </el-tab-pane>

                                    <el-tab-pane >
                                        <span slot="label"><i class="el-icon-news"></i> Tarifications</span>
                                        <!-- LISTE DES PRODUITS -->
                                        <div>
                                            <v-card-title>
                                                <v-chip text-color="white" label color="primary">
                                                    LISTE DES 10 DERNIERES TARIFICATIONS AJOUTEES
                                                </v-chip>
<!--
                                                <v-flex xs3>
                                                    <el-col :span="2" >
                                                        <el-popover
                                                                ref="popover5"
                                                                placement="top"
                                                                width="180"
                                                                trigger="hover">
                                                            <p>Veuillez choisir le format d'impression ?</p>
                                                            <div style="text-align: right; margin: 0">
                                                                <el-button type="success" size="mini" @click="imprimeListTarif('PDF')">PDF</el-button>
                                                                <el-button type="primary" size="mini" @click="imprimeListTarif('EXC')">EXCEL</el-button>
                                                            </div>
                                                        </el-popover>
                                                        <div>
                                                            <el-button v-popover:popover5 type="warning"
                                                                       icon="el-icon-printer" >Imprimer la liste
                                                            </el-button>
                                                        </div>
                                                    </el-col>
                                                </v-flex> -->
                                                <v-flex md4 class="mr-1">
                                                    <div class="text-xs-right">
                                                        <v-tooltip top>
                                                            <v-btn slot="activator" @click="loadProduitFoun(detailFour)" fab dark small color=#455a64>
                                                                <v-icon dark>search</v-icon>
                                                            </v-btn>
                                                            Afficher la liste de toutes les tarifications
                                                        </v-tooltip>
                                                    </div>
                                                </v-flex>
                                                <v-spacer></v-spacer>
                                                <v-tooltip top>
                                                    <v-btn slot="activator" icons color="primary" @click.stop="newTarif()" dark>Ajouter <v-icon right>add</v-icon></v-btn>
                                                    Ajouter
                                                </v-tooltip>
                                            </v-card-title>
                                            <v-layout row class="mb-3 mt-1">
                                               <v-flex md4 class="mr-1">
                                                <el-select name="typeProduit" id="typeProduit"  v-model="prodSelct"  @change="filtrerTypeTarification()" @clear="clearSelect4()" clearable filterable placeholder="Type ressource" style="width:100%">
                                                    <el-option v-for="item in listTypeRessource" :key="item.id" :label="item.libelle" :value="item.libelle">
                                                    </el-option>
                                              </el-select>
                                            </v-flex>

                                                <v-flex md4 class="mr-1" v-if="prodSelct != ''">
                                                    <el-select clearable filterable  @change="filtrerTarification()"  v-model="produiS" placeholder="Rechercher une produit" style="width:100%">
                                                        <el-option v-for="item in comboProduit" :key="item.id" :label="item.libelle" :value="item.id">
                                                        </el-option>
                                                    </el-select>
                                                </v-flex>

                                            <v-flex md8 class="mr-1">
                                                <v-flex xs12 class="text-xs-right">
                                          <v-tooltip top>
                                                <input
                                                 name="fileInputExcel"
                                                  type="file"
                                                  style="display:none"
                                                  ref="fileInputExcel"
                                                  accept="image/*"
                                                  v-on:change="onFileExcelPicked"
                                                />
                                                <v-btn
                                                    v-if="true"
                                                    slot="activator"
                                                    color="green"
                                                    @click.stop="$refs.fileInputExcel.click()"
                                                    dark
                                                >
                                                    Importer
                                                    <v-icon right>file_download</v-icon>
                                                </v-btn>Importer fichier excel
                                          </v-tooltip>

                                           <v-tooltip top>
                                          <v-btn
                                              v-if="true"
                                              slot="activator"
                                              color="orange"
                                              @click.stop="dialogImport = true"
                                              dark
                                          >
                                              Générer
                                              <v-icon right>file_upload</v-icon>
                                          </v-btn>Générer un modèle
                                          </v-tooltip>
                                                </v-flex>
                                            </v-flex>

                                            </v-layout>
                                            <v-card-text>
                                                <data-tables :data="listProduit" stripe border height="350" style="width: 100%">
                                                   <el-table-column prop="codeGestion" label="Code gestion">
                                                        <template slot-scope="scope">
                                                          <v-chip text-color="white" label color="indigo">
                                                                 {{scope.row.codeGestion}}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="type" label="Type de ressources">
                                                        <template slot-scope="scope">
                                                          <v-chip text-color="white" label color="orange">
                                                                 {{scope.row.type}}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="libelle" label="Libellé" width="480" >
                                                        <template slot-scope="scope">
                                                            <v-chip outline text-color="primary" label color="primary">
                                                                {{scope.row.libelle}}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="prixAchat" label="Prix d'achat">
                                                        <template slot-scope="scope">
                                                            <v-chip outline text-color="primary" label color="primary">
                                                                {{Intl.NumberFormat().format(scope.row.prixAchat) }} FCFA
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="unite" label="Unité">
                                                        <template slot-scope="scope">
                                                            <v-chip outline text-color="primary" label color="primary">
                                                                {{scope.row.unite}}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="ACTION" align="center" fixed="right">
                                                        <template slot-scope="scope">
                                                            <v-tooltip top>
                                                                    <v-btn  slot="activator" @click.stop="showTarif(scope.row)" fab dark small color="green">
                                                                        <v-icon dark>folder_open</v-icon>
                                                                    </v-btn>
                                                                    Détails
                                                            </v-tooltip>
                                                            <v-btn  icons color="primary"  @click="editTarif(scope.row)" fab dark small> <v-icon>edit</v-icon>
                                                            </v-btn>
                                                             <v-btn  icons color="red"  @click="deleteTarif(scope.row)" fab dark small> <v-icon>delete</v-icon>
                                                            </v-btn>
                                                        </template>
                                                    </el-table-column>
                                                </data-tables>
                                            </v-card-text>
                                        </div>
                                    </el-tab-pane>

                                    <el-tab-pane>
                                        <span slot="label"><v-icon right>shopping_cart</v-icon> Contrat de sous-traitance</span>
                                        <!-- LISTE DES COMMANDES -->
                                        <div>
                                            <v-card-title>
                                                <v-chip text-color="white" label color="primary">
                                                    LISTE DES TRAVAUX ET TACHE SOUS TRAITES <v-icon right>shopping_cart</v-icon>
                                                </v-chip>
                                                <v-chip outline text-color="primary" label color="primary">
                                                    TOTAL CONTRAT  : {{totalContrat}} FCFA <v-icon right>monetization_on</v-icon>
                                                </v-chip>
                                                <v-chip outline text-color="primary" label color="primary">
                                                    TOTAL VERSE  : {{totalVerse}} FCFA <v-icon right>monetization_on</v-icon>
                                                </v-chip>
                                                <v-chip outline text-color="primary" label color="primary">
                                                    TOTAL RESTANT  : {{totalRestant}} FCFA <v-icon right>monetization_on</v-icon>
                                                </v-chip>
                                                <v-spacer></v-spacer>
                                            </v-card-title>
                                            <v-card-text>
                                                <div class="text-xs-center">
                                                    <v-layout row>
                                                        <v-flex>
                                                            <el-popover ref="popOver" placement="top" width="180" trigger="hover">
                                                                <p>Veuillez choisir le format d'impression ?</p>
                                                                <div style="text-align: right; margin: 0">
                                                                    <el-button type="success" size="mini" @click="imprimeListeHisContra('PDF')">PDF</el-button>
                                                                    <el-button type="primary" size="mini" @click="imprimeListeHisContra('EXC')">EXCEL</el-button>
                                                                </div>
                                                            </el-popover>
                                                            <div>
                                                                <el-button v-popover:popOver type="warning" icon="el-icon-printer" >Rapport
                                                                </el-button>
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                </div>

                                                <data-tables :data="listContrat" >

                                                    <el-table-column prop="idContrat" label="Contrat">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="primary">
                                                                ID-{{ scope.row.idContrat }}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>


                                                    <el-table-column prop="projet" label="Projet/Chantier/travaux/tache">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="primary">
                                                                {{ scope.row.projet }}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>


                                                    <el-table-column prop="mntEstime" label="Montant">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="orange">
                                                                {{ new Intl.NumberFormat('fr-Fr').format(scope.row.mntEstime)  }} FCFA<v-icon right></v-icon>
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>


                                                    <el-table-column prop="mntVerse" label="Montant versé">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="orange">
                                                                {{  new Intl.NumberFormat('fr-Fr').format(scope.row.mntVerse) }} FCFA<v-icon right></v-icon>
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>


                                                    <el-table-column prop="mntReelAVerse" label="Montant restant">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="orange">
                                                                {{ new Intl.NumberFormat('fr-Fr').format(scope.row.mntReelAVerse)  }} FCFA<v-icon right></v-icon>
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>


                                                    <el-table-column prop="dateD" label="Date Début - fin">
                                                        <template slot-scope="scope">
                                                            <v-chip text-color="white" label color="primary">
                                                                {{ scope.row.dateD }} - {{ scope.row.dateF }}
                                                            </v-chip>
                                                        </template>
                                                    </el-table-column>


                                                    <el-table-column label="EVOLUTION" align="center">
                                                        <template slot-scope="scope">
                                                            <v-progress-circular :size="80" :width="15" :rotate="360" :value="scope.row.evolution" color="orange">
                                                                {{scope.row.evolution}} %
                                                            </v-progress-circular>
                                                        </template>
                                                    </el-table-column>



                                                    <el-table-column label="Action" fixed="right" width="140">
                                                        <template slot-scope="scope" >
                                                            <div class="text-xs-center">
                                                                <v-tooltip top>
                                                                    <v-btn  slot="activator" @click.stop="showDetailContrat(scope.row.idContrat)" fab dark small color="green">
                                                                        <v-icon dark>folder_open</v-icon>
                                                                    </v-btn>
                                                                    Détails
                                                                </v-tooltip>
                                                            </div>
                                                        </template>
                                                    </el-table-column>

                                                </data-tables>
                                            </v-card-text>
                                        </div>


                                        <!--MODAL DE CONTRAT-->
                                        <v-dialog v-model="dialogInfoContrat" :persistent="true"  fullscreen transition="dialog-bottom-transition" scrollable>
                                            <v-card tile>
                                                <v-toolbar card dark color="primary">

                                                    <v-toolbar-title >FICHE CONTRAT</v-toolbar-title>
                                                    <v-spacer></v-spacer>
                                                    <v-btn icon dark @click.native="dialogInfoContrat = false">
                                                        <v-icon>close</v-icon>
                                                    </v-btn>
                                                </v-toolbar>

                                                <v-card-text>
                                                    <v-layout row class="mb-5 mt-2 elevation-3 pt-4 pl-2 pr-2 pb-4">
                                                        <!--Information personnelles-->
                                                        <v-flex xs7 class="mr-2 ml-2">
                                                            <v-layout wrap>
                                                                <v-flex xs12>
                                                                    <h4 mt-2>INFORMATION GENERALE</h4>
                                                                    <v-divider class="mb-3"></v-divider>
                                                                </v-flex>
                                                                <v-flex xs12>
                                                                    <v-layout row>
                                                                        <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                                            <v-layout wrap>
                                                                                <v-flex xs12>
                                                                                    <v-layout row>
                                                                                        <v-flex xs6>Identifiant</v-flex>
                                                                                        <v-flex xs6 class="text-xs-right title red--text ">
                                                                                            Contrat-{{detailContrat.idContrat}}
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                    <v-divider class="mb-3"></v-divider>


                                                                                    <v-layout row>
                                                                                        <v-flex xs2>Projet</v-flex>
                                                                                        <v-flex xs10 class="text-xs-right title">
                                                                                            {{detailContrat.libProjet}}
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                    <v-divider class="mb-3"></v-divider>


                                                                                    <v-layout row>
                                                                                        <v-flex xs6>Chantier</v-flex>
                                                                                        <v-flex xs6 class="text-xs-right title">
                                                                                            {{detailContrat.chantier}}
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                    <v-divider class="mb-3"></v-divider>

                                                                                    <v-layout row>
                                                                                        <v-flex xs6>Travaux</v-flex>
                                                                                        <v-flex xs6 class="text-xs-right title">
                                                                                            {{detailContrat.libTravaux}}
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                    <v-divider class="mb-3"></v-divider>
                                                                                       <v-layout row>
                                                                                        <v-flex xs6>Prestataire</v-flex>
                                                                                        <v-flex xs6 class="text-xs-right title red--text">
                                                                                            {{detailContrat.prestataire}}
                                                                                        </v-flex>
                                                                                    </v-layout>


                                                                                    <v-divider class="mb-3"></v-divider>




                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </v-flex>

                                                                        <v-flex xs6 class="mr-4"> <!--COLONNE 2-->
                                                                            <v-layout wrap>
                                                                                <v-flex xs12>

                                                                                   <v-layout row v-if="detailContrat.libTache !=''">
                                                                                        <v-flex xs6>Tache</v-flex>
                                                                                        <v-flex xs6 class="text-xs-right title">
                                                                                            {{detailContrat.libTache}}
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                    <v-divider class="mb-3"></v-divider>

                                                                                    <v-layout row>
                                                                                        <v-flex xs6>Caisse concernée</v-flex>
                                                                                        <v-flex xs6 class="text-xs-right title">
                                                                                            {{detailContrat.caisse}}
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                    <v-divider class="mb-3"></v-divider>

                                                                                    <v-layout row>
                                                                                        <v-flex xs6>Banque concernée</v-flex>
                                                                                        <v-flex xs6 class="text-xs-right title">
                                                                                            <!-- {{detailContrat.banque}} -->
                                                                                            <span v-for="(item, index) in detailContrat.banque " :key="index">
                                                                                                  {{ item }} /
                                                                                            </span>
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                    <v-divider class="mb-3"></v-divider>
                                                                                    <v-layout row>
                                                                                        <v-flex xs3>Date Dbt et fin</v-flex>
                                                                                        <v-flex xs9 class="text-xs-right title">
                                                                                            {{detailContrat.dateDbt}} / {{detailContrat.dateFin}}
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                    <v-divider class="mb-3"></v-divider>

                                                                                    <v-layout row>
                                                                                        <v-flex xs6>Créé le</v-flex>
                                                                                        <v-flex xs6 class="text-xs-right title">
                                                                                            {{detailContrat.dateCreated}}
                                                                                        </v-flex>
                                                                                    </v-layout>
                                                                                    <v-divider class="mb-3"></v-divider>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-flex>

                                                            </v-layout>

                                                        </v-flex>


                                                        <!--EVOLUTION-->
                                                        <v-flex xs5 class="text-xs-center" >
                                                            <v-layout row class="text-xs-center">
                                                                <v-flex sm6 class="text-xs-center">
                                                                    <v-progress-circular :size="200" :width="20" :rotate="360" :value="detailContrat.evolution" color="teal">
                                                                        {{detailContrat.evolution}} %
                                                                    </v-progress-circular>
                                                                    <div class="subheading teal--text">Evolution physique</div>
                                                                </v-flex>

                                                                <v-flex sm6 class="text-xs-center">
                                                                    <v-progress-circular :size="180" :width="30" :rotate="360" :value="detailContrat.evolution" color="primary">
                                                                        {{detailContrat.evolutionFinance}} %
                                                                    </v-progress-circular>
                                                                    <div  class="subheading primary--text">Evolution financière</div>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>

                                                      <v-flex sm12 class="elevation-3  pt-3 pl-3 pr-3 pb-3"  v-if="detailContrat.taches !=''">
                                                            <!--Historique des TACHES-->
                                                            <v-layout wrap>
                                                                <v-flex xs12>
                                                                    <h4 mt-2>LISTES DES TACHES</h4>
                                                                    <v-divider class="mb-3"></v-divider>
                                                                </v-flex>

                                                                <v-flex xs12>
                                                                    <data-tables
                                                                            highlight-current-row
                                                                            :header-row-style="headerRowStyle"
                                                                            :data="detailContrat.taches" style="width:99%;">
                                                                        <el-table-column prop="refFact" label="TACHE A REALISER" align="left" >
                                                                             <template slot-scope="scope">
                                                                                <v-chip
                                                                                  outline
                                                                                  label
                                                                                  text-color="primary"
                                                                                  color="primary"
                                                                                  >{{ scope.row.tacheLibelle }}</v-chip
                                                                                >
                                                                              </template>
                                                                           </el-table-column>
                                                                           <el-table-column
                                                                              label="DATE ET INTERVAL DE TEMPS"
                                                                              align="center"
                                                                            >
                                                                              <el-table-column
                                                                                prop="dateD"
                                                                                label="Début"
                                                                                width="190"
                                                                              ></el-table-column>
                                                                              <el-table-column
                                                                                prop="dateF"
                                                                                label="Fin"
                                                                                width="190"
                                                                              ></el-table-column>
                                                                              <el-table-column
                                                                                prop="duree"
                                                                                label="Durée (Jours) "
                                                                                width="120"
                                                                              >
                                                                                <template slot-scope="scope">
                                                                                  <v-chip text-color="white" color="primary"
                                                                                    >{{ scope.row.duree }} Jour(s)</v-chip
                                                                                  >
                                                                                </template>
                                                                              </el-table-column>
                                                                            </el-table-column>
                                                                             <el-table-column label="ETAT GLOBAL" width="120">
                                                                              <template slot-scope="scope">
                                                                                <v-progress-circular
                                                                                  :size="80"
                                                                                  :width="15"
                                                                                  :rotate="360"
                                                                                  :value="scope.row.evolution"
                                                                                  color="green"
                                                                                  >{{
                                                                                    scope.row.evolution
                                                                                  }}
                                                                                  %</v-progress-circular
                                                                                >
                                                                              </template>
                                                                            </el-table-column>
                                                                            <el-table-column label="ETAT" width="150">
                                                                              <template slot-scope="scope">
                                                                                <v-chip
                                                                                  v-if="scope.row.etat == 0"
                                                                                  label
                                                                                  text-color="white"
                                                                                  color="red"
                                                                                  >EN ATTENTE</v-chip
                                                                                >
                                                                                <v-chip
                                                                                  v-if="scope.row.etat == 1"
                                                                                  label
                                                                                  text-color="white"
                                                                                  color="primary"
                                                                                  >EN EXECUTION</v-chip
                                                                                >
                                                                                <v-chip
                                                                                  v-if="scope.row.etat == 2"
                                                                                  label
                                                                                  text-color="white"
                                                                                  color="green"
                                                                                  >TERMINE</v-chip
                                                                                >

                                                                                <v-chip
                                                                                  v-if="scope.row.etat == 3"
                                                                                  label
                                                                                  text-color="white"
                                                                                  color="green"
                                                                                  >ARRETE</v-chip
                                                                                >
                                                                              </template>
                                                                            </el-table-column>
                                                                    </data-tables>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>

                                                    <v-layout wrap class="mt-4">
                                                        <v-flex sm12>
                                                            <v-layout row >
                                                                <v-flex class="mb-1" xs4 md4 >
                                                                    <v-card-text class="text-xs-center">
                                                                        <v-chip
                                                                                label
                                                                                outline
                                                                                color="primary darken-1"
                                                                                class="elevation-4"
                                                                                style="width:100%"
                                                                        >
                                                                            <span class="subheading">Total contrat : </span>
                                                                            <span class="title"> &nbsp;  {{ new Intl.NumberFormat().format(detailContrat.mntTotal)}} </span>
                                                                            <v-icon right>monetization_on</v-icon>
                                                                        </v-chip>

                                                                    </v-card-text>
                                                                </v-flex>

                                                                <v-flex class="mb-1" xs4 md4 >
                                                                    <v-card-text class="text-xs-center">
                                                                        <v-chip
                                                                                label
                                                                                outline
                                                                                color="green darken-1"
                                                                                class="elevation-4"
                                                                                style="width:100%"
                                                                        >
                                                                            <span class="subheading">Verse: </span>
                                                                            <span class="title"> &nbsp;  {{ new Intl.NumberFormat().format(detailContrat.mntVerse)}} </span>
                                                                            <v-icon right>monetization_on</v-icon>
                                                                        </v-chip>
                                                                    </v-card-text>
                                                                </v-flex>

                                                                <v-flex class="mb-1" xs4 md4 >
                                                                    <v-card-text class="text-xs-center">
                                                                        <v-chip
                                                                                label
                                                                                outline
                                                                                color="orange darken-1"
                                                                                class="elevation-4"
                                                                                style="width:100%"
                                                                        >
                                                                            <span class="subheading">Restant : </span>
                                                                            <span class="title"> &nbsp; {{ new Intl.NumberFormat().format(detailContrat.mntRestant)}} </span>
                                                                            <v-icon right>monetization_on</v-icon>
                                                                        </v-chip>
                                                                    </v-card-text>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex sm12 class="elevation-3  pt-3 pl-3 pr-3 pb-3" >
                                                            <!--Historique des factures-->
                                                            <v-layout wrap>
                                                                <v-flex xs12>
                                                                    <h4 mt-2>HISTORIQUE DES FACTURES DU CONTRAT</h4>
                                                                    <v-divider class="mb-3"></v-divider>
                                                                </v-flex>

                                                                <v-flex xs12>
                                                                    <el-table
                                                                            highlight-current-row
                                                                            show-summary
                                                                            :summary-method="getSommeFact"
                                                                            :header-row-style="headerRowStyle"
                                                                            :data="detailContrat.factures" style="width:99%;">
                                                                        <el-table-column prop="refFact" label="REFERENCE" align="left" > </el-table-column>
                                                                        <el-table-column prop="libelleFact" label="LIBELLE" align="left" >
                                                                            <template slot-scope="scope" >
                                                                                <span class="blue--text body-2">{{scope.row.libelleFact}}</span>
                                                                            </template>
                                                                        </el-table-column>

                                                                        <el-table-column prop="datePaiement" label="DATE DE PAIEMENT" align="left" ></el-table-column>

                                                                        <el-table-column prop="etatLibFacture" label="ETAT" align="center" >
                                                                            <template slot-scope="scope" >
                                                                                <el-tag v-if="scope.row.etatLibFacture == 'En attente'"  >{{scope.row.etatLibFacture}}</el-tag>
                                                                                <el-tag   v-else-if="scope.row.etatLibFacture == 'Payé'"  type="success">{{scope.row.etatLibFacture}}</el-tag>
                                                                                <el-tag   v-else-if="scope.row.etatLibFacture == 'Impayé'"  type="danger">{{scope.row.etatLibFacture}}</el-tag>
                                                                                <el-tag   v-else-if="scope.row.etatLibFacture == 'En cours'"  type="warning">{{scope.row.etatLibFacture}}</el-tag>
                                                                                <el-tag   v-else-if="scope.row.etatLibFacture == 'Validation en attente'"  type="info">{{scope.row.etatLibFacture}}</el-tag>
                                                                                <el-tag   v-else-if="scope.row.etatLibFacture == 'Réfusé'"  type="danger">{{scope.row.etatLibFacture}}</el-tag>
                                                                            </template>
                                                                        </el-table-column>

                                                                        <el-table-column prop="mntFacture" label="TOTAL" align="left" >
                                                                            <template slot-scope="scope">
                                                                                 <span>
                                                                                     {{ new Intl.NumberFormat().format(scope.row.mntFacture ) }}
                                                                                 </span>
                                                                            </template>
                                                                        </el-table-column>

                                                                        <el-table-column prop="mntFatureVerse" label="VERSE" align="left" >
                                                                            <template slot-scope="scope">
                                                                                 <span >
                                                                                     {{ new Intl.NumberFormat().format(scope.row.mntFatureVerse)  }}
                                                                                 </span>
                                                                            </template>
                                                                        </el-table-column>

                                                                        <el-table-column prop="mntFatureRestant" label="RESTANT" align="left" >
                                                                            <template slot-scope="scope">
                                                                                <span v-if="scope.row.mntFatureRestant > 0" style="color: #E6A23C; font-size:16px" >{{new Intl.NumberFormat().format(scope.row.mntFatureRestant)}}</span>
                                                                                <span v-else  >{{new Intl.NumberFormat().format(scope.row.mntFatureRestant)}}</span>
                                                                            </template>
                                                                        </el-table-column>




                                                                    </el-table>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>




                                            </v-card>
                                        </v-dialog>
                                        <!-- FIN MODAL DE CONTRAT-->
                                    </el-tab-pane>


                                </el-tabs>
                            </el-row>
                        </div>
                        <br/>
                    </el-row>

                    <v-tooltip top>
                        <v-btn slot="activator" icons color="orange" @click.stop="dialogShow = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
                        Fermer
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn slot="activator" icons color="primary" @click.stop="editFourn(fournCourant);" dark>Modifier <v-icon right>edit</v-icon></v-btn>
                        Modifier
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn slot="activator" icons color="indigo darken-4" @click.stop="newCommande(fournCourant);" dark>Commande <v-icon right>shopping_cart</v-icon></v-btn>
                        Créer une commande
                    </v-tooltip>
                    <v-tooltip top>
                        <v-btn  slot="activator" icons color="primary" @click.stop="newFactureFact(fournCourant);" dark>Devis / Facture <v-icon right>note_add</v-icon></v-btn>
                        Créer devis / facture
                    </v-tooltip>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL SHOW TYPE PROJET -->
    <v-dialog
      v-model="dialogShowTarif"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title
            >Détails de la tarification de la ressource {{tarifCourant.libelle}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowTarif = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content bg-purple">
              <el-card class="box-card" style="background:#F9FAFC">
                <div class="text item">
                  <v-layout row wrap>
                    <v-flex md6>
                      <p><b>Ressource concerné : </b> {{tarifCourant.libelle}}</p>
                      <p><b>Prix d'achat : </b>
                       {{Intl.NumberFormat().format(tarifCourant.prixAchat) }} FCFA</p>
                       <p>
                        <b>Code gestion:</b>
                        {{tarifCourant.codeGestion}}
                      </p>
                      <p>
                        <b>Unité :</b>
                        {{tarifCourant.unite}}
                      </p>
                    </v-flex>
                    <v-flex md6>

                      <p>
                        <b>Date de modification :</b>
                        {{tarifCourant.modified}}
                      </p>
                       <p>
                        <b>Dernier prix renseigné :</b>
                         {{Intl.NumberFormat().format(tarifCourant.prixOld) }} FCFA
                      </p>
                       <p>
                        <b>Modifier par :</b>
                        {{tarifCourant.userUpdate}}
                      </p>
                       <p>
                        <b>Date d'enregistrement :</b>
                        {{tarifCourant.created}}
                      </p>
                      <p>
                        <b>Enrregistrer par :</b>
                        {{tarifCourant.userCreated}}
                      </p>
                    </v-flex>
                  </v-layout>
                </div>
              </el-card>

              <!-- <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  color="orange"
                  @click.stop="dialogShowTarif = false"
                  dark
                  >Fermer <v-icon right>close</v-icon></v-btn
                >
                Fermer
              </v-tooltip>
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  color="primary"
                  @click.stop="editTypeProjet(detailTypeProjet)"
                  dark
                  >Mofifier <v-icon right>edit</v-icon></v-btn
                >
                Modifier
              </v-tooltip> -->
            </div>
          </el-row>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


      <!-- MODAL REACTIVATION DE LA COMMANDE -->
        <v-dialog v-model="dialogReactiv" max-width="50%" :overlay="true" scrollable persistent>
            <v-card>
                <v-card-text text-xs-center>
                    <h3 align="center">Voulez-vous réactiver cette commande ?</h3>
                    <p align="center">
                        <v-btn @click.native="dialogReactiv = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                        <v-btn icons color="red" @click.stop="refaireCommande()" dark>Confirmer <v-icon right>check</v-icon></v-btn>
                    </p>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
        
        <!-- MODAL SUPRIMER UNE FACTURE DEJA VALIER -->
        <v-dialog v-model="dialogSUppFacture" max-width="50%" :overlay="true" scrollable persistent>
            <v-card>
                <v-card-text text-xs-center>
                    <h3 align="center">Voulez-vous suprimer cette facture ?</h3>
                    <p align="center">
                        <v-btn @click.native="dialogSUppFacture = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                        <v-btn icons color="red" @click.stop="deleteFacture()" dark>Confirmer <v-icon right>check</v-icon></v-btn>
                    </p>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL SUPPRESSION FOURNISSEUR -->
        <v-dialog v-model="dialogSupr" max-width="50%" :overlay="true" scrollable persistent>
            <v-card>
                <v-card-text text-xs-center>
                    <h3 align="center">Voulez-vous vraiment supprimer cet enregistrement ?</h3>
                    <p align="center">
                        <v-btn @click.native="dialogSupr = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                        <v-btn icons color="red" @click.stop="deleteFourn" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
                    </p>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

        <!-- MODAL SUPPRESSION COMMANDE -->
        <v-dialog v-model="dialogSuprComm" max-width="50%" :overlay="true" scrollable persistent>
            <v-card>
                <v-card-text text-xs-center>
                    <h3 align="center">Voulez-vous vraiment supprimer cet enregistrement ?</h3>
                    <p align="center">
                        <v-btn @click.native="dialogSuprComm = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                        <v-btn icons color="red" @click.stop="deleteCommande" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
                    </p>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>

          <!-- MODAL SUPPRESSION TARIFICATION -->
        <v-dialog v-model="dialogSupTarif" max-width="50%" :overlay="true" scrollable persistent>
          <v-card>
            <v-card-text text-xs-center>
              <h1 align="center">Voulez-vous vraiment supprimer "{{this.selectProduit }}" de la Tarification ?</h1>
              <p align="center">
                <v-btn @click.native="dialogSupTarif = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                <v-btn icons color="red" @click.stop="deleteTarification" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
              </p>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>

        <!-- TABLEAU -->
        <v-card v-if="user.type === 1 || user.type === 0">
            <div>
                <v-chip text-color="white" label color="primary">
                    LISTE DES 10 DERNIERS FOURNISSEURS AJOUTES <v-icon right>assignment</v-icon>
                </v-chip>

                <!-- BTN AJOUT -->
                <v-spacer></v-spacer>
                <div class="text-xs-right">
                    <v-layout row>
                        <v-flex v-if="user.type === 1 || user.type === 0">
                            <div class="text-xs-right">
                                <el-dropdown @command="handleCommandFour">
                                    <el-button type="primary">
                                        Ajouter fournisseur<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command=1>Personne physique</el-dropdown-item>
                                        <el-dropdown-item command=0>Personne morale</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>


                            </div>
                        </v-flex>
                    </v-layout>
                </div>

                <v-card-text>
                    <v-flex xs12 >
                        <v-layout row class="mb-4 mt-1">

                            <v-flex md4 class="mr-1">
                                <el-select @clear="clearSelect1()"   v-if="etatAffichage == 1" clearable filterable   @change="filtrerMetier()" v-model="chantierS" placeholder="Selectionner un Metier" style="width:100%">
                                    <el-option v-for="item in comboMetier" :key="item.id" :label="item.libelle" :value="item.id">
                                    </el-option>
                                </el-select>
                            </v-flex>
                            <v-flex md4 class="mr-1">
                                <el-select @clear="clearSelect2()"   v-if="etatAffichage == 1" clearable filterable  @change="filtrerProfession()"  v-model="projetS" placeholder="Selectionner une Profession" style="width:100%">
                                    <el-option v-for="item in comboProfession" :key="item.id" :label="item.profession" :value="item.id">
                                    </el-option>
                                </el-select>
                            </v-flex>
                            <v-flex md4 class="mr-1">

                                <div class="text-xs-right">

                                    <v-tooltip top>
                                        <v-btn
                                            v-if="true"
                                            slot="activator"
                                            color="orange"
                                            @click.stop="generateListeFourFileExcel()"
                                            dark
                                        >
                                            Exporter
                                            <v-icon right>file_upload</v-icon>
                                        </v-btn>Exporter la liste des fournisseurs
                                    </v-tooltip>

                                    <v-tooltip top>
                                        <v-btn slot="activator" @click="loadFourn()" fab dark small color=#455a64>
                                            <v-icon dark>search</v-icon>
                                        </v-btn>
                                        Afficher la liste de tous les fournisseurs
                                    </v-tooltip>
                                </div>
                            </v-flex>

                        </v-layout>
                        <v-layout row class="mb-4 mt-1" >
                            <v-flex md4 class="mr-1">
                                <el-select @clear="clearSelect3()" v-if="etatAffichage == 1" clearable filterable  @change="filtrerFournisseur()"  v-model="fourniS" placeholder="Rechercher un Fournisseur" style="width:100%">
                                    <el-option v-for="item in comboFournisseur" :key="item.id" :label="item.libelle" :value="item.id">
                                    </el-option>
                                </el-select>
                            </v-flex>
                        </v-layout>

                    </v-flex>
                    <data-tables :data="listFour"  style="width: 100%">
                     <el-table-column prop="ref" v-if="false" label="Réference">
                            <template slot-scope="scope">
                                {{scope.row.ref }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="photo" label="Photo" width="100" fixed="left">
                            <template slot-scope="scope">
                                <v-avatar>
                                    <img v-if="scope.row.url" :src="scope.row.url" class="lazy" alt="">
                                    <img v-else src="http://elbtp.archipro.ci/webservice/web/uploads/avatars/default-avarta.png" class="lazy" alt="">
                                </v-avatar>
                            </template>
                        </el-table-column>
                        <el-table-column prop="nom" label="Raison sociale / Nom et prénoms">
                            <template slot-scope="scope">
                                <v-chip outline text-color="primary" label color="primary">
                                    {{scope.row.nom }} {{scope.row.pren }} <v-icon right>business</v-icon>
                                </v-chip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" label="Type">
                            <template slot-scope="scope">
                                <v-chip text-color="white" label color="primary" v-if="scope.row.type == 1">
                                    PARTICULIER<v-icon right>account_circle</v-icon>
                                </v-chip>
                                <v-chip text-color="white" label color="indigo darken-4" v-if="scope.row.type == 0">
                                    ENTREPRISE<v-icon right>business</v-icon>
                                </v-chip>
                                <v-chip outline text-color="orange" label color="orange" v-if="scope.row.typeFour == 1">
                                    FOURNISSEUR<v-icon right></v-icon>
                                </v-chip>
                                <v-chip outline text-color="indigo" label color="indigo darken-4" v-if="scope.row.typeFour == 2">
                                    PRESTATAIRE<v-icon right></v-icon>
                                </v-chip>
                                <v-chip outline text-color="green" label color="green" v-if="scope.row.typeFour == 3">
                                    FOURNISSEUR ET PRESTATAIRE<v-icon right></v-icon>
                                </v-chip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="contact" label="Contact">
                            <template slot-scope="scope">
                                <v-chip text-color="white" color="orange">
                                    {{scope.row.contact}}
                                </v-chip>
                            </template>
                        </el-table-column>
                        <el-table-column label="Action" fixed="right">
                            <template slot-scope="scope">
                                <div class="text-xs-center">
                                    <v-tooltip top>
                                        <v-btn slot="activator"  @click.stop="showFourn(scope.row); loadCommandeRecent(scope.row.id); loadFactureRecent(scope.row.id); loadLivraisonRecent(scope.row.id); loadMaintenanceRecent(scope.row); loadProduitFounRecent(scope.row); loadContrat(scope.row)" fab dark small color="green">
                                            <v-icon dark>folder_open</v-icon>
                                        </v-btn>
                                        Détails
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <v-btn  slot="activator" @click="editFourn(scope.row)" fab dark small color="primary">
                                            <v-icon dark>edit</v-icon>
                                        </v-btn>
                                        Modifier
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <v-btn slot="activator" @click="dialogSupr = true; idFourn = scope.row.id;" fab dark small color="red">
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                        Supprimer
                                    </v-tooltip>
                                </div>
                            </template>
                        </el-table-column>
                    </data-tables>
                </v-card-text>
            </div>
        </v-card>
        <v-card v-else-if="user.type === 3">
            <div>
                <v-card-title>
                    <v-chip text-color="white" label color="primary">
                        PRESTATAIRE : {{user.nom}} <v-icon right>assignment</v-icon>
                    </v-chip>
                    <v-spacer></v-spacer>

                </v-card-title>
                <v-card-text>
                    <v-data-table v-bind:headers="headers" v-bind:search="search" :items="listFournConnect" class="elevation-1">
                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                                <span>
                  {{ props.header.text }}
                </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" scope="props">
                            <td>
                                <v-avatar>
                                    <img v-if="props.item.url" :src="props.item.url" class="lazy" alt="">
                                    <img v-else src="http://archipro-v2.prodestic.net/webservice/web/uploads/avatars/default-avarta.png" class="lazy" alt="">
                                </v-avatar>
                            </td>
                            <td class="text-xs-center">{{ props.item.nom }} {{ props.item.pren }}</td>
                            <td class="text-xs-center">
                                <v-chip text-color="white" label color="primary" v-if="props.item.type == 1">
                                    PARTICULIER<v-icon right>account_circle</v-icon>
                                </v-chip>
                                <v-chip text-color="white" label color="indigo darken-4" v-if="props.item.type == 0">
                                    ENTREPRISE<v-icon right>business</v-icon>
                                </v-chip>
                                <v-chip outline text-color="orange" label color="orange" v-if="props.item.typeFour == 1">
                                    FOURNISSEUR<v-icon right></v-icon>
                                </v-chip>
                                <v-chip outline text-color="indigo" label color="indigo darken-4" v-if="props.item.typeFour == 2">
                                    PRESTATAIRE<v-icon right></v-icon>
                                </v-chip>
                                <v-chip outline text-color="green" label color="green" v-if="props.item.typeFour == 3">
                                    FOURNISSEUR ET PRESTATAIRE<v-icon right></v-icon>
                                </v-chip>
                            </td>
                            <td class="text-xs-center">{{ props.item.contact }}</td>
                            <td class="text-xs-center">
                                <div class="text-xs-center">
                                    <v-tooltip top>
                                        <v-btn  slot="activator" @click.stop="showFourn(props.item); loadCommandeRecent(props.item.id); loadFactureRecent(props.item.id); loadLivraisonRecent(props.item.id); loadStatsPieCommandeFourn(props.item); loadMaintenanceRecent(props.item); loadProduitFounRecent(props.item)" fab dark small color="green">
                                            <v-icon dark>folder_open</v-icon>
                                        </v-btn>
                                        Détails
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <v-btn  slot="activator" @click.stop="editFourn(props.item)" fab dark small color="blue">
                                            <v-icon dark>edit</v-icon>
                                        </v-btn>
                                        Modifier
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <v-btn  slot="activator" @click.stop="dialogSupr = true; idFourn = props.item.id;" fab dark small color="red">
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                        Supprimer
                                    </v-tooltip>
                                </div>
                            </td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </div>
        </v-card>
        <p align="center" v-else>
            <v-chip text-color="white" label color="red" style="width: 100%; font-size: 23px">
                VOUS N'AVEZ PAS LES AUTORISATIONS REQUISES POUR VOIR LA LISTE DES FOURNISSEURS.
                CONTACTER L'ADMINISTRATEUR
                <v-icon dark right>stop_screen_share</v-icon>
            </v-chip>
        </p>
        <!-- DIALOG RESUME MONTANT COMMAMDE -->
        <div class="text-xs-center">
            <v-dialog v-model="dialogMontantCommande"  width="50%">
                <v-flex xs12>
                    <v-card>
                        <v-card-title
                                class="headline primary lighten-2 white--text"
                                primary-title
                        >
                            Calcul des montants de la commande
                        </v-card-title>
                        <v-card-text>
                            <v-list two-line class="pa-0">

                                <v-list-tile >
                                    <v-list-tile-action>
                                        <v-icon color="indigo">attach_money</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Montant total Hors Taxe sans remise (fcfa)</v-list-tile-title>
                                        <v-list-tile-sub-title></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <span class="title">{{totalComHTSR}}</span>

                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider inset></v-divider>
                                
                                <v-list-tile v-if="totalRabais != 0">
                                    <v-list-tile-action>
                                        <v-icon color="indigo">attach_money</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Montant total rabais (fcfa)</v-list-tile-title>
                                        <v-list-tile-sub-title></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <span class="title">{{totalRabais}}</span>

                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider inset></v-divider>
                                <v-list-tile >
                                    <v-list-tile-action>
                                        <v-icon color="indigo">attach_money</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Montant total net (fcfa)</v-list-tile-title>
                                        <v-list-tile-sub-title></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <span class="title">{{totalComHT}}</span>

                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider inset></v-divider>
                                <v-list-tile >
                                    <v-list-tile-action>
                                        <v-icon color="indigo">attach_money</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Montant total REMISE(fcfa)</v-list-tile-title>
                                        <v-list-tile-sub-title></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <span class="title">{{totalComRemise}}</span>

                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider inset></v-divider>
                                <v-list-tile >
                                    <v-list-tile-action>
                                        <v-icon color="indigo">attach_money</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Montant total RETENU (fcfa)</v-list-tile-title>
                                        <v-list-tile-sub-title></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <span class="title">{{totalComRetenu}}</span>

                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider inset></v-divider>
                                <v-list-tile >
                                    <v-list-tile-action>
                                        <v-icon color="indigo">attach_money</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Montant total TVA (fcfa)</v-list-tile-title>
                                        <v-list-tile-sub-title></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <span class="title">{{totalComTVA}}</span>

                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-divider inset></v-divider>

                                <v-list-tile >
                                    <v-list-tile-action>
                                        <v-icon color="indigo">attach_money</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>Montant total TTC (fcfa)</v-list-tile-title>
                                        <v-list-tile-sub-title></v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <span class="title red--text">{{totComLigneTTCFormat}}</span>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                    color="red"
                                    dark
                                    @click=" dialogMontantCommande = false"
                            >
                                Annuler
                            </v-btn>
                            <v-btn :disabled="loading"
                                    color="green"
                                    dark
                                    @click="submitComm()"
                            >
                                Valider
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-dialog>
        </div>
        <!--  MODAL COMPARAISON DE COMMANDE-->
        <v-dialog v-model="dialogComparaison" transition="dialog-bottom-transition" scrollable :loading="loading" fullscreen hide-overlay>
            <v-card>
                <v-toolbar card dark color="primary">
                    <v-toolbar-title>Fiche de proposition de commande </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="dialogComparaison = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout>
                        <v-flex>
                            <v-card color="" class="mb-5" flat >
                                <v-layout wrap>
                                    <!-- TAB COMMANDE INITIAL -->
                                    <v-flex xs12>
                                        <v-alert  :value="true" color="grey" outline icon="info">
                                            DETAILS DE LA COMMANDE INITIALE
                                        </v-alert>
                                        <v-card color="" class="mb-5" >
                                            <v-card-text>
                                                <v-layout wrap>
                                                    <v-flex xs12>
                                                        <v-chip style="font-size:20px" label outline color="green"><b>Total (TTC): {{ new Intl.NumberFormat().format(totCommandeInit)  }} fcfa</b></v-chip>
                                                    </v-flex>

                                                    <v-flex xs12>
                                                        <el-table :data="commandeInit.option" style="width: 100%">
                                                            <el-table-column prop="libelle" label="LIBELLE" sortable></el-table-column>
                                                            <el-table-column prop="unite" label="UNITE" sortable></el-table-column>
                                                            <el-table-column prop="qte" label="QUANTITE"></el-table-column>
                                                            <el-table-column prop="prix" label="PRIX UNITAIRE">
                                                                <template slot-scope="scope">
                                                                    <el-tag >  {{new Intl.NumberFormat().format(scope.row.prix)}}</el-tag>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column prop="tva" label="TVA" ></el-table-column>
                                                            <el-table-column prop="total" label="TOTAL" >
                                                                <template slot-scope="scope">
                                                                    <el-tag >  {{new Intl.NumberFormat().format(scope.row.total)}}</el-tag>
                                                                </template>
                                                            </el-table-column>
                                                        </el-table>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>

                                    <!-- TAB COMMANDES DERIVEES PROPOSEES -->
                                    <v-flex xs12>
                                        <v-alert  :value="true" color="purple" outlin icon="warning">
                                            LISTE DES COMMANDES SUGGEREES
                                        </v-alert>

                                        <v-layout wrap class="mb-3">
                                            <v-flex xs8 >
                                                <v-chip label outline   color="orange darken-1"  class="elevation-4" style="width:90%">
                                                    <span class="subheading">Montant total economisé: &nbsp;  </span> <span class="title"> {{ totalBenefice}} Fcfa </span>
                                                </v-chip>
                                            </v-flex>
                                        </v-layout>

                                        <p v-for="(cmdDeri, index) in commandeDeriv" :key="index">
                                            <v-card v-for="(CmdD, index) in cmdDeri" :key="index"  color="" class="mb-5" >
                                                <v-card-text>
                                                    <v-layout wrap>

                                                        <v-flex xs12>
                                                          <v-chip label outline color="green darken-1"  class="elevation-4 text-xs-left" style="width:100%">
                                                              <span class="subheading">Commande à passer chez le fournisseur : &nbsp; </span> <span class="title text-xs-left"  >  {{ index }} </span>
                                                          </v-chip>
                                                            <!-- <h6 class="display-6">Commande à passer chez le fournisseur: {{ index }} </h6> -->
                                                        </v-flex>

                                                        <v-flex xs12>
                                                            <el-table :data="CmdD" style="width: 100%">
                                                                <el-table-column prop="libelleProduit" label="LIBELLE" sortable></el-table-column>
                                                                <el-table-column prop="unite" label="UNITE" sortable></el-table-column>
                                                                <el-table-column prop="qteProd" label="QUANTITE"></el-table-column>
                                                                <el-table-column prop="prixU" label="PRIX UNITAIRE">
                                                                    <template slot-scope="scope">
                                                                        <el-tag >  {{ new Intl.NumberFormat().format(scope.row.prixU)}}</el-tag>
                                                                    </template>
                                                                </el-table-column>
                                                                <el-table-column prop="tva" label="TVA" ></el-table-column>
                                                                <el-table-column prop="mntTotal" label="TOTAL" >
                                                                    <template slot-scope="scope">
                                                                        <el-tag >  {{ new Intl.NumberFormat().format(scope.row.mntTotal)}}</el-tag>
                                                                    </template>
                                                                </el-table-column>
                                                                <el-table-column prop="beneficeFormat" label="GAIN (Fcfa)" >
                                                                    <template slot-scope="scope">
                                                                        <el-tag>  {{ scope.row.beneficeFormat}}</el-tag>
                                                                    </template>
                                                                </el-table-column>

                                                            </el-table>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </p>

                                    </v-flex>

                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>

            <v-tooltip top v-if="totalBenefice != 0">
                <v-btn class="mb-5" style="margin-right: 30px" absolute @click="validCommd = true" slot="activator" dark fab large bottom right color="green">
                    <v-icon>check</v-icon>
                </v-btn>
                <span>Valider toutes les propositions</span>
            </v-tooltip>
        </v-dialog>

        <el-dialog
                title="Liste des Ressources"
                :visible.sync="dialogProdNull"
                width="70%">
            <div>
                <el-alert
                        title="Fournisseur ou Prix d'achat non renseigné"
                        type="warning"
                        :closable="false"
                        description="Le(s) ressource(s) suivant ne possède(nt) ancun fournisseur ou un prix d'achat, aucune commande n'a été générée pour ces ressources, Veuillez renseigner ces informations"
                        show-icon>
                </el-alert>
            </div>
            <div>
                <el-table :data="listeProdNull">
                    <el-table-column property="libelleProduit" label="Ressource"></el-table-column>
                    <el-table-column property="prixU" label="Montant" >
                        <template slot-scope="scope">
                            <el-input-number v-model="scope.row.prixU" :min="0" size="small" controls-position="right" />
                        </template>
                    </el-table-column>
                    <el-table-column property="fournisseur" label="Fournisseur" >
                        <template slot-scope="scope">
                            <el-select clearable v-model="scope.row.fournisseur"   placeholder="Associer un fournisseur" style="width:100%">
                                <el-option v-for="item in listFour" :key="item.id" :label="item.libelle" :value="item.id">
                                </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary"  @click.stop="attribuerFour()">Confirmer</el-button>
      </span>
        </el-dialog>

        <formAjoutFour @close="closeFormFour()" :idFour="fournCourant.id" :show="showFour"  :typeFour="parseInt(typeF)"></formAjoutFour>

       <LoadTarificationFourn
          @close="showModalLoadTarification =false;closeFormFourTarif(fournCourant.id);"
          :show="showModalLoadTarification"
          :idFour="fournCourant.id"
          :listeTypeTravaux="lstRessources"
        ></LoadTarificationFourn>

         <!-- MODAL CONFIRMATION CHANGEMENT DE FOURNISSEEUR -->
        <v-dialog v-model="validCommd" max-width="50%" :overlay="true" scrollable persistent>
          <v-card>
            <v-card-text text-xs-center>
              <h1 align="center">Voulez-vous vraiment annuler la commande passée chez ce fournisseur ? </h1>
              <p align="center">
                <v-btn @click.native="validCommd = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                <v-btn icons color="red"  @click="validCmdDerivees(commandeDeriv)()" dark>Confirmer <v-icon right>check</v-icon></v-btn>
              </p>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>

          <!-- MODAL IMPRESSION BON DE COMMANDE-->
        <v-dialog v-model="dialogImprCommande" max-width="50%" :overlay="true" scrollable persistent>
          <v-card>
            <v-card-text text-xs-center>
               <p align="center">
                  <v-btn @click.stop="imprimerModeCommande(2)" color="green" dark>
                    Paysage
                    <v-icon right>print</v-icon>
                  </v-btn>
                  <v-btn icons color="orange" @click.stop="imprimerModeCommande(1)" dark>
                    Portrait
                    <v-icon right>print</v-icon>
                  </v-btn>
                </p>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
          <v-btn icon @click.native="dialogImprCommande = false" dark class="blue"
            ><v-icon>close</v-icon>
          </v-btn>
        </v-dialog>

        <!-- MODAL IMPRESSION FACTURE-->
        <v-dialog v-model="dialogImprFacture" max-width="50%" :overlay="true" scrollable persistent>
          <v-card>
            <v-card-text text-xs-center>
               <p align="center">
                  <v-btn @click.stop="imprimerModeFacture(2)" color="green" dark>
                    Paysage
                    <v-icon right>print</v-icon>
                  </v-btn>
                  <v-btn icons color="orange" @click.stop="imprimerModeFacture(1)" dark>
                    Portrait
                    <v-icon right>print</v-icon>
                  </v-btn>
                </p>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
          <v-btn icon @click.native="dialogImprFacture = false" dark class="blue"
            ><v-icon>close</v-icon>
          </v-btn>
        </v-dialog>


         <!-- MODAL IMPRESSION FUSION COMMANDE-->
        <v-dialog v-model="dialogImprFusionCom" max-width="50%" :overlay="true" scrollable persistent>
          <v-card>
            <v-card-text text-xs-center>
               <p align="center">
                  <v-btn @click.stop="imprimerListe(2)" color="green" dark>
                    Paysage
                    <v-icon right>print</v-icon>
                  </v-btn>
                  <v-btn icons color="orange" @click.stop="imprimerListe(1)" dark>
                    Portrait
                    <v-icon right>print</v-icon>
                  </v-btn>
                </p>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
          <v-btn icon @click.native="dialogImprFacture = false" dark class="blue"
            ><v-icon>close</v-icon>
          </v-btn>
        </v-dialog>

        <!-- MODAL IMPRESSION LIVRAISON-->
        <v-dialog v-model="dialogImprLivraison" max-width="50%" :overlay="true" scrollable persistent>
          <v-card>
            <v-card-text text-xs-center>
               <p align="center">
                  <v-btn @click.stop="imprimerModeLivraison(2)" color="green" dark>
                    Paysage
                    <v-icon right>print</v-icon>
                  </v-btn>
                  <v-btn icons color="orange" @click.stop="imprimerModeLivraison(1)" dark>
                    Portrait
                    <v-icon right>print</v-icon>
                  </v-btn>
                </p>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
          <v-btn icon @click.native="dialogImprLivraison = false" dark class="blue"
            ><v-icon>close</v-icon>
          </v-btn>
        </v-dialog>


            <!-- MODAL IMPORTATION STOCK -->
    <v-dialog v-model="dialogImport" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h4 align="center">Nb: Le fichier contient uniquement les ressources qui figurent dans votre base de produit.</h4>
          <h4 align="center">Indiquer uniquement le PRIX D'ACHAT de chaque ligne de produit que vous souhaitez ajouter à la tarification chez ce fournisseur.</h4>
          <h3 align="center">Supprimer ensuite les lignes restantes dans votre fichier avant importation.</h3>
          <p align="center">
            <v-btn @click.native="dialogImport = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="green" @click.stop="generateFileExcel()" dark>Généner <v-icon right>done</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
    </div>
</template>

<script>
    var echarts = require('echarts/lib/echarts')
    require('echarts/lib/chart/bar')
    require('echarts/lib/chart/pictorialBar')
    require('echarts/lib/chart/funnel')
    require('echarts/lib/chart/sankey')
    require('echarts/lib/chart/scatter')
    require('echarts/lib/chart/pie')
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')

    import Loading from '@/components/Loading';
    import boardFacture from '@/components/tierce/boardFacture';
    import formAjoutFour from '@/components/tierce/formAjoutFour';
    import boardFactureFournisseur from '@/components/tierce/boardFactureFournisseur';
    import LoadTarificationFourn from "@/components/tierce/LoadTarifiFourn.vue";

    export default {
        components:{ Loading,LoadTarificationFourn,boardFacture,boardFactureFournisseur,formAjoutFour },
        name: 'fournisseur',
        data () {
            return {
                loading: false,
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),

                headersMaintenance: [
                    { text: 'Nom du demandeur', align: 'left', value: '' },
                    { text: 'Date', align: 'left', value: '' },
                    { text: 'Etat', align: 'left', value: '' },
                    { text: 'Actions', align: 'center', value: '' }
                ],
                racourcis: [
                    { path: '/', text: 'Accueil', disabled: false },
                    { path: '/fournisseur', text: 'Liste des fournisseurs', disabled: true }
                ],
                menuNais: false,
                menuDeliv: false,
                dialogImprCommande: false,
                dialogImprFacture: false,
                dialogImprFusionCom: false,
                dialogImprLivraison: false,
                dialogImport: false,
                menuExpi: false,
                dialogDevis: false,
                validCommd: false,
                dialogConfirm: false,
                // dialogConf: false,
                //dialogAjout: false,
                dialogShow: false,
                dialogShowTarif: false,

                dialogEdit: false,
                dialogSupr: false,
                dialogReactiv: false,
                dialogSUppFacture: false,
                commReactiv: '',
                dialogConteneur: false,
                dialogSuprComm: false,
                dialogComm: false,
                assignTotier: false,
                dialogFacture: false,
                dialogFactureFact: false,
                dialogTarif: false,
                dialogArticlConteneur: false,
                dialogShowCommande: false,
                dialogShowFacture: false,
                dialogValiFacture: false,
                dialogLivraison: false,
                dialogShowLivraison: false,
                dialogShowMaintenance: false,
                showModalLoadTarification: false,
                dialogAppro: false,
                projetS: '',
                valid: true,
                personneType: true,
                idFourn: '',
                nom: '',
                nomRules: [ (v) => !!v || 'Le nom est obligatoire' ],
                pren: '',
                prenRules: [ (v) => !!v || 'Le prénom est obligatoire' ],
                dateNais: null,
                lieuNais: '',
                selectNaturePiece: "",
                naturePiece: [
                    { text: 'CNI', value: 1 },
                    { text: 'Passeport', value: 2 },
                    { text: 'Permis de conduire', value: 3 },
                    { text: 'Attestation', value: 4 }
                ],
                naturePieceRules: [ (v) => !!v || 'La nature de la pièce est obligatoire' ],
                numPiece: '',
                numPieceRules: [ (v) => !!v || 'Le numéro de la pièce est obligatoire' ],
                dateDeliv: "",
                dateExpi: "",
                contact: '',
                contactRules: [ (v) => !!v || 'Le contact est obligatoire' ],
                loginUser: '',
                mdpUser: '',
                mdpVerUser: '',
                loginUserRules: [
                    (v) => !!v || 'Le login est obligatoire',
                    (v) => /^\w+([.-]?\w+)*@\w+([-]?\w+)*(.\w{2,3})+$/.test(v) || 'Vous devez respecter format de E-mail'
                ],
                mdpUserRules: [
                    (v) => !!v || 'Le mot de passe est obligatoire',
                    (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
                ],
                mdpVerUserRules: [
                    (v) => !!v || 'La vérifiaction du mot de passe est obligatoire. Il doit être identique au mot de pas entré précédenment',
                    (v) => v && v.length >= 4 || 'Vous devez renter pas moins de 4 caractères'
                ],
                service: '',
                profession: '',
                domicile: '',
                selectTypeEntre: '',
                nationalite: '',
                formJuridique: '',
                formJuridiqueRules: [ (v) => !!v || 'La forme juridique est obligatoire' ],
                registreComm: '',
                siege: '',
                siegeRules: [ (v) => !!v || 'Le siège social est obligatoire' ],
                telBureau: '',
                telBureauRules: [ (v) => !!v || 'Le téléphone est obligatoire' ],
                representant: '',
                representantRules: [ (v) => !!v || 'Le nom de représentant légal est obligatoire' ],
                metier: '',
                metierRules: [ (v) => !!v || 'Le type de métier est obligatoire' ],
                selectType: "",
                metier: [],
                typeFour: [
                    { text: 'Fournisseur', value: 1 },
                    { text: 'Prestataire', value: 2 },
                    { text: 'Fournisseur et Prestataire', value: 3 }
                ],
                typeFourRules: [ (v) => !!v || 'Le type de fournisseur est obligatoire' ],
                selectCivilite: "",
                civilite: [
                    { text: 'Monsieur' },
                    { text: 'Madame' },
                    { text: 'Mademoiselle' }
                ],
                civiliteRules: [ (v) => !!v || 'La civilité est obligatoire' ],
                listFour: [],
                selectFourn: '',
                fourSelect: '',
                listFourFinal: [],
                listProduiFinal: [],
                statAllFour: [],
                statAllFactureFour: [],
                statsFactureFourn: [],
                listSupp: [],
                comboMetier:[],
                comboProduit:[],
                comboProfession:[],
                comboFournisseur:[],
                statFourn: [],
                nbrComAll: 0,
                nbrFactAll: 0,
                nbrLivrAll: 0,
                depenseAll: 0,
                nbrComFourn: 0,
                nbrFactFourn: 0,
                nbrLivrFourn: 0,
                depenseFourn: 0,
                detailFour: [],
                fournCourant: {},
                libelle: '',
                dateLivr: "",
                selectUsers: [],
                users: [],
                listProd: [],
                tvaSelect: 0,
                remiseSelect: 0,
                rabaisSelect: 0,
                retenuSelect: 0,
                tvaGlobal: 'NON',
                retenuGlobal: 'NON',
                remiseGlobal:'NON',
                rabaisGlobal:'NON',
                reponses: [
                    { text: 'OUI', value: 'OUI' },
                    { text: 'NON', value: 'NON' }
                ],
                reponsesRabais: [
                    { text: 'OUI EN %', value: '%' },
                    { text: 'OUI EN MONTANT', value: 'MONTANT' },
                    { text: 'NON', value: 'NON' }
                ],
                tableEnsemble: [{
                    infoConteneur:{
                        marque : '',
                        forfait : '',
                        poidsCargot : '',
                        tare : '',
                        mesure : '',
                        description : '',
                        numeroConte :'',
                        numCle : '',
                    },
                    infoArticle:{
                        metrage : '',
                        poidsBrute : '',
                        poidsNet :'',
                        tare : '',
                        designation : '',
                        tourtes : '',
                        code : '',

                        qte : '',
                    }
                }],
                formAjoutConteneur:{},
                formAjoutArticle: {},
                optionCommande: [{ key: 1, produit: '', prix: 0, qte: 1, remise: 0, tva: 0,  total: 0, id: '' }],
                totalComHT: 0,
                totalRabais: 0,
                totalRetenu: 0,
                totalComHTSR: 0,
                totalComTVA: 0,
                totalComTTC: 0,
                totalRABAISTTC: 0,
                totComLigneTTC: 0,
                totComLigneTTCFormat: 0,
                listCommande: [],
                idComm: '',
                idFacture: '',
                detailCommande: [],
                commCourant: [],
                listFacture: [],
                factureCourant: [],
                detailFacture: [],
                decisionFact: [
                    { text: 'Accepter', value: 1 },
                    { text: 'Rejeter', value: 2 }
                ],
                upload:'',
                selectDecisionFact: "",
                selectModalite: "",
                modalite: [
                    { text: 'Mensuel', value: 1 },
                    { text: 'Trimestrielle', value: 2 },
                    { text: 'Semestrielle', value: 3 },
                    { text: 'Annuel', value: 4 }
                ],
                selectModeRegl: "",
                modeRegl: [
                    { text: 'Espèce', value: 1 },
                    { text: 'Chèque', value: 2 },
                    { text: 'Virement', value: 3 },
                ],
                datePaie: "",
                dialogDocsVisible: false,
                dialogDocsUrl: '',
                etatLivraison: [
                    { text: 'Total', value: 1 },
                    { text: 'Partiellement', value: 2 }
                ],
                typeLivraison: [
                    { text: 'Standard', value: 1 },
                    { text: 'Bâteau', value: 2 }
                ],
                selectLivraison: "",
                selectTypeLivraison: "",
                provenanceConteneur: '',
                recepetionConteneur: '',
                numCpteLivraison: '',
                numVoyage: '',
                livreur: '',
                commentaire: '',
                e1: 1,
                d1: 1,
                formConteneurArticle:{},
                tableArticleConteneur: [],
                tableArticleConteneurAffiche:[],
                optionLivraison: [{ key: 1, value: '', qte: 1, qteL: 0, id: '' }],
                listLivraison: [],
                livraisonCourant: [],
                detailLivraison: null,
                showBoat: false,
                showConteneurs: false,
                statsPieCommande: '',
                optionLivr: [],
                optionType: [],
                etatAffichage: 0,
                optionEntrepot: [],
                optionAppro: [],
                optionQteRecu: [],
                totalCommande: 0,
                totalFacture: 0,
                listMaintenance: [],
                detailMaintenance: [],
                maintenanceCourant: [],
                longDevis: 0,
                listCaisse: [],
                selectCaisse: [],
                optionDevis: [],
                devisTotal: 0,
                devisTva: 0,
                devisHt: 0,
                listKeyword:[],
                listFournConnect:[],
                listProjet:[],
                listChantier:[],
                listTravaux:[],
                tableTarification: [],
                projetS: '',
                chantierS: '',
                fourniS: '',
                disabledBtnPop: false,
                produiS: '',
                travauxS: '',
                disabledBtn : false,
                disabledBtnF : false,
                disabledBtnL : false,
                disabledBtnM : false,
                listProduit: [],
                selectProduit: '',
                selectIdProduit: '',
                prixAchat: 0,
                listeProd: [],
                tarifCourant: [],
                typeComm: [
                    { text: 'Commande pour un chantier', value: 1 },
                    { text: 'Commande pour une maintenance', value: 2 },
                ],
                selectTypeCom: '',
                selectDemande: '',
                listDemande: [],
                infoProduit: [],
                image1: "/static/img-doc.png",
                image2: "/static/img-doc.png",
                totalTva: 0,
                totalRemise:0,
                totalHT: 0,
                dialogShowArticle: false,
                dialogMontantCommande: false,
                dialogComparaison: false,
                commandeInit: [],
                oui: [],
                non: [],
                detailArticle: {},
                totCmdHtInit: 0,
                totCmdTvaInit: 0,
                totCommandeInit: 0,
                commandeDeriv: [],
                totalBenefice: 0,
                dialogProdNull:false,
                listeProdNull:[],
                listContrat: [],
                totalContrat: 0,
                totalVerse : 0,
                totalRestant : 0,
                selectContrat: null,
                disabledSelectCaisse: false,
                disabledSelectCaisse: false,
                mntRestantContrat:0,
                logoFacture: "/static/img-doc.png",

                avance:0,
                modePaie: 0,
                deleteConteneur: false,
                currentConteneurToDelete: null,
                modalitePaie: [
                    { text: 'A la commande', value: 1},
                    { text: '10 jours nets', value: 10 },
                    { text: '30 jours nets', value: 30 },
                    { text: '30 jours fin du mois', value: 45 },
                    { text: '60 jours nets', value: 60 },
                    { text: '60 jours fin de mois', value: 75 },
                    { text: '90 jours nets', value: 90 },
                    { text: '90 jours fin de mois', value: 105},
                    { text: '120 jours nets', value: 120 },
                ],
                totalComRemise: 0,
                totalComRetenu: 0,
                dateLivr : null,
                disBtnAjtCom: false,
                taches: [
                    {
                        prop: 'codeGestion',
                        label: 'Code gestion',
                    },
                    {
                        prop: 'produit',
                        label: 'Produit concerné',
                    },
                     {
                        prop: 'unite',
                        label: 'Unité',
                    },
                    {
                        prop: 'prix',
                        label: "Prix d'achat",
                    }
                ],

                //form container
                formConteneur: {
                    export: "",
                    numComm: "",
                    bl:"",
                    reception: "",
                    numChargement: "",
                    numVoyage: "",
                    provenance: ""
                },

                formConteneur: {
                    marque: "",
                    numConteneur: "",
                    numCle:"",
                    type: "",
                    poids: "",
                    nbPacket:0,
                    description:"",
                    tare:"",
                    mesure:"",
                    metrageTotal: 0,
                    poidsBrutTotal: 0,
                    poidsNetTotal: 0,
                    tareTotal: 0
                },

                tableConteneur: [
                    {
                        conteneur:
                            {
                                marque: "",
                                numConteneur: "",
                                numCle:"",
                                type: "",
                                poids: "",
                                nbPacket:0,
                                description:"",
                                tare:"",
                                mesure:"",
                                metrageTotal: 0,
                                poidsBrutTotal: 0,
                                poidsNetTotal: 0,
                                tareTotal: 0
                            },
                        articles: [
                            {
                                code: "",
                                designation: "",
                                qte:"",

                                tourtes: "",
                                metrage:0,
                                poidsBrute:"",
                                poidsNet:"",
                                tare:"",
                                mesure:""
                            }
                        ]

                    }
                ],
                formArticle: {
                    code: "",
                    designation: "",
                    qte:"",

                    tourtes: "",
                    metrage:0,
                    poidsBrute:"",
                    poidsNet:"",
                    tare:"",
                    mesure:""
                },
                typeConteneur:[
                    {
                        id:1,
                        libelle: "10'"
                    },
                    {
                        id:2,
                        libelle: "20'"
                    },
                    {
                        id:3,
                        libelle: "20'HC"
                    },
                    {
                        id:4,
                        libelle: "40'"
                    },
                    {
                        id:8,
                        libelle: "40' HC"
                    },
                    {
                        id:5,
                        libelle: "45'"
                    },
                    {
                        id:6,
                        libelle: "Open Top"
                    },
                    {
                        id:7,
                        libelle: "Flat Rack"
                    },
                ],
                prodSelct: '',            
                listTypeRessource: [], 
                
                nbTourtes: 0,
                nbMetrage: 0,
                nbPoidsBrutes: 0,
                nbTare:0,
                nbPoidsNet:0,

                //formbateau
                formBateau:{
                    export:"",
                    numCom:"",
                    bl:"",
                    reception:"",
                    numChargement:"",
                    numVoyage:"",
                    provenance: ""
                },

                formComm:{},
                disableCaisse: false,

                //STATISTIQUE FACTURE
                dataFactureStat: null,
                dataCommandeStat: [],
                showFactureStat: false,
                dataFactureStatNb: [],

                //  pour limpression en un bon de commande
                nombreSelection: 0,
                multipleSelection:[],


                dataFactureStatFour: [],
                dataCommandeStatFour: [],
                showFactureStatFour: false,
                dataFactureStatNbFour: null,
                mntEstimeContrat : 0,
                mntFactureGenere : 0,
                mntAVerserContrat : 0,
                evolutionContrat : 0,
                typeProduit:'',

                 //Importer fichier excel
                fileExcel: [],
                lstRessources: [],

                //DETAIL CONTRAT
                listeFacturesContrat: [],
                dialogInfoContrat: false,
                detailContrat: {},
                dialogSupTarif: false,
                avanceContSelect: false,
                listCaisseComplete: [],
                libTachePrest: null,

                showFour: false,
                typeF: null,
                nameFile: "",

              valeurUniteMateriel:'',
              codegestion: '',
              selectUnite:'',
              listeProduitAffich:[]

            }
        },
        computed: {
            loadCaisseCommd: function(){
                return this.listCaisse.filter( elt=>{
                    if(this.commCourant.idProj != ""){
                      if(this.commCourant.idBanque) {
                        return ( this.commCourant.idCaisse == elt.id || this.commCourant.idBanque.filter(element=> {
                                return element = elt.id;
                            }));
                       }
                    }
                    else{
                        return true;
                    }


                })
            }

        },


        mounted () {
            this.loadPage()
            this.loadMetier()
            this.loadTypeRessource()
            this.loadFournLimit()
            this.loadUser()
            this.loadCaisse()
            this.loadDevis()
            this.loadProjet()
            this.loadProduitListe()
            this.loadDemande()
            // this.loadProduit()
            this.showFactureStat= true
        },

        watch: {
            avance: function(newValue,oldValue){
                if(this.selectContrat != null && newValue > 0){
                    this.calculMontAvance();
                }
            }
        },

        methods: {
           handleFileExcel(
              command //0=>Importer,1=>generer

            ) {
              switch (command) {
                case "0": //importer un fichier
                   this.$refs.fileInputExcel.click()
                  break;
                case "1": //generer un modele un fichier
                  this.generateFileExcel();
                  break;
              }
            },
            generateFileExcel() {
              this.dialogImport = false
              let url = this.domaine + "product/exportEXC/listRessources";
              window.open(url);
            },
            generateListeFourFileExcel() {
                let url = this.domaine + "fournisseur/generer/liste";
                window.open(url);
            },
            generateFile(format, etat) {
                this.loading = true
                var formdata = new FormData();
                let options = []; 

                for (let prop in this.multipleSelection) {
                    let ligne = this.multipleSelection[prop];
                    options.push(ligne.ref);
                }
                console.log('dhhdd',options)
                console.log('selectFourn',this.selectFourn)
                formdata.append('idUser', this.user.id)
                formdata.append('typeRech', 'commande')
                formdata.append('commande', options)
                // formdata.append('livraison', this.reference)
                formdata.append('facture', this.reference)
                formdata.append('fournisseur', this.selectFourn)

                let url = ''
                let idUser = this.user.id
                let typeRech = 'commande'
                let commande = options
                let periode = null
                let fournisseur = null
                let projet = null
                let chantier = null
                url = this.domaine + "fournisseur/imprimerEXC/recherche/liste/"+idUser+'/'+typeRech+'/'+commande+'/'+fournisseur+'/'+projet+'/'+chantier+'/'+periode;
                console.log('url',url)
                this.loading = false
                window.open(url);
            },
            onFileExcelPicked(event) {
              this.fileExcel.splice(0, 1);
              const files = event.target.files;
              let filename = files[0].name;
              if (filename.lastIndexOf(".xls") <= 0) {
                return alert("Veuillez selectionner un fichier excel valide ");
              }
              if (files[0].size > 1048576) {
                this.$message.error("La taille du fichier est supérieur à 1024 ko");
                return;
              }
              const fileReader = new FileReader();
              fileReader.addEventListener("load", () => {
                this.fileExcel.push(fileReader.result);
              });
              fileReader.readAsDataURL(files[0]);

              let url = this.domaine + "fournisseur/loadTarif/excel";
              let data = new FormData();
              data.append("fichierExcel", files[0], files[0][name]);
              this.$http.post(url, data).then(
                resp => {
                  this.loading = false;
                  this.$notify({
                    title: "Chargement des tarifications",
                    message: "Chargement effectué",
                    type: "success",
                    position: "top-right",
                    duration: 5000
                  });
                  this.lstRessources = resp.body.listeTypeTravaux;
                  this.showModalLoadTarification = true;
                },
                error => {
                  this.loading = false;
                  this.$message.error("Erreur lors de l'importation du fichier");
                }
              );


            },
           loadUniteProduit(item) {
                let valeur;
                let code ='';
                this.valeurUniteMateriel =''
                valeur = this.listeProduitAffich.find(function(element) {
                  if (element.id == item) {
                    code = element.codeGestion
                    return element.unite;
                  }
                });
                this.codegestion = code
                this.valeurUniteMateriel = valeur.unite;
              },
            handleTypeLivr(valuetypeLivr){

                if(valuetypeLivr == 1){
                    let optionLivrCopie =  this.optionLivraison.slice()
                    this.optionLivraison.splice(0);

                    optionLivrCopie.forEach( (elt,index)=>{
                        let eltMod = elt
                        eltMod.qteL = elt.qte;
                        this.optionLivraison.push(eltMod)
                    } );

                    // for(let indexOptLivr in this.optionLivraison){
                    //     let qteL = this.optionLivraison[indexOptLivr].qte
                    //     this.optionLivraison[indexOptLivr].qteL = qteL
                    // }
                }
                else{

                    let optionLivrCopie =  this.optionLivraison.slice()
                    this.optionLivraison.splice(0);
                    optionLivrCopie.forEach( (elt,index)=>{
                        let eltMod = elt
                        eltMod.qteL = 0;
                        this.optionLivraison.push(eltMod)
                    } );
                    // for(let indexOptLivr in this.optionLivraison){
                    //     this.optionLivraison[indexOptLivr].qteL = 3
                    // }
                }
            },
            showFormFour(){
                this.showFour = true;
            },
            loadTypeRessource() {          
                let url =this.domaine + "product/typeRessource";
                    this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listTypeRessource = response.body.types;
                        this.loading = false;
                    }
                    });
            },
            handleCommandFour(command) {
                this.showFour = true;
                this.typeF = command
            },
            closeFormFourTarif(item) {
              let url = ""
               if (this.droitAcces.index_produit_fourn) {
                    url = this.domaine + 'fournisseur/' + item+ '/index/produit'
                } else{
                    url = this.domaine + 'fournisseur/' + item + '/index/' + this.user.id + '/produit'
                }

                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listProduit = response.body.produit
                        this.loading = false
                    }
                })

            },
            closeFormFour(){
                this.showFour = false;
                this.typeF = null;
                this.fournCourant = {}
                this.loadFournLimit()
            },
            imprimerListe(mode) {
              this.loading = true;
              this.optionCommande = this.multipleSelection;
              let options = []; 
              for (let index = 0; index < this.multipleSelection.length; index++) {
                    let element1 = this.multipleSelection[0]["projet"];
                    const element = this.multipleSelection[index]["projet"];
                    // if (element1 != element) {
                    //    this.$notify({
                    //         title: "Fusion",
                    //         message: "Veuillez sélectionner des commandes issues d'un même projet",
                    //         type: "error",
                    //         position: "top-center"
                    //       });
                    //     return
                    //   }
                  }



              var formdata = new FormData();
              for (let prop in this.multipleSelection) {
                let ligne = this.multipleSelection[prop];
                  options.push(ligne.id);
              }

              let  url = this.domaine + "fournisseur/imprimerFusionPdf/comamnde/"+mode;
              formdata.append("options", options);
              formdata.append("idUser", this.user.id);

              let req=new XMLHttpRequest();
              this.$http
                .post(url, formdata, { responseType: "arraybuffer" })
                .then(response => {
                  let blob = new Blob([response.data], {
                    type: response.headers.get("content-type")
                  });
                  this.loading = false;
                  let url = URL.createObjectURL(blob);
                  this.loading = false;
                  this.dialogImprFusionCom = false
                  window.open(url);
                },
                 error => {
                this.loading = false;
                this.$message.error(
                    "Une erreur est survenue lors du de la génération du document pdf"
                );
                });
            },
             handleSelectionChange(val) {
                console.log('val',val)
                this.multipleSelection = val;
                this.nombreSelection = val;
              },
            besoinSelect(row, index) {
              let etat = null;
              if (parseInt(row.qte) != 0) {
                etat = true;
              } else {
                etat = false;
              }
              return etat;
              },
            loadTypeProduit(item){
                  if (this.$refs.typeProduit == "") {
                      return;
                    }
                    this.loading = true;
                    let url = this.domaine + "product/productSelect/type/"+item;
                    this.$http.get(url).then(
                      response => {
                        this.loading = false;
                        this.listProd = response.body.produits;
                        this.listeProduitAffich = response.body.produits

                      },
                      errRep => {
                        this.loading = false;
                        this.$message.error(
                          "Une erreur est survenue lors du chargement de la liste du chntier"
                        );
                      }
                    );

                  },

            supprimerArticle(index, rows) {
                rows.splice(index, 1);
            },
            editConteneur(item) {
                this.formConteneur = item.conteneur
                this.formArticle = item.articles[item.articles.length - 1]
                this.tableArticleConteneur = item.articles
                this.dialogConteneur = true
            },
            changeContrat(data){
                this.libTachePrest = null;
                if (data == null){
                    this.disabledSelectCaisse = false;
                    return;
                }
                this.optionCommande.splice(0)
                if(data == "undefined" || data == ""){
                    this.disabledSelectCaisse = false;
                    return;
                }
                //rechercher la caisse lie au projet du contrat
                this.loading = true;

                this.listCaisse = this.listCaisseComplete;

                let url = this.domaine + 'projet/caisse/contrat/' + data
                this.$http.get(url).then(response => {
                    this.selectCaisse = response.body.caisse.id;

                    //filtrer la liste des caisse
                    this.listCaisse = this.listCaisse.filter(elt=>{
                        if( (elt.id == response.body.caisse.id ) || (elt.id == response.body.caisse.idBanque ) ){
                            return true;
                        }
                        return false;
                    })


                    this.mntRestantContrat = response.body.caisse.mntRestant;
                    this.optionCommande.push(...response.body.caisse.produits);
                    //this.optionCommande.produit =  response.body.caisse.libTrx;
                    if(response.body.caisse.mntAVerse > 0){
                        this.optionCommande[0].total= response.body.caisse.mntAVerse;
                    }
                    else{
                        this.optionCommande[0].total= 0;
                    }



                    this.mntEstimeContrat = response.body.caisse.mntEstime
                    this.mntFactureGenere = response.body.caisse.mntFacture
                    this.mntAVerserContrat = response.body.caisse.mntAVerse
                    this.evolutionContrat = response.body.caisse.evolution
                    this.projetS = response.body.caisse.idProjet;
                    this.loadChantier();
                    this.chantierS = response.body.caisse.idChantier;
                    this.loadTravaux()
                    this.calculMontAvance()
                    this.libTachePrest = response.body.caisse.libTache
                    this.travauxS = response.body.caisse.idTravaux;
                    this.avanceContSelect =  response.body.caisse.isAvance
                    if(response.body.caisse.isAvance == true){
                        this.$message('Une avance de demarrage a déja été versé pour ce contrat');
                    }
                    this.loading = false
                    this.disabledSelectCaisse = false;

                }, error =>{
                    this.loading = false
                    this.disabledSelectCaisse = false;
                    this.$message.error("Une erreur est survenue lors du chargement de la caisse du projet")
                })

            },

            calculMontAvance(){
                if(this.selectContrat != null && this.avance != 0){
                    let mntAvance = (this.mntEstimeContrat * this.avance) / 100;
                    this.optionCommande[0].prix = mntAvance;
                    this.optionCommande[0].total = mntAvance;

                }
            },

            verifFormConteneur(){
                if(this.formConteneur.marque != null && this.formConteneur.numConteneur !=null  && this.formConteneur.numCle !=null ){
                    return true
                }else {
                    return false
                }
            },
            newConteneur(formName) {

                this.formConteneur = {
                    marque : '',
                    type : '',
                    poids : '',
                    tare : '',
                    mesure : '',
                    description : '',
                    numConteneur : '',
                    numCle : '',
                    nbPacket: '',
                },
                    this.formConteneurArticle = {
                        metrage : '',
                        poidsBrute : '',
                        poidsNet : '',
                        tare : '',
                        designation : '',
                        tourtes : '',
                        code : '',
                        qte : '',
                    },
                    this.d1 = 1
                this.dialogConteneur = true
                // this.tableConteneur.splice(0)
                this.tableArticleConteneur.splice(0)
                // this.isEdit = false
                // this.idEditMission = ""
            },
            loadContrat(ligne){
                this.loading = true;
                let url = this.domaine + 'fournisseur/contrat/' + ligne.id
                this.$http.get(url).then(response => {
                    this.listContrat = response.body.contrats;
                    this.totalContrat = response.body.totalContrat;
                    this.totalVerse = response.body.totalVerse;
                    this.totalRestant = response.body.totalRestant;
                    this.loading = false

                }, error =>{
                    this.loading = false
                    this.$message.error("Une erreur est survenue lors du chargement des contrats fournisseurs")
                })
            },
            loadProjet ()
            {
                let url = this.domaine + 'projet/index/projet/all'

                this.loading = true
                this.$http.get(url).then(response => {
                    this.loading = false
                    this.listeProjet = response.body.projet

                    this.projetS = this.detailCommande.projet;
                },errRep=>{
                    this.loading = false
                    this.$message.error("Une erreur est survenue lors du chargement de la liste des projets")
                })
            },

            loadPage () {
                this.loading = true
            },
            imprimerDemandeDevis(item){
                let url = this.domaine + 'maintenance/' + item.id + '/imprimer/demandeDevis'
                this.$http.get(url).then(response => {
                    if (response.body) {
                    }
                })
                window.open(url)
            },
            loadUser () {
                this.loading = true
                let url = this.domaine + 'userCreate/user-list'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.users = response.body
                        this.loading = false
                    }
                })
            },
            loadFournisseurConnecte () {
                this.loading = true
                let url = this.domaine + 'fournisseur/'+ this.user.id +'/connecte'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listFournConnect = response.body.fournisseur
                        this.statAllFour = response.body.stats
                        this.statAllFactureFour = response.body.statsFact
                        this.nbrComAll = response.body.nbrCom
                        this.nbrFactAll = response.body.nbrFact
                        this.nbrLivrAll = response.body.nbrLivr
                        this.depenseAll = response.body.coutTotal
                        this.loading = false
                    }
                })
            },
            loadProjet () {
                let url = this.domaine + 'projet/index/projet/all'
                this.loading = true
                this.$http.get(url).then(response => {
                    this.loading = false
                    if (response.body) {
                        this.listProjet = response.body.projet
                    }
                })
            },
            loadCaisseProjet () {

                if (this.projetS !== '') {
                    this.loading = true
                    let url = this.domaine + 'caisse/project/'+ this.projetS
                    this.$http.get(url).then(response => {
                        if (response.body)
                        {
                            this.loading = false;
                            this.selectCaisse = response.body.caisse.id;
                            this.disabledSelectCaisse = false;
                        }
                    }, error=>{
                        this.loading = false
                    })
                } else {
                    this.disabledSelectCaisse = false;
                    this.loading = false
                }
            },
            loadChantier () {
                this.loading = true
                this.chantierS = ''
                this.travauxS = ''
                this.listChantier = []
                if (this.projetS !== '') {
                    let url = this.domaine + 'projet/'+ this.projetS +'/index/chantier'
                    this.$http.get(url).then(response => {
                        if (response.body) {
                            this.listChantier = response.body.chantier;
                            this.loading = false;
                            this.loadCaisseProjet();

                        }
                    })
                } else {
                    this.$message.error('Veuillez sélectionner un projet')
                    this.loading = false
                }
            },
            loadTravaux ()
            {
                this.loading = true
                this.travauxS = ''
                this.listTravaux = []
                if (this.chantierS !== '') {
                    let url = this.domaine + 'projet/'+ this.chantierS +'/index/chantier/travaux'
                    this.$http.get(url).then(response => {
                        if (response.body) {
                            this.listTravaux = response.body.travaux
                            this.loading = false
                        }
                    })
                } else {
                    this.$message.error('Veuillez sélectionner un chantier')
                    this.loading = false
                }
            },
            loadProduitListe() {
                let url = this.domaine + 'product/product-list'
                this.$http.get(url).then(response => {
                        if (response.body) {
                            this.listeProd = response.body
                        }
                    },
                    response => {
                    })
            },
            loadDemande () {
                this.loading = true
                this.listDemande = []
                let url = this.domaine + 'entrepot/index/demande/devis/valide'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listDemande = response.body.demande
                        this.loading = false
                    }
                })
            },
            loadDevis (){
                this.loading = true
                let url = this.domaine + 'product/load-product-stock'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listKeyword = response.body
                        this.loading = false
                    }
                })
            },
            clearAll() {
              this.projetS = ''
              this.chantierS = ''
              this.travauxS = ''
              this.libTachePrest = ''
              this.selectContrat = null
            },
            loadCaisse () {
                this.loading = true
                let url = this.domaine + 'caisse/index'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listCaisseComplete = response.body.caisse
                        this.listCaisse = response.body.caisse

                        this.loading = false
                    }
                })
            },
            loadDemandeur(queryString, cb) {
                let url = this.domaine +  'maintenance/listes-demandeur'
                var formdata = new FormData();
                formdata.append('user', this.user.id)
                formdata.append('tag', queryString)
                this.$http.post(url, formdata).then(response => {
                        if (response.body) {
                            var links = response.body;
                            var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                            cb(results);
                        }
                    },
                    response => {
                    })
            },
            loadFourn () {
                this.loading = true
                 let url =''
                  if (this.droitAcces.fournisseur) {
                      url = this.domaine + 'fournisseur/index'
                  } else{
                    url = this.domaine + 'fournisseur/index/'+ this.user.id
                  }
                // let url = this.domaine + 'fournisseur/index'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listFour = response.body.fournisseur
                        this.listFourFinal = response.body.fournisseur
                        this.statAllFour = response.body.stats

                        //on recupere uniquement les profession differents
                        var tableau = response.body.profession;
                        for (var i = 0; i < tableau.length; ++i) {
                            for (var j = i + 1; j < tableau.length; ++j) {
                                if (tableau[i].profession === tableau[j].profession) {
                                    tableau[i].qte = tableau[i].qte + tableau[j].qte;
                                    tableau.splice(j--, 1);
                                }
                            }
                        }
                        this.comboProfession = tableau;

                        this.comboFournisseur = response.body.fournisseur
                        this.statAllFactureFour = response.body.statsFact
                        this.nbrComAll = response.body.nbrCom
                        this.nbrFactAll = response.body.nbrFact
                        this.nbrLivrAll = response.body.nbrLivr
                        this.depenseAll = response.body.coutTotal
                        //this.statAllDepense()
                        //this.statAllFacture()
                        this.loading = false
                    }
                })

                // on affiche les differents champs de recherche

                this.etatAffichage= 1;
            },
            loadFournLimit () {
                let url = ''
                this.loading = true
                if (this.droitAcces.fournisseur) {
                   url = this.domaine + 'fournisseur/indexRecent';
                } else{
                   url = this.domaine + 'fournisseur/indexRecent/'+ this.user.id;
                }

                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listFour = response.body.fournisseur
                        this.listFourFinal = response.body.fournisseur
                        this.statAllFour = response.body.stats
                        this.comboFournisseur = response.body.combofournisseur
                        this.statAllFactureFour = response.body.statsFact
                        this.nbrComAll = response.body.nbrCom
                        this.nbrFactAll = response.body.nbrFact
                        this.nbrLivrAll = response.body.nbrLivr
                        this.depenseAll = response.body.coutTotal
                        this.loading = false
                    }
                })
            },
            loadCommande (ligne) {
                this.loading = true
                // this.fournCourant = ligne
                //let url=""
                //if (this.droitAcces.index_commande) {
                let  url = this.domaine + 'fournisseur/' + ligne.id + '/index/commande'
                // }
                //if(this.droitAcces.index_cmd_user_createur){
                //url = this.domaine + 'fournisseur/' + this.fournCourant.id + '/index/' + this.user.id + '/commande'
                //}
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listCommande = response.body.commande
                        this.totalCommande = response.body.totalCommande
                        if (this.listCommande === undefined || this.listCommande.length == 0) {
                            this.disabledBtn = true
                        } else{
                            this.disabledBtn = false
                        }
                        this.loading = false
                    }
                })
            },
            loadCommandeRecent (ligne) {
                this.loadingCL = true
                // this.fournCourant = ligne
                //let url=""
                //if (this.droitAcces.index_commande) {
                let  url = this.domaine + 'fournisseur/' + ligne + '/index/commande/recent'
                // }
                //if(this.droitAcces.index_cmd_user_createur){
                //url = this.domaine + 'fournisseur/' + this.fournCourant.id + '/index/' + this.user.id + '/commande'
                //}
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listCommande = response.body.commande
                        this.totalCommande = response.body.totalCommande
                        if (this.listCommande === undefined || this.listCommande.length == 0) {
                            this.disabledBtn = true
                        } else{
                            this.disabledBtn = false
                        }
                        this.loading = false
                    }
                })
            },
            loadLivraison (ligne) {
                this.loading = true
                let url=""
                if (this.droitAcces.index_livraison) {
                    url = this.domaine + 'fournisseur/' + ligne.id + '/index/livraison'
                } else{
                    url = this.domaine + 'fournisseur/' + ligne.id + '/index/' + this.user.id + '/livraison'
                }

                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listLivraison = response.body.livraison
                        if (this.listLivraison === undefined || this.listLivraison.length == 0) {
                            this.disabledBtnL = true
                        } else{
                            this.disabledBtnL = false
                        }
                        this.loading = false
                    }
                })
            },
            loadLivraisonRecent (ligne) {
                this.loading = true
                let url=""
                if (this.droitAcces.index_livraison) {
                    url = this.domaine + 'fournisseur/' + ligne + '/index/livraison/recent'
                } else{
                    url = this.domaine + 'fournisseur/' + ligne + '/index/' + this.user.id + '/livraison/recent'
                }

                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listLivraison = response.body.livraison
                        if (this.listLivraison === undefined || this.listLivraison.length == 0) {
                            this.disabledBtnL = true
                        } else{
                            this.disabledBtnL = false
                        }
                        this.loading = false
                    }
                })
            },
            loadFacture (ligne) {
                this.loading = true
                let   url = this.domaine + 'fournisseur/' + ligne.id + '/index/facture'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listFacture = response.body.facture
                        this.totalFacture = response.body.totalFacture
                        if (this.listFacture === undefined || this.listFacture.length == 0) {
                            this.disabledBtnF = true
                        } else{
                            this.disabledBtnF = false
                        }
                        this.loading = false
                    }
                })
            },
            loadFactureRecent (ligne) {
                this.loading = true

                let   url = this.domaine + 'fournisseur/' + ligne + '/index/facture/recent'

                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listFacture = response.body.facture
                        this.totalFacture = response.body.totalFacture
                        if (this.listFacture === undefined || this.listFacture.length == 0) {
                            this.disabledBtnF = true
                        } else{
                            this.disabledBtnF = false
                        }
                        this.loading = false
                    }
                })
            },
            loadMaintenance(ligne){
                this.loading = true
                let url=""
                if (this.droitAcces.index_maintenance) {
                    url = this.domaine + 'fournisseur/' + ligne.id + '/index/maintenance'
                }
                if(this.droitAcces.index_maintenance_user) {
                    url = this.domaine + 'fournisseur/' + ligne.id + '/index/' + this.user.id + '/maintenance'
                }

                this.loading = true;
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.loading = false;
                        this.listMaintenance = response.body.maintenance
                        if (this.listMaintenance === undefined || this.listMaintenance.length == 0) {
                            this.disabledBtnM = true
                        } else{
                            this.disabledBtnM = false
                        }
                        this.loading = false
                    }
                })
            },
            loadMaintenanceRecent(ligne){
                this.loading = true
                let url=""
                if (this.droitAcces.index_maintenance) {
                    url = this.domaine + 'fournisseur/' + ligne.id + '/index/maintenance/recent'
                }
                if(this.droitAcces.index_maintenance_user) {
                    url = this.domaine + 'fournisseur/' + ligne.id + '/index/' + this.user.id + '/maintenance/recent'
                }

                this.loading = true;
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.loading = false;
                        this.listMaintenance = response.body.maintenance
                        if (this.listMaintenance === undefined || this.listMaintenance.length == 0) {
                            this.disabledBtnM = true
                        } else{
                            this.disabledBtnM = false
                        }
                        this.loading = false
                    }
                })
            },
            loadProduitFoun(ligne){
                this.loading = true
                let url=""
                if (this.droitAcces.index_produit_fourn) {
                    url = this.domaine + 'fournisseur/' + ligne.id + '/index/produit'
                } else{
                    url = this.domaine + 'fournisseur/' + ligne.id + '/index/' + this.user.id + '/produit'
                }

                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listProduit = response.body.produit
                        this.loading = false
                    }
                })
            },
            loadProduitFounRecent(ligne){
                this.loading = true
                let url=""
                if (this.droitAcces.index_produit_fourn) {
                    url = this.domaine + 'fournisseur/' + ligne.id+ '/index/produit/recent'
                } else{
                    url = this.domaine + 'fournisseur/' + ligne.id + '/index/' + this.user.id + '/produit/recent'
                }
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.listProduit = response.body.produit
                        this.listProduiFinal = response.body.produitFinal
                        this.loading = false
                    }
                })
            },
            showFourn (ligne) {
              this.fourSelect = ligne
                this.loading = true
                this.showFactureStatFour = true;
                this.dialogShow = true
                this.fournCourant = ligne
                let url = this.domaine + 'fournisseur/' + ligne.id + '/show'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.detailFour = response.body.fournisseur
                        this.statFourn = response.body.stats
                        this.statsFactureFourn = response.body.statsFact
                        this.nbrComFourn = response.body.nbrCom
                        this.nbrFactFourn = response.body.nbrFact
                        this.nbrLivrFourn = response.body.nbrLivr
                        this.depenseFourn = response.body.coutTotal
                        this.loading = false
                    }
                })
            },
            deleteFacture() {
                this.loading = true
                let url = this.domaine + 'fournisseur/' + this.idFacture + '/delete/facture'
                this.$http.get(url).then(response => {
                    if (response.body) {
                       this.$notify({
                          title: "ENREGISTREMENT REUSSI",
                          message: "Facture supprimé avec succès.",
                          type: "success",
                          position: "top-center"
                        });
                        this.dialogSUppFacture = false
                        this.loading = false
                        this.loadFacture(this.detailFour)
                    }
                })
            },
            showLivraison (ligne) {
                // this.loading = true
                this.dialogShowLivraison = true
                this.livraisonCourant = ligne
                let url = this.domaine + 'fournisseur/' + this.livraisonCourant.id + '/show/livraison'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.detailLivraison = response.body.livraison
                        if (this.detailLivraison[0].export) {
                            this.showBoat = true
                        }

                        if (this.detailLivraison[0].conteneurs.length > 0) {
                            this.showConteneurs = true
                        }

                    }
                })
            },
            showFacture (ligne) {
                this.loading = true
                this.dialogShowFacture = true
                this.factureCourant = ligne
                let totalHT = 0
                let totalTVA = 0
                let totalRemise = 0;
                for (let option in this.factureCourant.option) {
                    let item = this.factureCourant.option[option]

                    let tmpTotalHTSRem = parseFloat(item.prix * item.qte)
                    let mntRemise = 0;
                    let remise = parseFloat(item.remise)
                    if(remise > 0){
                        mntRemise =  (tmpTotalHTSRem  * remise) /100
                    }
                    let tmpTotalHT = tmpTotalHTSRem - mntRemise;
                    let tva = parseFloat( item.tva)
                    let tmpTotalTVA = ((tmpTotalHT) * (tva/ 100))

                    totalTVA += tmpTotalTVA
                    totalHT += tmpTotalHT
                    totalRemise += mntRemise;
                }
                
                console.log('showFacture',ligne)
                this.totalComHT = new Intl.NumberFormat().format(totalHT)
                this.totalComTVA = new Intl.NumberFormat().format(totalTVA )
                this.totalRabais = new Intl.NumberFormat('fr-Fr').format(ligne.rabais)
                this.totalComRetenu = new Intl.NumberFormat('fr-Fr').format(ligne.retenu)
                let url = this.domaine + 'fournisseur/' + this.factureCourant.idFact + '/show/facture'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.detailFacture = response.body.facture
                        this.loading = false
                    }
                })
            },
            refaireCommande() {
                this.loading = true
                let url = this.domaine + 'fournisseur/' + this.commReactiv + '/'+this.user.id +'/refaire/commande'
                this.$http.get(url).then(response => {
                    if (response.body) {
                       this.$notify({
                          title: "ENREGISTREMENT REUSSI",
                          message: "Commmande réinitialisé avec succès.",
                          type: "success",
                          position: "top-center"
                        });
                        // this.detailCommande = response.body.commande
                        this.dialogReactiv = false
                        this.loadCommandeRecent(this.fourSelect.id)
                        this.loadFactureRecent(this.fourSelect.id)
                        this.loadLivraisonRecent(this.fourSelect.id)
                        this.loading = false
                    }
                })

            },
            showCommande (ligne) {
                this.loading = true

                this.dialogShowCommande = true
                this.commCourant = ligne
                let totalRetenus = ligne.retenu
                let totalHT = 0
                let totalTVA = 0
                let totalRemise = 0;


                for (let option in this.commCourant.option) {
                    let item = this.commCourant.option[option]
                    let tmpTotalHTSRem = parseInt( (item.prix * item.qte) ,10)
                    let mntRemise = 0;
                    let remise = parseInt(item.remise,10)
                    if(remise > 0){
                        mntRemise =  (tmpTotalHTSRem  * remise) /100
                    }

                    let tmpTotalHT = tmpTotalHTSRem - mntRemise;
                    let tva = parseInt( item.tva,10)
                    let tmpTotalTVA = (tmpTotalHT * (tva/ 100))

                    totalTVA += tmpTotalTVA
                    totalHT += tmpTotalHT
                    totalRemise += mntRemise;
                }


                this.totalComHT = new Intl.NumberFormat('fr-Fr').format(totalHT)
                this.totalComTVA = new Intl.NumberFormat('fr-Fr').format(totalTVA)
                this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise)
                this.totalComRetenu = new Intl.NumberFormat('fr-Fr').format(totalRetenus)
                let url = this.domaine + 'fournisseur/' + this.commCourant.id + '/show/commande'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.detailCommande = response.body.commande

                        this.optionLivr = this.detailCommande.optionLivr
                        this.loading = false
                    }
                })
            },

            showMaintenance (ligne) {
                this.loading = true
                this.dialogShowMaintenance = true
                this.maintenanceCourant = ligne
                let url = this.domaine + 'fournisseur/' + this.maintenanceCourant.id + '/show/maintenance'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.detailMaintenance = response.body.maintenance
                        this.longDevis = this.detailMaintenance.devis.length
                        this.loading = false
                    }
                })
            },
            newFourn () {
                this.dialogEdit = false
                this.loginUser = ''
                this.nom = ''
                this.pren = ''
                this.dateNais = null
                this.lieuNais = ''
                this.selectNaturePiece = null
                this.numPiece = ''
                this.dateDeliv = null
                this.dateExpi = null
                this.contact = ''
                this.service = ''
                this.profession = ''
                this.domicile = ''
                this.nationalite = ''
                this.formJuridique = ''
                this.registreComm = ''
                this.siege = ''
                this.telBureau = ''
                this.representant = ''
                this.metier = ''
                this.selectType = null
                this.selectCivilite = null
            },
            addListArticleConteneur(item) {
                this.tableArticleConteneur.push({
                    designation : item.designation,
                    code : item.code,
                    tourtes : item.tourtes,

                    qte: item.qte,
                    poidsBrute : item.poidsBrute,
                    metrage : item.metrage,
                    poidsNet : item.poidsNet,
                    tare : item.tare,
                })
                this.oui = this.tableArticleConteneur
                this.tableEnsemble.infoArticle = this.oui
                this.formArticle = {}
            },
            filtrerMetier(){
                //this.oldListTravaux = this.listeTrx;
                let idMetier = this.chantierS;
                this.listFour = this.listFour.filter(function (item) {
                    return item.idmetier == idMetier
                })
            },
            filtrerProfession(){
                //this.oldListTravaux = this.listeTrx;
                let idProfession = this.projetS;
                this.listFour = this.listFour.filter(function (item) {
                    return item.idprofession == idProfession
                })
            },
            filtrerFournisseur(){
                //this.oldListTravaux = this.listeTrx;
                let idFournisseur = this.fourniS;
                this.listFour = this.listFour.filter(function (item) {
                    return item.id == idFournisseur
                })
            },
            filtrerTypeTarification() {
                 let idType = this.prodSelct;
                  let tab = this.listProduit
                   if((idType == null || idType == "undefined" || idType == "")){
                        this.listProduit = tab
                        return ;
                      }

                let libele = this.listTypeRessource.find(function (item) {
                    return item.id == idType
                })

                this.listProduit = tab.filter(function (item) {
                    return item.type == libele.value
                })
                this.comboProduit = this.listProduit
            },
            filtrerTarification(){
                let idProduit = this.produiS;
                if((idProduit == null || idProduit == "undefined" || idProduit == "")){
                    this.filtrerTypeTarification()
                    return ;
                  }
                let tab = this.listProduit
                this.listProduit = tab.filter(function (item) {
                    return item.id == idProduit
                })
            },
            clearSelect1(){
                //this.listeTrx = this.oldListTravaux;
                this.chantierS= '';
                this.listFour = this.listFourFinal;

                // this.listeChantier.splice(0)
            },
            clearSelect2(){
                //this.listeTrx = this.oldListTravaux;
                this.projetS= '';
                this.listFour = this.listFourFinal;
                // this.listeChantier.splice(0)
            },
            clearSelect3(){
                //this.listeTrx = this.oldListTravaux;
                this.fourniS= '';
                this.listFour = this.listFourFinal;
                // this.listeChantier.splice(0)
            },
            clearSelect4(){
                //this.listeTrx = this.oldListTravaux;
                this.produiS= '';
                this.listProduit = this.listProduiFinal;
                // this.listeChantier.splice(0)
            },
            showDetailsArticle (ligne) {

                // this.loading = true
                this.dialogShowArticle = true
                // this.livraisonCourant = ligne
                // this.tableArticleConteneur.getItem({
                //     designation : item.designation,
                //     code : item.code,
                //     tourtes : item.tourtes,
                //     tc : item.tc,
                //     qte: item.qte,
                //     poidsBrute : item.poidsBrute,
                //     metrage : item.metrage,
                //     poidsNet : item.poidsNet,
                //     Tare : item.Tare,
                // })

                // this.tableArticleConteneurAffiche = item

                // console.log('ligne',this.tableArticleConteneurAffiche )
                // let url = this.domaine + 'fournisseur/' + this.livraisonCourant.id + '/show/livraison'
                // this.$http.get(url).then(response => {
                //     if (response.body) {
                //         this.detailLivraison = response.body.livraison
                //         // this.loading = false
                //     }
                // })
            },
            addListConteneur() {
                this.loading = true;

                const articles = this.tableArticleConteneur.slice();
                let metrageTotal = 0
                let poidsNetTotal = 0
                let poidsBruteTotal = 0
                let tourtesTotal = 0
                let tareTotal = 0

                articles.forEach(element => {
                    metrageTotal += element.metrage
                    poidsNetTotal += element.poidsNet
                    poidsBruteTotal += element.poidsBrute
                    tourtesTotal += element.tourtes
                    tareTotal += element.Tare

                });
                this.formConteneur.metrageTotal = metrageTotal
                this.formConteneur.poidsNetTotal = poidsNetTotal
                this.formConteneur.poidsBruteTotal = poidsBruteTotal
                this.formConteneur.tourtesTotal = tourtesTotal
                this.formConteneur.tareTotal = tareTotal

                this.tableConteneur.push({
                    conteneur: this.formConteneur,
                    articles: this.tableArticleConteneur.slice()
                })

                //vider le formualire info container et liste article
                this.formConteneur = {}
                this.tableArticleConteneur.splice(0)
                this.loading = false;
            },
            newArticleConte (ligne) {
                this.loading = false
                this.dialogArticlConteneur = true
                this.code = ''
                this.designation = ''
                this.qte = ''

                this.metrage = ''
                this.poidsBrute = ''
                this.poidsNet = ''
                this.tare = ''
                this.tourtes = ''
            },
            newCommande (ligne) {
                this.loading = false
                this.dialogComm = true
                this.selectFourn = ''
                this.dialogEdit = false
                this.libelle = ''
                this.projetS = ''
                this.avance = 0
                this.chantierS = ''
                this.travauxS = ''
                this.listTravaux = []
                this.listChantier = []
                this.selectUsers = []
                this.dateLivr = null
                this.optionCommande = [{ key: 1, produit: '', prix: 0, qte: 1,remise:0, tva: 0, total: 0, id: '' }]
                this.totalComTTC = 0
                this.totComLigneTTCFormat = 0
                this.totalComHT = 0
                this.totalComHTSR = 0
                this.totalComRemise=0
                this.totalComRetenu =0
                this.totalComTVA = 0
                this.selectTypeCom = ''
                this.selectDemande = ''
                this.commCourant = []
            },
            newAppro (ligne) {
                this.loading = false
                this.livraisonCourant = ligne
                this.dialogAppro = true
                this.optionEntrepot = this.livraisonCourant.entrepot
                this.optionAppro = this.livraisonCourant.appro
                this.optionQteRecu = this.livraisonCourant.qteRecue
            },
            newLivraison (ligne) {

                this.loading = false
                this.factureCourant = ligne
                this.dialogLivraison = true
                this.tableConteneur.splice(0)
                this.optionLivraison = this.factureCourant.livre
                this.selectLivraison = ''
                this.selectTypeLivraison= ''
                this.provenanceConteneur = ''
                this.recepetionConteneur = ''
                this.numCpteLivraison = ''
                this.numVoyage = ''
                this.image2 = ""
            },
            newFacture (ligne) {
                this.disableCaisse  = false;
                this.loading = false
                this.commCourant = ligne
                this.dialogFacture = true
                this.dialogEdit = false
                this.selectContrat = null
                this.datePaie = ""
                this.selectCaisse = ligne.idCaisse
                this.libelle = ligne.libelle
                this.optionCommande = this.commCourant.option
                this.totalComTTC = 0
                this.totalRABAISTTC = 0
                this.totComLigneTTCFormat = 0
                this.totalComHT = 0
                this.totalRabais = 0
                this.totalRetenu = 0
                this.retenuGlobal = 'NON'
                this.retenuSelect = 0

                this.totalComHTSR = 0
                this.totalComRemise=0
                this.totalComRetenu =0
                this.totalComTVA = 0
                this.selectModalite = ligne.modalite
                this.avance = ligne.avance
                this.image1 = ""
                this.calculTotalComm()
            },
            newFactureFact (ligne) {
                this.loading = false
                this.dialogEdit = false
                this.disabledSelectCaisse = false
                this.dialogFactureFact = true
                this.logoFacture = "/static/img-doc.png",
                this.libelle = '',
                this.avance = 0
                this.totalComHT = 0
                this.totalComTVA = 0
                this.totalComRemise = 0
                this.totalComRetenu =0
                this.selectModalite = ""
                this.selectContrat = null
                this.selectCaisse = ""
                this.datePaie = ""
                this.optionCommande = [{ key: 1, produit: '', prix: 0, qte: 1, remise: 0, tva: 0, total: 0, id: '' }]                
            },
            newDevis (ligne) {
                this.loading = false
                this.maintenanceCourant = ligne
                this.dialogDevis = true
                this.dialogEdit = false
                this.optionDevis = this.maintenanceCourant.devis
                this.calculTotalDevis()
            },
            newTarif (ligne) {
                this.loading = false
                this.tarifCourant.id = ''
                this.dialogTarif = true
                this.dialogEdit = false
                this.selectProduit = ''
                this.prixAchat = 0
                this.selectIdProduit = ''
                this.tableTarification = []
            },
            editTarif (ligne) {
                this.loading = false
                this.tarifCourant.id = ligne.id
                this.dialogTarif = true
                this.dialogEdit = true
                this.selectProduit = ligne.libelle
                this.selectIdProduit = ligne.idproduit
                this.prixAchat = ligne.prixAchat
                this.valeurUniteMateriel = ligne.unite
                this.tableTarification = ligne
            },
            showTarif(ligne) {
              this.dialogShowTarif = true
               this.tarifCourant = ligne
            },
            deleteTarif(ligne) {
              this.dialogSupTarif = true
              this.tarifCourant.id = ligne.id
               this.selectProduit = ligne.libelle
            },
            editFourn (ligne) {
                this.loading = false
                if (ligne.type === 1) {
                    this.personneType = false
                } else {
                    this.personneType = true
                }
                this.typeF = ligne.type
                this.dialogEdit = true
                //this.dialogAjout = true
                this.showFour = true;
                this.fournCourant = ligne
                this.loginUser = ligne.email
                this.nom = ligne.nom
                this.pren = ligne.pren
                this.dateNais = ligne.dateNais
                this.lieuNais = ligne.lieuNais
                this.selectNaturePiece = ligne.naturePiece
                this.numPiece = ligne.numPiece
                this.dateDeliv = ligne.dateDeliv
                this.dateExpi = ligne.dateExpi
                this.contact = ligne.contact
                this.service = ligne.service
                this.profession = ligne.profession
                this.domicile = ligne.domicile
                this.nationalite = ligne.nationalite
                this.formJuridique = ligne.formJuridique
                this.registreComm = ligne.registreComm
                this.siege = ligne.siege
                this.telBureau = ligne.contact
                this.representant = ligne.representant
                this.metier = ligne.metier
                this.selectType = parseInt(ligne.typeFour)
                this.selectCivilite = ligne.civilite
            },
            editerFacture ()
            {


                this.loading = false
                if(this.factureCourant.idContrat != null){
                    this.$message({
                        message: "Impossible de modifier une facture contrat,Si cette facture comporte des erreurs elle doit etre rejetée par le DG",
                        type: 'warning',
                        duration:5000
                    });
                    return;
                }
                this.factureCourant =  this.detailFacture




                this.dialogFacture = true
                this.dialogEdit = true
                this.avance = this.factureCourant.avance
                this.libelle = this.factureCourant.libelle
                this.dateLivr = this.factureCourant.dateLivr
                this.selectModalite = this.factureCourant.modalite
                this.selectCaisse = this.factureCourant.caisse
                this.datePaie = this.factureCourant.datePaie
                this.optionCommande = this.factureCourant.option
                this.calculTotalComm()
            },

            editFacture (ligne)
            {
                this.loading = false
                this.commCourant = ligne
                if(ligne.length != 0) //commande courante
                {
                    this.factureCourant = ligne

                }
                //this.factureCourant = ligne

                this.dialogFacture = true
                this.dialogEdit = true
                this.dateLivr = this.factureCourant.dateLivr
                this.libelle = this.factureCourant.libelle
                this.avance = this.factureCourant.avance            
                this.selectModalite = this.factureCourant.modalite
                this.selectCaisse = this.factureCourant.caisse
                this.datePaie = this.factureCourant.datePaie
                this.optionCommande = this.factureCourant.option
                this.calculTotalComm()
            },
            editCommande (ligne, type = null) {
                this.assignTotier = false
                this.loading = true
                this.commCourant = ligne
                this.dialogComm = true
                this.selectFourn = ''
                this.dialogEdit = true
                this.libelle = this.commCourant.libelle
                this.projetS = this.commCourant.idProj
                this.listChantier = this.commCourant.listChantier
                this.chantierS = this.commCourant.idChan
                this.listTravaux = this.commCourant.listTravaux
                this.travauxS = this.commCourant.idTrav
                this.dateLivr = this.commCourant.dateLivr
                this.selectUsers = this.commCourant.user
                this.avance = this.factureCourant.avance            
                if(type) {
                    this.assignTotier = true
                }

                this.optionCommande = this.commCourant.option
                this.selectTypeCom = this.commCourant.type
                this.selectDemande = this.commCourant.idDmd
                this.calculTotalComm()
                this.loading = false
            },
            submitTarif () {
                this.loading = true
                var form = document.getElementById("formTarif");
                var data = new FormData(form);
                let url = "";
                if (!!this.tarifCourant.id) {
                  url =this.domaine + "fournisseur/new/" + this.tarifCourant.id+ "/tarif";
                } else {
                  url = this.domaine + "fournisseur/tarif/new";
                }
                if ((this.selectProduit != '' && this.prixAchat > 0 )) {
                    data.append('fournisseur', this.fournCourant.id)
                    data.append('produit', this.selectProduit)
                    data.append('selectIdProduit', this.selectIdProduit)
                    data.append('id', this.tarifCourant.id)
                    data.append('idUser', this.user.id)
                    data.append("tarif", JSON.stringify(this.tableTarification));
                    this.$http.post(url, data).then(response => {
                            if (response.body) {
                                let verif = response.body
                                if (verif.code === 1) {
                                    this.$notify({
                                        title: 'ENREGISTREMENT REUSSI',
                                        message: 'Tarification enregistré avec succès.',
                                        type: 'success',
                                        position: 'top-center'
                                    })
                                }
                                this.loadProduitFounRecent(this.fournCourant)
                                this.tableTarification = []
                                this.dialogTarif = false
                                this.dialogConfirm = false
                                this.loading = false
                            } else {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                                this.dialogAppro = false
                            }
                        },
                        response => {
                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                            this.loading = false
                    })
                } else if (this.tableTarification.length > 0)
                {
                    data.append('fournisseur', this.fournCourant.id)
                    data.append('id', this.tarifCourant.id)
                    data.append('idUser', this.user.id)
                    data.append("typeProduit", JSON.stringify(this.tableTarification));
                      this.$http.post(url, data).then(response => {
                            if (response.body) {
                                let verif = response.body
                                if (verif.code === 1) {
                                    this.$notify({
                                        title: 'ENREGISTREMENT REUSSI',
                                        message: 'Tarification enregistré avec succès.',
                                        type: 'success',
                                        position: 'top-center'
                                    })
                                }
                                this.loadProduitFounRecent(this.fournCourant)
                                this.dialogTarif = false
                                this.dialogConfirm = false
                                this.loading = false
                            } else {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                                this.dialogAppro = false
                            }
                        },
                        response => {
                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                            this.loading = false
                    })

                }else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La tarification n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            submitAppro () {
                this.loading = true
                if (this.$refs.formAppro.validate()) {
                    var form = document.getElementById('formAppro')
                    var formdata = new FormData(form);
                    let url = this.domaine + 'fournisseur/new/approvisionnement'
                    formdata.append('idLivr', this.livraisonCourant.id)
                    formdata.append('idUser', this.user.id)
                    let ligneEntre = null
                    let reste = null

                    for (let prop in this.optionQteRecu) {
                        ligneEntre = this.optionQteRecu[prop]

                        //verifie si la quantite saisi est null on passe au prochain produit
                        if(ligneEntre.qte == 0){
                            continue;
                        }

                        let valide = null
                        for (let item in this.optionEntrepot)
                        {
                            if(this.optionEntrepot[item].id == ligneEntre.idEntreprot)
                            {
                                valide = this.optionEntrepot[item].valide
                            }
                        }


                        formdata.append('recu[entrepot][]' , ligneEntre.idEntreprot)
                        formdata.append('recu[ligne][]' , ligneEntre.idLivre)
                        formdata.append('recu[qte][]' , ligneEntre.qte) //quantite saisie
                        formdata.append('recu[valide][]' , valide)
                    }



                    for (let item in this.optionAppro) {
                        //reste += this.optionAppro[item].qteL
                        reste += this.optionAppro[item].qteR
                    }
                    if (reste !== 0) {
                        this.loading = false;
                        this.$notify({
                            title: "ATTENTION",
                            message: "Vous devez obligatoirement repartir toutes la livraison.",
                            type: 'warning',
                            position: 'top-center'
                        })
                    } else {
                        this.$http.post(url, formdata).then(response => {
                                this.loading = false;
                                if (response.body) {
                                    let verif = response.body
                                    if (verif.code === 1) {
                                        this.$notify({
                                            title: 'ENREGISTREMENT REUSSI',
                                            message: 'Approvisionnement enregistré avec succès.',
                                            type: 'success',
                                            position: 'top-center'
                                        })
                                    }

                                    this.loadLivraisonRecent(this.fourSelect.id)
                                    this.loadFactureRecent(this.fourSelect.id)
                                    this.loadCommande(this.fourSelect)
                                    // this.showFourn(this.fourSelect.id)
                                    this.dialogAppro = false
                                    this.loading = false
                                } else {
                                    this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                    this.loading = false
                                    this.dialogAppro = false
                                }
                            },
                            response => {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                            })
                    }
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La livraison n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            deleteTarification() {
              //  this.loading = true
                let url = "";
                url =this.domaine + "fournisseur/delete/"+ this.tarifCourant.id+"/tarif";
                this.$http.get(url).then(response => {
                  if(response.body.code == 2) {
                  this.dialogSupTarif = false
                  this.loading = false
                     this.$notify({
                          title: 'SUPPRESSION REUSSI',
                          message: 'Tarification supprimé avec succès.',
                          type: 'success',
                          position: 'top-center'
                      })
                      this.loadProduitFounRecent(this.fournCourant)
                  }else{
                  this.loading = false
                     this.$message.error('Impossible de supprimer la tarification de ce produit car il est déja utilisé dans une commande')
                  }

                    },
                    error => {
                        // this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                        this.$message.error('Impossible de supprimer la tarification de ce produit, il est lié à une commande.')
                        this.loading = false
                })
            },
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            submitLivraison () {
                this.loading = true
                if (this.$refs.form.validate() &&  this.selectLivraison != "" && this.selectTypeLivraison != "") {
                    var form = document.getElementById('formLivraison')
                    var formdata = new FormData(form)
                    let url = this.domaine + 'fournisseur/new/livraison'
                    formdata.append('idFact', this.factureCourant.idFact)
                    formdata.append('etat', this.selectLivraison)
                    formdata.append('typeLivraison', this.selectTypeLivraison)
                    formdata.append('idUser', this.user.id)

                    if(this.selectTypeLivraison == 2 )
                    {
                        formdata.append('tableConteneurs', JSON.stringify(this.tableConteneur))

                    }

                    let ligne = null
                    for (let prop in this.optionLivraison) {
                        ligne = this.optionLivraison[prop]
                        formdata.append('options[id][]', ligne.id)
                        formdata.append('options[produit][]', ligne.produit)
                        formdata.append('options[qte][]', ligne.qte)
                        formdata.append('options[qteL][]', ligne.qteL)
                    }
                    this.$http.post(url, formdata).then(response => {
                            this.dialogLivraison = false
                            this.loadLivraisonRecent(this.fourSelect.id)
                            this.loadFactureRecent(this.fourSelect.id)
                            this.loadCommande(this.fourSelect)
                            this.loading = false
                            this.$notify({
                                title: 'ENREGISTREMENT REUSSI',
                                message: 'Livraison enregistré avec succès.',
                                type: 'success',
                                position: 'top-center'
                            })
                            if (response.body) {
                                let verif = response.body
                                if (verif.code === 1) {


                                } else if (verif.code === 2) {
                                    this.$message.error(verif.message)
                                    this.loading = false
                                    this.dialogLivraison = false
                                } else if (verif.code === 3) {
                                    this.$message.error(verif.message)
                                    this.loading = false
                                    this.dialogLivraison = false
                                }
                                this.loading = false
                            } else {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                                this.dialogLivraison = false
                            }
                        },
                        response => {
                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                            this.loading = false
                        })
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La livraison n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            deleteTache(position,rows) {
                rows.splice(position, 1);
            },
            addListTaches(produit,prix) {
                let libelle = this.listeProd.filter(function (item) {
                    if(item.id == produit) return item.value
                })

                this.tableTarification.push({
                    idprod : produit,
                    codeGestion : this.codegestion,
                    unite: this.valeurUniteMateriel,
                    produit : libelle[0]['value'],
                    prix : prix,
                })
                this.dialogTarif = true
                this.selectProduit=''
                this.prixAchat=''
                this.codegestion = ''
                this.valeurUniteMateriel =''
            },
            submitValidFacture () {

                //verification montant facture contrat
                if(this.selectContrat != "undefined" && this.selectContrat != null  ){
                    if(this.totComLigneTTCFormat > this.mntRestantContrat){
                        this.$message.error("Le montant TTC definit est supérieur au montant restant "+this.mntRestantContrat);
                        return
                    }
                }


                this.loading = true
                if (this.$refs.form.validate()) {
                    var form = document.getElementById('formValidFacture')
                    var formdata = new FormData(form)
                    let url = this.domaine + 'fournisseur/valider/facture'
                    formdata.append('id', this.factureCourant.idFact)
                    formdata.append('idUser', this.user.id)
                    formdata.append('decision', this.selectDecisionFact)
                    this.$http.post(url, formdata).then(response => {
                            if (response.body) {
                                let verif = response.body
                                if (verif.code === 1) {
                                    this.$notify({
                                        title: 'VALIDATION REUSSI',
                                        message: 'Facture validé avec succès.',
                                        type: 'success',
                                        position: 'top-center'
                                    })
                                    this.loading = false
                                } else if (verif.code === 2) {
                                    this.$message.error(verif.message)
                                    this.loading = false
                                }
                                this.loading = false
                                this.loadFactureRecent(this.fourSelect.id)
                                this.loadCommandeRecent(this.fourSelect.id)
                                this.calculTotalComm()
                                this.dialogValiFacture = false
                                this.showFourn(this.fournCourant)
                            } else {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                                this.dialogValiFacture = false
                            }
                        },
                        response => {
                            this.$message.error('Veuillez obligatoirement ajouté des lignes de commande')
                            this.loading = false
                        })
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La facture n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            submitFacture () {
                this.loading = true
                if (this.$refs.form.validate() && this.selectModalite != "" && this.datePaie != "" && this.image1 != "/static/img-doc.png") {
                    let etat = false
                    if (this.optionCommande.length > 0) {
                        this.optionCommande.forEach(function(item){
                            if (item.produit != '' && item.prix > 0 && item.qte > 0) {
                                etat = true
                            }
                        })
                    }

                    if (etat == true) {
                        var form = document.getElementById('formFacture')
                        let data = new FormData(form);

                        let url=''
                        data.append('total', this.totalComTTC)
                        data.append('id', this.commCourant.id)
                        data.append('idUser', this.user.id)
                        data.append('modalite', this.selectModalite)
                        data.append('avance', this.avance)
                        // data.append('caisse', this.selectCaisse)
                        data.append('id', this.commCourant.id)
                         //on va enregister dabor la facture
                        url = this.domaine + "fournisseur/facture/new";

                        this.$http.post(url, data).then(
                            response => {
                              if (response.body) {
                                  let verif = response.body

                                  url = this.domaine + 'fournisseur/new/facture'

                                let nbData = 10;
                                let nbReq = 1;
                                let ligne = null;

                                let nbRest
                                    if (this.optionCommande.length > 10) {
                                      nbData = 10;
                                      nbReq = Math.round(this.optionCommande.length / nbData);
                                      nbRest = this.optionCommande.length % nbData;
                                      if (nbRest > 0) {
                                        nbReq += 1;
                                      }
                                    }

                                for(let i=0; i<nbReq;i++) {
                                        let initJ = i*nbData;
                                        let finJ = (i + 1) * nbData;
                                        let dataLot = [];
                                        if(this.optionCommande.length > 0){
                                            for(let j = initJ;j < finJ;j++){
                                                if(this.optionCommande[j] == undefined){
                                                    break ;
                                                }
                                                dataLot.push(this.optionCommande[j]);
                                            }
                                        }
                                        let data = new FormData(form);

                                        for (let prop in dataLot) {
                                            ligne = dataLot[prop];
                                            data.append('options[id][]', ligne.id)
                                            data.append('options[produit][]', ligne.produit)
                                            data.append('options[libelle][]', ligne.libelle)
                                            data.append('options[prix][]', ligne.prix)
                                            data.append('options[qte][]', ligne.qte)
                                            data.append('options[unite][]', ligne.unite)
                                            data.append('options[tva][]', this.tvaSelect != 0 ? this.tvaSelect : ligne.tva)
                                            data.append('options[remise][]', this.remiseSelect != 0 ? this.remiseSelect : ligne.remise)
                                            data.append('options[total][]', ligne.total)
                                          }
                                        data.append("idFacture", verif.idFacture);

                                        console.log('thi',this.totalRETENU)
                                        data.append('total', this.totalComTTC)
                                        data.append('totalRabais', this.totalRABAISTTC)
                                        data.append('retenuPrc', this.retenuSelect)
                                        
                                        data.append('totalRetenu', this.totalRETENU )
                                        data.append('id', this.commCourant.id)
                                        data.append('idUser', this.user.id)
                                        data.append('modalite', this.selectModalite)
                                        data.append('avance', this.avance)

                                        this.loading = true

                                        this.$http.post(url, data).then(
                                            response => {
                                              if (response.body) {
                                                    let verif = response.body
                                                    if (verif.code === 1) {
                                                        if (this.factureCourant.idFact) {
                                                            this.$notify({
                                                                title: 'MODIFICATION REUSSI',
                                                                message: response.body.message,
                                                                type: 'success',
                                                                position: 'top-center'
                                                            })
                                                        } else {
                                                            this.$notify({
                                                                title: 'ENREGISTREMENT REUSSI',
                                                                message: response.body.message,
                                                                type: 'success',
                                                                position: 'top-center'
                                                            })
                                                        }
                                                    } else if (verif.code === 2) {
                                                        this.$message.error(verif.message)
                                                        this.loading = false
                                                    }
                                                    this.loading = false
                                                    this.calculTotalComm()
                                                    this.loadFactureRecent(this.fourSelect.id)
                                                    this.loadCommandeRecent(this.fourSelect.id)
                                                    // this.showFourn(this.fournCourant)
                                                    this.dialogFacture = false
                                                    this.dialogShowCommande = false
                                                } else {
                                                    this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                                    this.loading = false
                                                    this.dialogFacture = false
                                                    this.dialogShowCommande = false
                                                }
                                            },
                                            error => {
                                              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                              this.loading = false
                                            }
                                        )
                                        }


                                        } else {
                                            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                            this.loading = false
                                            this.dialogFacture = false
                                            this.dialogShowCommande = false
                                        }
                                    },
                                      error => {
                                        this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                        this.loading = false
                                      }
                                  )
                    } else {
                        this.$notify({
                            title: "ATTENTION",
                            message: "Vous devez obligatoirement enregistré des lignes pour la facture et que ces lignes ont été correctements remplis.",
                            position: 'top-center',
                            type: 'warning'
                        })
                        this.loading = false
                    }
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La facture n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },

            submitEditFacture () {
                this.loading = true
                if (this.$refs.form.validate() && this.selectModalite != "" && this.selectCaisse != "" && this.datePaie != "" && this.image1 != "/static/img-doc.png") {
                    let etat = false
                    if (this.optionCommande.length > 0) {
                        this.optionCommande.forEach(function(item){
                            if (item.produit != '' && item.prix > 0 && item.qte > 0) {
                                etat = true
                            }
                        })
                    }

                    if (etat == true) {
                        var form = document.getElementById('formFacture')
                        var formdata = new FormData(form)

                        let  url = this.domaine + 'fournisseur/' + this.factureCourant.idFact + '/edit/facture'

                        for (let prop in this.optionCommande) {
                            let ligne = this.optionCommande[prop]
                            formdata.append('options[id][]', ligne.id)
                            formdata.append('options[produit][]', ligne.produit)
                            formdata.append('options[libelle][]', ligne.libelle)
                            formdata.append('options[prix][]', ligne.prix)
                            formdata.append('options[qte][]', ligne.qte)
                            formdata.append('options[unite][]', ligne.unite)
                            formdata.append('options[tva][]', ligne.tva)
                            formdata.append('options[remise][]',ligne.remise !=null ? ligne.remise : 0)
                            formdata.append('options[total][]', ligne.total)
                        }

                        formdata.append('total', this.totalComTTC)
                        formdata.append('id', this.commCourant.id)
                        formdata.append('idUser', this.user.id)
                        formdata.append('modalite', this.selectModalite)
                        formdata.append('avance', this.avance)
                        formdata.append('caisse', this.selectCaisse)
                        this.loading = true
                        this.$http.post(url, formdata).then(response => {
                                this.dialogShowFacture = false;
                                if (response.body) {
                                    let verif = response.body
                                    if (verif.code === 1) {
                                        if (this.factureCourant.idFact) {
                                            this.$notify({
                                                title: 'MODIFICATION REUSSI',
                                                message:  response.body.message,
                                                type: 'success',
                                                position: 'top-center'
                                            })
                                        } else {
                                            this.$notify({
                                                title: 'ENREGISTREMENT REUSSI',
                                                message: response.body.message,
                                                type: 'success',
                                                position: 'top-center'
                                            })
                                        }
                                    } else if (verif.code === 2) {
                                        this.$message.error(verif.message)
                                        this.loading = false
                                    }
                                    this.loading = false
                                    this.calculTotalComm()
                                    this.loadFactureRecent(this.fourSelect.id)
                                    this.loadCommandeRecent(this.fourSelect.id)
                                    // this.showFourn(this.fournCourant)
                                    this.dialogFacture = false
                                } else {
                                    this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                    this.loading = false
                                    this.dialogFacture = false
                                }
                            },
                            response => {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                            })
                    } else {
                        this.$notify({
                            title: "ATTENTION",
                            message: "Vous devez obligatoirement enregistré des lignes pour la facture et que ces lignes ont été correctements remplis.",
                            position: 'top-center',
                            type: 'warning'
                        })
                        this.loading = false
                    }
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La facture n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            submitFactureFact () {
                // this.loading = true
                //Verfions si le montant a verser ne depasse pas le montant total restant de la facture
                if( (this.selectContrat != null) &&  (this.optionCommande[0].prix >  this.selectContrat.mntRestant )){
                this.loading = false

                    this.$message({
                        message: 'Attention, le montant à verser supérieur au montant restant',
                        type: 'warning'
                    });
                    return;
                }

                if (this.$refs.formFactureFact.validate()) {
                    let etat = false
                    if (this.optionCommande.length > 0) {
                        this.optionCommande.forEach(function(item){
                            if (item.produit != '' && item.prix > 0 && item.qte > 0) {
                                etat = true
                            }
                        })
                    }

                    if (etat == true) {
                        var form = document.getElementById('formFactureFact')
                        var formdata = new FormData(form)
                        for (let prop in this.optionCommande) {
                            let ligne = this.optionCommande[prop]
                            formdata.append('options[id][]', ligne.id)
                            formdata.append('options[produit][]', ligne.produit)
                            formdata.append('options[prix][]', ligne.prix)
                            formdata.append('options[qte][]', ligne.qte)
                            formdata.append('options[unite][]', ligne.unite)
                            formdata.append('options[libelle][]', ligne.libelle)
                            formdata.append('options[tva][]', ligne.tva)
                            formdata.append('options[remise][]', ligne.remise !=null ? ligne.remise : 0)
                            formdata.append('options[total][]', ligne.total)
                        }
                        formdata.append('total', this.totalComTTC)
                        formdata.append('idfourn', this.fournCourant.id)
                        formdata.append('modalite', this.selectModalite)
                        formdata.append('avance', this.avance)
                        formdata.append('caisse', this.selectCaisse)

                        formdata.append('contratId', this.selectContrat)
                        formdata.append('chantierId', this.chantierS)
                        formdata.append('travauxId', this.travauxS)
                        formdata.append('travaux',this.travauxS)
                        formdata.append('idtache', this.libTachePrest)
                        formdata.append('idUser', this.user.id)

                        let url = this.domaine + 'fournisseur/devis/fact';
                        this.$http.post(url, formdata).then(response => {
                                if (response.body) {
                                    let verif = response.body
                                    if (verif.code === 1) {
                                        this.$notify({
                                            title: 'ENREGISTREMENT REUSSI',
                                            message: response.body.message,
                                            type: 'success',
                                            position: 'top-center'
                                        })
                                        this.loadFactureRecent(this.fourSelect.id)
                                        // this.showFourn(this.fournCourant)
                                        this.dialogFactureFact = false
                                        this.loading = false
                                        this.clear()
                                    } else if (verif.code === 2) {
                                        this.$message.error(verif.message)
                                        this.loading = false
                                    } else if (verif.code === 0) {
                                        this.$message.error(verif.message)
                                        this.loading = false
                                    }
                                } else {
                                    this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                    this.loading = false
                                    this.clear()
                                }
                            },
                            response => {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                            })
                    } else {
                        this.$notify({
                            title: "ATTENTION",
                            message: "Vous devez obligatoirement enregistré des lignes pour la facture et que ces lignes ont été correctements remplis.",
                            position: 'top-center',
                            type: 'warning'
                        })
                        this.loading = false
                    }
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La facture n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
                //enregistrement des images
            onFileImageFacturePicked(event)
            {
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.logoFacture = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.logoFacture = files[0]

            },
            submitDevis () {
                this.loading = true
                if (this.$refs.formDevis.validate()) {
                    var form = document.getElementById('formDevis')
                    var formdata = new FormData(form)
                    let ligne = null
                    let url = this.domaine + 'fournisseur/' + this.maintenanceCourant.id + '/new/devis'
                    for (let prop in this.optionDevis) {
                        ligne = this.optionDevis[prop]
                        formdata.append('options[id][]', ligne.id)
                        formdata.append('options[produit][]', ligne.produit)
                        formdata.append('options[prix][]', ligne.cout)
                        formdata.append('options[qte][]', ligne.qte)
                        formdata.append('options[unite][]', ligne.unite)
                        formdata.append('options[tva][]', ligne.tva)
                    }

                    formdata.append('idUser', this.user.id)
                    if (ligne !== null) {
                        this.$http.post(url, formdata).then(response => {
                                if (response.body) {
                                    let verif = response.body
                                    if (verif.code === 1) {
                                        this.$notify({
                                            title: 'ENREGISTREMENT REUSSI',
                                            message: 'Devis enregistré avec succès.',
                                            type: 'success',
                                            position: 'top-center'
                                        })

                                        this.loadFactureRecent(this.fourSelect.id)
                                        // this.showFourn(this.fournCourant)
                                        this.loadMaintenanceRecent(this.fourSelect.id)
                                        this.dialogDevis = false
                                        this.loading = false
                                        this.clear()
                                    } else if (verif.code === 0) {
                                        this.$message.error(verif.message)
                                        this.loading = false
                                    }
                                } else {
                                    this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                    this.loading = false
                                    this.clear()
                                }
                            },
                            response => {
                                this.$message.error('Veuillez obligatoirement ajouté des lignes de commande')
                                this.loading = false
                            })
                    } else {
                        this.$notify({
                            title: "ATTENTION",
                            message: "Vous devez obligatoirement enregistré des lignes pour la commande.",
                            position: 'top-center',
                            type: 'warning'
                        })
                        this.loading = false
                    }
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La devis n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            displayMontant(){
                this.loading = true
                if (this.$refs.formComm.validate() && this.libelle != "" && this.dateLivr != "" && (this.travauxS != "" || this.selectDemande != '')) {
                    this.calculTotalComm()
                    this.dialogMontantCommande = true;
                }
                else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La commande n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }

            },
            submitComm () {
                this.loading = true
                this.disBtnAjtCom  = true;
                this.dialogMontantCommande = false
                this.dialogComm = false
                if (this.$refs.formComm.validate() && this.libelle != "" && this.dateLivr != "" && (this.travauxS != "" || this.selectDemande != '')) {
                    let etat = false
                    if (this.optionCommande.length > 0) {
                        this.optionCommande.forEach(function(item){
                            if (item.produit != '' && item.prix > 0 && item.qte > 0) {
                                etat = true
                            }
                        })
                    }
                    if(this.assignTotier && this.selectFourn == '') {
                        this.$message.error('Veuillez selectionner le fournisseur')
                        this.loading = false
                    }

                    if (etat == true) {
                        let url = ''

                        var form = document.getElementById('formComm')
                        var formdata = new FormData(form)

                        if (this.commCourant.id) {
                            url = this.domaine + 'fournisseur/edit/commande'
                            formdata.append('id', this.commCourant.id)
                            formdata.append('listSupp', this.listSupp)
                            formdata.append('selectFourn', this.selectFourn)
                            this.assignTotier = false
                        } else {
                            url = this.domaine + 'fournisseur/new/commande'
                            formdata.append('id', this.fourSelect.id)
                        }

                        for (let prop in this.optionCommande) {
                            let ligne = this.optionCommande[prop]
                            formdata.append('options[id][]', ligne.id)
                            formdata.append('options[produit][]', ligne.produit)
                            formdata.append('options[prix][]', ligne.prix)
                            formdata.append('options[qte][]', ligne.qte)
                            formdata.append('options[unite][]', ligne.unite)
                            formdata.append('options[tva][]', ligne.tva)
                            formdata.append('options[remise][]', ligne.remise !=null ? ligne.remise : 0)
                            formdata.append('options[total][]', ligne.total)
                        }

                        formdata.append('total', this.totalComTTC)
                        formdata.append('users', this.selectUsers)
                        formdata.append('idUser', this.user.id)
                        formdata.append('travaux', this.travauxS)
                        formdata.append('demande', this.selectDemande)
                        formdata.append('modePaie', this.modePaie)
                        formdata.append('avance', this.avance)
                        formdata.append('type', this.selectTypeCom)

                        this.$http.post(url, formdata).then(response => {
                                this.disBtnAjtCom  = false;
                                this.loading = false;
                                if (response.body) {
                                    this.dialogShowCommande = false
                                    let verif = response.body
                                    if (verif.code === 1) {
                                        this.disBtnAjtCom  = false;
                                        if (this.commCourant.id) {
                                            this.$notify({
                                                title: 'MODIFICATION REUSSI',
                                                message: response.body.message,
                                                type: 'success',
                                                position: 'top-center'
                                            })
                                        } else {
                                            this.disBtnAjtCom  = false;
                                            this.$notify({
                                                title: 'ENREGISTREMENT REUSSI',
                                                message: response.body.message,
                                                type: 'success',
                                                position: 'top-center'
                                            })
                                        }
                                        this.disBtnAjtCom  = false;
                                        this.loadCommandeRecent(this.fourSelect.id)
                                        // this.showFourn(this.fournCourant)
                                        this.dialogComm = false
                                        this.loading = false
                                        this.$refs.formComm.reset()
                                    } else if (verif.code === 2) {
                                        this.loading = false
                                        this.disBtnAjtCom  = false;
                                        this.$message.error(verif.message)
                                    }
                                } else {
                                    this.disBtnAjtCom  = false;
                                    this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                    this.loading = false
                                    this.clear()
                                }
                            },
                            response => {
                                this.disBtnAjtCom  = false;
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                            })
                    } else {
                        this.disBtnAjtCom  = false;
                        this.$notify({
                            title: "ATTENTION",
                            message: "Vous devez obligatoirement enregistré des lignes pour la commande et que ces lignes ont été correctements remplis.",
                            position: 'top-center',
                            type: 'warning'
                        })
                        this.loading = false
                    }
                } else {
                    this.disBtnAjtCom  = false;
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "La commande n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            submitFourn () {
                this.loading = true
                if (this.$refs.form.validate()) {
                    if (this.mdpUser === this.mdpVerUser) {
                        let url = ''
                        var form = document.getElementById('formFour')
                        var data = new FormData(form)
                        if (this.fournCourant.id) {
                            url = this.domaine + 'fournisseur/update'
                            data.append('id', this.fournCourant.id)
                        } else {
                            url = this.domaine + 'fournisseur/create'
                        }
                        if (this.personneType === true) {
                            data.append('type', 0)
                        } else {
                            data.append('type', 1)
                        }
                        data.append('typeFour', this.selectType)
                        data.append('metier', this.selectTypeEntre)
                        data.append('civilite', this.selectCivilite)
                        data.append('naturePiece', this.selectNaturePiece)
                        data.append('idUser', this.user.id)
                        this.$http.post(url, data).then(response => {
                                if (response.body) {
                                    let verif = response.body
                                    if (verif.code === 1) {
                                        if (this.fournCourant.id) {
                                            this.$notify({
                                                title: 'MODIFICATION REUSSI',
                                                message: 'Fournisseur modifié avec succès.',
                                                type: 'success',
                                                position: 'top-center'
                                            })
                                        } else {
                                            this.$notify({
                                                title: 'ENREGISTREMENT REUSSI',
                                                message: 'Fournisseur enregistré avec succès.',
                                                type: 'success',
                                                position: 'top-center'
                                            })
                                        }
                                        // this.loadFourn()
                                        this.loadFournLimit()
                                        this.loadPage()
                                        //this.dialogAjout = false
                                        this.dialogEdit = false
                                        this.loading = false
                                        this.clear()
                                    } else{
                                        this.$message.error(verif.message)
                                        this.loading = false
                                    }
                                } else {
                                    this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                    this.loading = false
                                }
                            },
                            response => {
                                this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                                this.loading = false
                            })
                    } else {
                        this.$message.error('Le mot de passe de vérification doit être identique au mot de passe')
                        this.loading = false

                    }
                } else {
                    this.$message.error('Veuillez renseigner les champs obligatoires')
                    this.$notify.error({
                        title: "ERREUR D'ENREGISTREMENT",
                        message: "Le fournisseur n'a pas été enregistré.",
                        position: 'top-center'
                    })
                    this.loading = false
                }
            },
            validFacture (ligne) {
                this.loading = false
                this.factureCourant = ligne
                this.dialogValiFacture = true
            },
            handlePictureCardPreview (file) {
                this.dialogDocsUrl = file.url
                this.dialogDocsVisible = true
            },
            calculTotalAppro (entreprosParam,livraisonParam,index)
            {

                let total = 0;
                for(let itemm in this.optionEntrepot)
                {
                    for(let item in this.optionQteRecu)
                    {
                        if(this.optionQteRecu[item].idLivre == livraisonParam.id &&  this.optionQteRecu[item].idEntreprot == this.optionEntrepot[itemm].id && this.optionEntrepot[itemm].valide == true ){
                            total += parseInt(this.optionQteRecu[item].qte)
                        }
                    }
                }
                this.optionAppro[index].qteR = parseInt(this.optionAppro[index].qteLivre) - total
            },

            qtelivraison(option,entrepros){
                for(let item in this.optionQteRecu){
                    if( this.optionQteRecu[item].idLivre == option.id && this.optionQteRecu[item].idEntreprot == entrepros.id ){
                        return this.optionQteRecu[item].qte
                    }
                }
            },
            addOptionComm () {

                this.optionCommande.push({
                    key: Date.now(),
                    produit: '',
                    prix: 0,
                    qte: 1,
                    remise: 0,
                    tva: 0,
                    total: 0,
                    id: ''
                })
                this.totComLigneTTC += 5
            },
            totauxCommande(index){
                let idProduit = this.optionCommande[index].produit;
                if(isNaN(idProduit)){
                    idProduit = this.optionCommande[index].id;
                }
                let mntHT = 0
                let mntTTC = 0;
                let mntTva = 0;
                let mntRemise = 0;
                let mntHTSRem = 0;

                if (idProduit != '' ) {
                  if(this.dialogEdit == false) {
                    let url = this.domaine + 'fournisseur/info/produit/'+idProduit
                    var data = new FormData()
                    data.append('fournisseur', this.fourSelect.id)
                    this.loading = true
                    this.$http.post(url, data).then(response =>
                        {
                            if (response.body) {
                                this.loading = false
                                this.infoProduit = response.body

                                //ceki etait la avant modification de la transformation en commande
                                let prixOpt =  parseFloat(this.infoProduit.prixAchat ) ;
                                this.dialogEdit == false
                                this.optionCommande[index].prix = this.infoProduit.prixAchat

                                this.optionCommande[index].id = this.infoProduit.id
                                let qteOpt = parseFloat( this.optionCommande[index].qte);
                                let tvaOpt = parseFloat( this.optionCommande[index].tva);
                                let remiseOpt = parseFloat( this.optionCommande[index].remise);


                                mntHTSRem =  ( prixOpt * qteOpt);
                                mntRemise = (remiseOpt > 0) ? ( (mntHTSRem * remiseOpt) / 100): 0;
                                mntHT = mntHTSRem - mntRemise;
                                mntTva = Math.round(   mntHT * (tvaOpt / 100) )
                                mntTTC = mntHT + mntTva



                                this.optionCommande[index].total =  mntTTC ;
                                this.optionCommande[index].prix = this.infoProduit.prixAchat;



                                this.optionCommande[index].unite =this.infoProduit.unite;


                                this.loading = false
                            }
                        },
                        response => {
                            this.loading = false
                        })
                  } else {
                     let optionCmd = this.optionCommande.slice();   
                     let totalHT = 0
                    let totalHTRS = 0
                    let totalTVA = 0
                    let totalRemise = 0
                    let mntTotal = 0;     
                    let tot = 0;    
                    let totHT = 0;    
                     
                    for (let prop in optionCmd)
                        {
                             this.loading = false

                            let item = optionCmd[prop]
                            let itemPrix = item.prix;
                            let itemQte = item.qte;
                            let itemTva = item.tva;
                            let itemRemise =item.remise;

                            let mntHtSRem = itemPrix * itemQte;
                            let mntRemise = (itemRemise > 0) ? (mntHtSRem * itemRemise ) /100 : 0;
                            let mntHT = mntHtSRem -  mntRemise;
                            totalHT += mntHT
                            totalTVA += Math.round((mntHT) * (itemTva  / 100))
                            tot = (mntHT) + Math.round((mntHT) * (itemTva  / 100))
                            totHT = Math.round((mntHT))
                            mntTotal += totHT;
                            this.optionCommande[prop].total = totHT;
                            this.optionCommande[index].total =  totHT ;

                            this.totalComRemise = new Intl.NumberFormat("fr-FR").format(mntRemise);

                        }

                        //  this.loading = false
                        //   //ceki etait la avant modification de la transformation en commande
                        //   let prixOpt =  parseFloat(this.optionCommande[index].prix ) ;
                        //   let prixReseigner = this.optionCommande[index].prix
                        //   this.optionCommande[index].prix = prixReseigner

                        //   this.optionCommande[index].id = this.optionCommande[index].id
                        //   let qteOpt = parseFloat( this.optionCommande[index].qte);
                        //   let tvaOpt = parseFloat( this.optionCommande[index].tva);
                        //   let remiseOpt = parseFloat( this.optionCommande[index].remise);


                        //   mntHTSRem =  ( prixOpt * qteOpt);
                        //   mntRemise = (remiseOpt > 0) ? ( (mntHTSRem * remiseOpt) / 100): 0;
                        //   mntHT = mntHTSRem - mntRemise;
                        //   mntTva = Math.round(   mntHT * (tvaOpt / 100) )
                        //   mntTTC = mntHT + mntTva

                        // //   this.totalComRemise = new Intl.NumberFormat("fr-FR").format(totalRemise);

                        //   this.optionCommande[index].total =  mntTTC ;
                        //     console.log('AHH',this.optionCommande[index].total)

                        // this.totalComRemise = new Intl.NumberFormat("fr-FR").format(mntRemise);
                       

                          // this.optionCommande[index].prix = this.infoProduit.prixAchat;
                  }

                } else {
                    this.loading = false
                    this.$message.error('Veuillez sélectionner une ressource')
                }


            },
            calculTotalComm () {
                this.loading = true
                this.totComLigneTTC = 0
                let totalHT = 0
                let totalHTRS = 0
                let totalTVA = 0
                let totalRemise = 0
                let mntTotal = 0;
                let valrabais = 0
                let valretenu = 0

                let optionCmd = this.optionCommande.slice();
                for (let prop in optionCmd)
                {
                    let item = optionCmd[prop]
                    let tot = 0;
                    let totHT = 0
                    
                    if (item.produit != '' ) {
                        if( this.dialogEdit == false || this.selectContrat == undefined || this.selectContrat == null ){
                            let idProd = "";
                            if(item.id != null && item.id != "" ){
                                idProd = item.id;
                            }
                            else if(item.produit != null && item.produit != ""  ){
                                idProd = item.produit;
                            }
                            else{
                                return;
                            }
                            let url = this.domaine + 'fournisseur/info/produit/'+idProd
                            var data = new FormData()
                            data.append('fournisseur', this.fourSelect.id)
                            if(typeof(item.produit) != 'string') {
                               this.$http.post(url, data).then(response => {
                                    if (response.body) {
                                        let itemPrix = item.prix;
                                        let itemQte = item.qte;

                                        let itemTva =  this.tvaSelect != 0 ? this.tvaSelect : item.tva;
                                        let itemRemise = this.remiseSelect != 0 ? this.remiseSelect : item.remise;

                                        
                                        this.infoProduit = response.body
                                        // ANCIEN
                                        // item.prix = (this.infoProduit.prixAchat != 0) ? itemPrix :  this.infoProduit.prixAchat ;
                                        item.prix = (this.infoProduit.prixAchat != 0) ? this.infoProduit.prixAchat : itemPrix ;
                                        item.produit = this.infoProduit.produit
                                        item.id = this.infoProduit.id


                                        let mntHtSRem = itemPrix * itemQte;
                                        // CEKI ETAI LA
                                        let mntRemise = (itemRemise > 0) ? (mntHtSRem * itemRemise ) /100 : 0;
                                        let mntHT = mntHtSRem -  mntRemise                                         
                              

                                        if(this.rabaisGlobal == '%' && this.rabaisSelect != 0 ) {
                                            valrabais += (mntHT * this.rabaisSelect / 100 )                                    
                                        }
                                        if(this.rabaisGlobal == 'MONTANT' && this.rabaisSelect != 0) {
                                            valrabais = (this.rabaisSelect )
                                        }
                                        valretenu = 0
                                        if(this.retenuSelect != 0 && this.retenuGlobal == 'OUI') {
                                            valretenu =  totalHT * this.retenuSelect /100                                           
                                        }
                                        totalRemise += mntRemise;
                                        totalHT += mntHT;
                                        totalTVA += Math.round((mntHT) * (itemTva / 100))
                                        tot = (mntHT) + (mntHT)                                        
                                        totHT = mntHT
                                        mntTotal += totHT;
                                        totalHTRS += mntHT + mntRemise;
                                        this.optionCommande[prop].id =  item.id;
                                        this.optionCommande[prop].produit =  item.produit;
                                        this.optionCommande[prop].total = totHT
                                        this.optionCommande[prop].prix =item.prix;
                                        this.optionCommande[prop].unite =this.infoProduit.unite;
                                        this.optionCommande[prop].tva = 0;
                                        this.optionCommande[prop].remise= 0;
                                        
                                        this.totalComHT = new Intl.NumberFormat("fr-FR").format(totalHT);
                                        this.totalComRemise = new Intl.NumberFormat("fr-FR").format(totalRemise);
                                        this.totalComHTSR = new Intl.NumberFormat("fr-FR").format(totalHTRS);
                                        this.totalComTVA = new Intl.NumberFormat("fr-FR").format(totalTVA);
                                        this.totalRabais = new Intl.NumberFormat('fr-Fr').format(valrabais)
                                        this.totalRetenu = new Intl.NumberFormat('fr-Fr').format(valretenu)
                                        console.log('jfjf',valretenu)
                                        this.totalRETENU = Math.round(valretenu)
                                        this.totalRABAISTTC = Math.round(valrabais)
                                        this.totComLigneTTCFormat =  new Intl.NumberFormat("fr-FR").format(Math.round((mntTotal- valretenu + totalTVA - valrabais )));
                                        this.totalComTTC = Math.round((mntTotal - valretenu  + totalTVA - valrabais ));
                                        this.loading = false
                                    }
                                },
                                response => {
                                    this.loading = false
                                })
                            }else {

                                let itemPrix = item.prix;
                                let itemQte = item.qte;
                                let itemTva =  this.tvaSelect != 0 ? this.tvaSelect : item.tva;
                                let itemRemise = this.remiseSelect != 0 ? this.remiseSelect : item.remise;

                                let mntHtSRem = itemPrix * itemQte;
                                let mntRemise = (itemRemise > 0) ? (mntHtSRem * itemRemise ) /100 : 0;
                                let mntHT = mntHtSRem -  mntRemise;

                                if(this.rabaisGlobal == '%' && this.rabaisSelect != 0) {
                                    valrabais += mntHT * this.rabaisSelect / 100 
                                }
                                if(this.rabaisGlobal == 'MONTANT' && this.rabaisSelect != 0) {
                                    valrabais = this.rabaisSelect 
                                }
                                valretenu = 0
                                if(this.retenuSelect != 0 && this.retenuGlobal == 'OUI') {
                                    valretenu =  totalHT * this.retenuSelect /100
                                }
                                        
                              totalRemise += mntRemise;                                
                              totalHT += mntHT
                              totalTVA += Math.round((mntHT) * (itemTva  / 100))
                              tot = (mntHT) + Math.round((mntHT) * (itemTva  / 100))
                              totHT = Math.round((mntHT))
                              
                              mntTotal += totHT;
                              totalRemise += mntRemise;
                              this.optionCommande[prop].total = totHT;
                              this.optionCommande[prop].prix = itemPrix;
                              this.optionCommande[prop].unite = item.unite;                        
                              this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise)
                              this.totalRabais = new Intl.NumberFormat('fr-Fr').format(valrabais)
                              this.totalRABAISTTC = Math.round(valrabais)
                              this.totalRetenu = new Intl.NumberFormat('fr-Fr').format(valretenu)
                              this.totalRETENU = Math.round(valretenu)
                              console.log('valretenuff',valretenu)
                              this.totalComHT = new Intl.NumberFormat("fr-FR").format(totalHT);
                              this.totalComTVA = new Intl.NumberFormat("fr-FR").format(totalTVA);
                              this.totComLigneTTCFormat =  new Intl.NumberFormat("fr-FR").format(mntTotal - valretenu + totalTVA - valrabais);
                              this.totalComTTC = (mntTotal-valretenu) - valrabais + totalTVA;
                              this.loading = false
                            }
                        } // if selectContrat
                        else {
                            // let itemPrix = parseInt(item.prix,10);
                            // let itemQte = parseInt(item.qte,10);
                            // let itemTva = parseInt(item.tva,10);
                            // let itemRemise = parseInt(item.remise,10);

                            let itemPrix = item.prix;
                            let itemQte = item.qte;
                            // let itemTva = item.tva;
                            // let itemRemise =item.remise;
                            let itemTva =  this.tvaSelect != 0 ? this.tvaSelect : item.tva;
                            let itemRemise = this.remiseSelect != 0 ? this.remiseSelect : item.remise;
                            let mntHtSRem = itemPrix * itemQte;
                            let mntRemise = (itemRemise > 0) ? (mntHtSRem * itemRemise ) /100 : 0;
                            let mntHT = mntHtSRem -  mntRemise;
                            totalRemise += mntRemise;
                            totalHT += mntHT
                            totalTVA += Math.round((mntHT) * (itemTva  / 100))
                            tot = (mntHT) + Math.round((mntHT) * (itemTva  / 100))
                            totHT = Math.round((mntHT))
                            // mntTotal += tot;
                            valretenu = 0
                            if(this.retenuSelect != 0 && this.retenuGlobal == 'OUI') {
                                    valretenu =  totalHT * this.retenuSelect /100
                                }
                            mntTotal += totHT;
                            this.optionCommande[prop].total = totHT;
                            this.optionCommande[prop].prix = itemPrix;
                            this.optionCommande[prop].unite = item.unite;
                            this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise)
                            this.totalRabais = new Intl.NumberFormat('fr-Fr').format(valrabais)
                            this.totalRABAISTTC = Math.round(valrabais)
                            this.totalRETENU = Math.round(valretenu)
                            console.log('valretenu',valretenu)
                            this.totalRetenu = new Intl.NumberFormat('fr-Fr').format(valretenu)
                            this.totalComHT = new Intl.NumberFormat("fr-FR").format(totalHT);
                            this.totalComTVA = new Intl.NumberFormat("fr-FR").format(totalTVA);
                            this.totComLigneTTCFormat =  new Intl.NumberFormat("fr-FR").format( mntTotal-valretenu + totalTVA - valrabais);
                            this.totalComTTC = mntTotal - valretenu  + totalTVA - valrabais;
                            this.loading = false
                        }
                    } else {
                        this.loading = false
                        this.$message.error('Veuillez sélectionner une ressource')
                    }

                    this.totComLigneTTC += tot
                }
                this.loading = false
                this.totalRabais = new Intl.NumberFormat('fr-Fr').format(valrabais)             
            
                let totalRetenu =  this.retenuSelect > 0 && this.retenuGlobal != 'NON' ? (totalHT * this.retenuSelect / 100 )  : 0
               
                this.totalRABAISTTC = Math.round(valrabais)
                this.totalComRetenu = new Intl.NumberFormat('fr-Fr').format(totalRetenu)
                this.totalRETENU = Math.round(totalRetenu)
                this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise)
                this.totalComHT = new Intl.NumberFormat('fr-Fr').format(totalHT)
                this.totalComTVA = new Intl.NumberFormat('fr-Fr').format(totalTVA)
                this.totComLigneTTCFormat = new Intl.NumberFormat('fr-Fr').format(this.totComLigneTTC - valrabais - totalRetenu)
            },
            deleteFourn () {
                this.loading = true;
                let url = this.domaine + 'fournisseur/' + this.idFourn + '/delete'
                this.$http.get(url).then(response => {
                    this.loading = false;
                    if (response.body)
                    {
                        this.dialogSupr = false

                        this.loadFournLimit()

                        this.loadPage()

                        if(response.body.code == 2){
                            this.$alert(response.body.message, 'Suppression',
                                {
                                    confirmButtonText: 'OK',
                                });
                        }else{
                            this.$notify({
                                title: 'SUPPRESSION',
                                message: response.body.message,
                                type: 'success',
                                duration: 5000,
                                position: 'top-center'
                            })
                        }


                    }
                })
            },
            deleteCommande () {
                let url = this.domaine + 'fournisseur/' + this.idComm + '/delete/commande'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.$notify({
                            title: 'SUPPRESSION',
                            message: 'Commande supprimé avec succès.',
                            type: 'success',
                            position: 'top-center'
                        })
                        this.dialogSuprComm = false
                        this.loadFournLimit(this.fournCourant)
                        this.loadCommandeRecent(this.fourSelect.id)
                        this.loadPage()
                    }
                })
            },
            imprimerFacture (ligne) {
                this.factureCourant = ligne
                this.dialogImprFacture = true
            },
            imprimerFuCom(ligne) {
                this.dialogImprFusionCom = true
            },
            imprimerModeFacture(mode){
                this.dialogImprFacture = false
                let url = this.domaine + 'fournisseur/' + this.factureCourant.idFact + '/'+ this.user.id +'/imprimer/facture/'+mode
                this.$http.get(url).then(response => {
                    if (response.body) {
                    }
                })
                window.open(url)
            },
            imprimerCommande (ligne) {
              this.dialogImprCommande = true
              this.commCourant = ligne
            },
            imprimerModeCommande(mode){
               let url = this.domaine + 'fournisseur/' + this.commCourant.id + '/imprimer/commande/'+this.user.id+'/'+mode
                this.$http.get(url).then(response => {
                    if (response.body) {
                    }
                })
                this.dialogImprCommande = false
                window.open(url)
            },
            imprimerLivraison (ligne) {
                this.livraisonCourant = ligne
                this.dialogImprLivraison = true
            },
            imprimerModeLivraison(mode){
              this.dialogImprLivraison = false
              let url = this.domaine + 'fournisseur/' + this.livraisonCourant.id + '/imprimer/livraison/'+this.user.id+'/'+mode
                this.$http.get(url).then(response => {
                    if (response.body) {
                    }
                })
                window.open(url)
            },
            imprimeListeHisFourCmde (type) {
                let idFour = this.fournCourant.id
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"fournisseur/imprimerPDF/historique/"+idFour+"/commande/liste"
                }else {
                    url = this.domaine+"fournisseur/imprimerEXC/historique/"+idFour+"/commande/liste"
                }
                window.open(url)
            },
            imprimeListeHisContra (type) {
                let idFour = this.fournCourant.id
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"fournisseur/imprimerPDF/liste"
                }else {
                    url = this.domaine+"fournisseur/imprimerEXC/historique"
                }
                window.open(url)
            },
            imprimeListeHisFourFacture (type) {
                let idFour = this.fournCourant.id
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"fournisseur/imprimerPDF/historique/"+idFour+"/facture/liste"
                }else {
                    url = this.domaine+"fournisseur/imprimerEXC/historique/"+idFour+"/facture/liste"
                }
                window.open(url)
            },
            imprimeListeHisFourLivraison (type) {
                let idFour = this.fournCourant.id
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"fournisseur/imprimerPDF/historique/"+idFour+"/livraison/liste"
                }else {
                    url = this.domaine+"fournisseur/imprimerEXC/historique/"+idFour+"/livraison/liste"
                }
                window.open(url)
            },
            imprimeListeHisFourMaintenance (type) {
                let idFour = this.fournCourant.id
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"fournisseur/imprimerPDF/historique/"+idFour+"/maintenance/liste"
                }else {
                    url = this.domaine+"fournisseur/imprimerEXC/historique/"+idFour+"/maintenance/liste"
                }
                window.open(url)
            },
            imprimeListeHisFournisseur (type) {
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"fournisseur/imprimerPDF/historique/fournisseur/liste"
                }else {
                    url = this.domaine+"fournisseur/imprimerEXC/historique/fournisseur/liste"
                }
                window.open(url)
            },
            morale () {
                this.personneType = true
                //this.dialogAjout = true
            },
            physique () {
                this.personneType = false
                //this.dialogAjout = true
            },
            querySearch(queryString, cb) {
                var links = this.listKeyword;
                var results = queryString ? links.filter(this.createFilter(queryString)) : links;
                // call callback function to return suggestions
                cb(results);
            },
            createFilter(queryString) {
                return (link) => {
                    return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            removeOptionComm (item) {
                var index = this.optionCommande.indexOf(item)
                this.listSupp.push(item.id)

                //Montant total

                // let prixOpt = parseInt(item.prix);
                // let qteOpt = parseFloat(item.qte);
                // let tvaOpt = parseFloat(item.tva);
                // let remiseOpt = parseFloat(item.remise);

                let prixOpt = item.prix;
                let qteOpt = item.qte;
                let tvaOpt = item.tva;
                let remiseOpt = item.remise;
                let totalRemise = 0
                let totalHT = 0

                 let mntHtSRem = prixOpt * qteOpt;
                // CEKI ETAI LA
                let mntRemise = (remiseOpt > 0) ? (mntHtSRem * remiseOpt ) /100 : 0;
                let mntHTC = mntHtSRem -  mntRemise;

                totalRemise += mntRemise;

                totalHT += mntHTC;

                let mntHT =  parseFloat( prixOpt * qteOpt);
                // let mntTva = parseFloat(Math.round((prixOpt * qteOpt) * (tvaOpt / 100) )   )
                let mntTva = parseFloat(Math.round((mntHTC) * (tvaOpt / 100) )   )
                // let mntTTC = mntHT + mntTva
                let mntTTC = mntHTC + mntTva

                // this.optionCommande[index].total = mntHTC



                this.totTTC -= this.optionCommande[index].total
                if (index !== -1) {
                    this.optionCommande.splice(index, 1)
                }
            },
            demandeDevisPlus () {
                this.optionDevis.push({
                    key: Date.now(),
                    libelle: '',
                    cout: 0,
                    qte: 1,
                    tva:0,
                    total:0,
                    id: ''
                })
                this.totComLigneTTC += 5
            },
            calculTotalDevis(){
                this.loading = true
                let total = 0
                let tvaG = 0
                let ht = 0
                this.optionDevis.forEach(function(item){
                    let t = 0
                    let c = 0
                    let tva = 0
                    if (item.produit != '') {
                        let idProd = "";
                        if(item.id != null && item.id != "" ){
                            idProd = item.id;
                        }
                        else if(item.produit != null && item.produit != "" ){
                            idProd = item.produit;
                        }
                        else{
                            return;
                        }
                        let url = this.domaine + 'fournisseur/info/produit/'+idProd
                        var data = new FormData()
                        data.append('fournisseur', this.fourSelect.id)
                        this.$http.post(url, data).then(response => {
                                if (response.body) {
                                    this.infoProduit = response.body
                                    item.cout = this.infoProduit.prixAchat
                                    c = parseInt(item.cout) * parseInt(item.qte)
                                    tva = c * (parseInt(item.tva)/100)
                                    t = c + tva
                                    item.total = t
                                    total += t
                                    tvaG += tva
                                    ht += c
                                    this.loading = false
                                }
                            },
                            response => {
                                this.loading = false
                            })
                    } else {
                        this.loading = false
                        this.$message.error('Veuillez sélectionner une ressource')
                    }

                    c = parseInt(item.cout) * parseInt(item.qte)
                    tva = c * (parseInt(item.tva)/100)
                    t = c + tva
                    item.total = t
                    total += t
                    tvaG += tva
                    ht += c
                });

                this.devisTotal = new Intl.NumberFormat('fr-Fr').format(total)
                this.devisTva = new Intl.NumberFormat('fr-Fr').format(tvaG)
                this.devisHt = new Intl.NumberFormat('fr-Fr').format(ht)
            },
            suppressionDevis(index){
                var item = this.optionDevis.indexOf(index)
                this.optionDevis.splice(item, 1)
                this.calculTotalDevis()
            },
            clear () {
                this.$refs.form.reset()
                this.dialogComm = false
            },
            onFileImage1Picked(event){
                const files = event.target.files
                let filename = files[0].name
                this.nameFile = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }
                if( files[0].size > 10485760 ){
                    this.$message.error("La taille du fichier est supérieur à 10 Mo");
                    return;
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image1 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file1 = files[0]
            },
            onFileImage2Picked(event){
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0)
                {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.image2 = fileReader.result
                })

                fileReader.readAsDataURL(files[0])
                this.file2 = files[0]
            },
            imprimeListTarif (type) {
                // let listLivraison = this.listProduit
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"fournisseur/imprimerPDF/historique/"+this.fournCourant.id+"/tarification"
                }else {
                    url = this.domaine+"fournisseur/imprimerEXC/historique/"+this.fournCourant.id+"/tarification"
                }
                window.open(url)
            },
            showDialogComparaison(item){
                this.loading = true
                this.commandeInit = item
                let totalCmdInit = 0;
                this.commandeInit.option.forEach(function (value, i) {
                    totalCmdInit   = totalCmdInit+value.total
                });
                this.totCommandeInit =  totalCmdInit
                let url = this.domaine + 'comparateur/commande/'+ item.id
                this.$http.get(url).then(response => {
                    this.loading = false
                    if (response.body.listeProdCom.length > 0) {
                        this.commandeDeriv = response.body.fournisseurs
                        this.totalBenefice = response.body.beneficeTotal
                        this.listeProdNull = response.body.listeProdNull;
                        this.dialogComparaison = true
                    }else{
                        this.dialogProdNull = true
                    }

                    if(response.body.listeProdCom.length == 0 && response.body.listeProdNull.length == 0  ){
                        this.$message.error("Aucune ressource de cette commande n'a été trouvé lors de la recherche ")
                    }
                    // if(response.body.listeProdNull.length > 0 ) {
                    //     this.listeProdNull = response.body.listeProdNull;
                    //     this.dialogProdNull = true
                    // }
                })
                this.loading = false
            },
            attribuerFour(){
                for(let index in this.listeProdNull){
                    let item =this.listeProdNull[index];
                    if(item.fournisseur == undefined || item.prixU == undefined ||  item.prixU == 0){
                        this.$message.error('Veuillez selectionner un fournisseur et un montant supérieur à zéro pour chaque ressource');
                        return
                    }
                }
                let url = this.domaine + 'fournisseur/new/tarif/listproduit'

                let listProdFour = []
                for(let index in this.listeProdNull)
                {
                    let item = {
                        produit: this.listeProdNull[index].idProduit,
                        prixAchat: this.listeProdNull[index].prixU,
                        fournisseur: this.listeProdNull[index].fournisseur
                    };
                    listProdFour.push(item);
                }
                let data = new FormData();
                data.append("listeProdFour",JSON.stringify(listProdFour)  );
                data.append('idUser', this.user.id)

                this.$http.post(url,data).then(response => {
                        this.$notify({
                            title: 'Success',
                            message: response.body.message,
                            type: 'success'
                        });
                        this.dialogProdNull = false
                        this.showDialogComparaison(this.commandeInit)
                    },
                    response => {
                        this.$message.error("Une erreur s'est produite lors de l'enregistrement du montant de  la ressource ")
                        this.loading = false
                    })
            },
            loadMetier() {
                let url = this.domaine + "chantier/index";
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.comboMetier = response.body.metier;
                    }
                });
            },

            validCmdDerivees(listPropos){

                // this.loading = true
                var formdata = new FormData()
                formdata.append('commandes', JSON.stringify(listPropos))
                formdata.append('commandeInit', this.commandeInit.id)
                formdata.append('idUser', this.user.id)
                formdata.append('benefTotal', 9000)



                let url = this.domaine + 'comparateur/commande/create'
                this.$http.post(url, formdata ).then(response => {
                    this.loading = false
                    this.dialogComparaison =false;
                    if (response.body) {
                      this.validCommd = false
                        let verif = response.body
                        this.$notify({
                            title: 'VALIDATION REUSSIE',
                            message: 'Les commandes ont été génerées.',
                            type: 'success',
                            position: 'top-center',
                            duration: 5000
                        })
                        this.loadCommandeRecent(this.fourSelect.id)

                    }else {
                        this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                        this.loading = false
                        this.dialogAppro = false
                    }
                });

            },

            //DETAIL CONTRAT
            showDetailContrat(idContrat){
                this.loading = true
                let url = this.domaine + 'contrat/prestataire/show/'+idContrat;
                this.$http.get(url).then( resp=>{
                    this.detailContrat = resp.body.contrat
                    this.dialogInfoContrat = true;
                    this.loading = false
                }, error =>{
                    this.$message.error("Echec lors Chargement detail contrat, verifiez votre connexion");
                    this.loading = false
                } )
            },

            getSommeFact(param) {
                const {columns, data} = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = "Total";
                        return;
                    }

                    if (index === 3  ) {
                        sums[index] = "N/A";
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = new Intl.NumberFormat().format(
                            values.reduce((prev, curr) => {
                                const value = Number(curr);
                                if (!isNaN(value)) {
                                    return prev + curr;
                                } else {
                                    return prev;
                                }
                            }, 0)
                        );
                    } else {
                        sums[index] = "N/A";
                    }
                });

                return sums;
            },
            headerRowStyle({row, rowIndex}) {
                return {"color":"black"};
            },
        },

        beforeMount: function () {

            if(!this.roleAcces[this.$router.history.current.name]){
                this.$router.push({ name: 'Home' })
            }


        }
    };
</script>

<style>
    .list__tile__title {
        height: 220px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Fournisseur.vue